// src/pages/health/data/workoutVideos.js



import weightMachineVideos from "./weightMachineVideos.json";

export const VIDEOS_BY_ITEM = {
    machine: weightMachineVideos,
    "trx": [
        {
            "id": "TRX/TRX-0001",
            "title": "TRX Chest",
            "thumb": "/assets/thumbs/TRX-0001.png",
            "guide": [
                "TRX축을 등지고 서서 양 팔을 가슴 앞으로 뻗어 손잡이를 잡는다.",
                "몸 전체를 앞으로 기울여 머리부터 발까지 사선 형태를 만들어 팔에 체중을 싣는다.",
                "팔꿈치를 굽히면서 몸을 아래로 내렸다 원위치로 돌아온다.",
                "10~15회 2~3세트 반복한다.",
                "※ 초기에는 TRX길이를 짧게 하여(몸이 가볍게 기운 상태) 낮은 강도로 운동하고, 근력에 따라 길이를 늘린다."
            ]
        },
        {
            "id": "TRX/TRX-0002",
            "title": "TRX Biceps curl",
            "thumb": "/assets/thumbs/TRX-0002.png",
            "guide": [
                "TRX 손잡이를 가슴 앞으로 잡아 팔을 뻗는다.",
                "몸 전체를 뒤로 기울여 머리부터 발까지 사선 형태를 만들어 팔에 체중을 싣는다.",
                "팔꿈치를 굽히며 몸을 끌어 올렸다 원위치로 돌아온다.",
                "10~15회 2~3세트 반복한다.",
                "※ 초기에는 TRX길이를 짧게 하여(몸이 가볍게 기운 상태) 낮은 강도로 운동하고, 근력에 따라 길이를 늘린다."
            ]
        },
        {
            "id": "TRX/TRX-0003",
            "title": "TRX Triceps",
            "thumb": "/assets/thumbs/TRX-0003.png",
            "guide": [
                "팔꿈치를 굽혀서 수직으로 들어 올려 TRX를 뒤에서 잡는다.",
                "몸 전체를 앞으로 기울여 머리부터 발까지 사선형태를 만들어 팔에 체중을 싣는다.",
                "팔꿈치를 펴 팔을 머리 위로 뻗으면서 몸을 들어 올린다.",
                "10~15회 2~3세트 반복한다.",
                "※ 초기에는 TRX길이를 짧게 하여(몸이 가볍게 기운 상태) 낮은 강도로 운동하고, 근력에 따라 길이를 늘린다."
            ]
        },
        {
            "id": "TRX/TRX-0004",
            "title": "TRX Row",
            "thumb": "/assets/thumbs/TRX-0004.png",
            "guide": [
                "팔을 가슴앞으로 뻗어 TRX 손잡이를 잡고 몸 전체를 뒤로 기울여 머리부터 발까지 사선형태를 만든다.",
                "팔을 몸 옆에 붙여 팔꿈치를 굽히면서 몸을 끌어 올렸다 원위치로 돌아온다.",
                "10~15회 2~3세트 반복한다.",
                "※ 초기에는 TRX길이를 짧게 하여(몸이 가볍게 기운 상태) 낮은 강도로 운동하고, 근력에 따라 길이를 늘린다."
            ]
        },
        {
            "id": "TRX/TRX-0005",
            "title": "TRX Hip hinge",
            "thumb": "/assets/thumbs/TRX-0005.png",
            "guide": [
                "양 팔을 가슴앞으로 뻗어 TRX 손잡이를 잡고 가볍게 누른다.",
                "무릎을 살짝 굽히고 고관절을 굴곡시켜 상체를 앞으로 숙이면서 TRX를 앞으로 밀어낸다.",
                "이 때 허리는 일직선을 유지한다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "TRX/TRX-0006",
            "title": "TRX Torso Stretch",
            "thumb": "/assets/thumbs/TRX-0006.png",
            "guide": [
                "양 손으로 TRX를 옆으로 잡고 서서 바깥쪽 다리를 뒤로 보내 교차시킨다.",
                "팔을 뻗으며 힙을 뒤로 빼면서 상체를 숙여 5~10초 유지한다.",
                "10~15회 반복 후 반대쪽으로 실시한다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "TRX/TRX-0007",
            "title": "TRX Half kneeling roll out",
            "thumb": "/assets/thumbs/TRX-0007.png",
            "guide": [
                "무릎을 90°로 굽혀 TRX를 등지고 앉아 한 발을 앞으로 보내고, 팔을 뻗어 TRX를 살짝 눌러 잡는다.",
                "상체를 오른쪽으로 틀어 팔과 함께 앞으로 밀어냈다 돌아온다.",
                "같은 방법으로 왼쪽방향으로 실시한다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "TRX/TRX-0009",
            "title": "TRX Forward Lunge",
            "thumb": "/assets/thumbs/TRX-0009.png",
            "guide": [
                "TRX를 등지고 서서 두 손으로 손잡이를 잡는다.",
                "한 쪽 다리를 앞으로 충분히 보내 무릎을 굽히면서(런지) 한 팔은 위로, 다른 팔은 옆으로 뻗는다.",
                "시작자세로 돌아와 팔다리를 바꿔 같은 방법으로 실시한다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "TRX/TRX-0008",
            "title": "TRX Cossack stretch",
            "thumb": "/assets/thumbs/TRX-0008.png",
            "guide": [
                "다리를 넓게 벌리고 서서 양손으로 손잡이를 잡는다.",
                "한 쪽 무릎을 굽혀 체중을 이동시켜 수직으로 앉으면서 동시에 반대쪽 다리는 옆으로 뻗는다.(사이드 런지)",
                "처음자세로 돌아와 반대방향으로 실시한다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "TRX/TRX-0010",
            "title": "TRX Table top row hang tight",
            "thumb": "/assets/thumbs/TRX-0010.png",
            "guide": [
                "팔을 가슴앞으로 뻗어 TRX를 잡고 무릎을 90°로 굽혀 머리부터 무릎까지 일직선이 되게 눕는다.",
                "팔꿈치를 굽혀 상체를 끌어 올렸다 원위치로 돌아온다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "TRX/TRX-0011",
            "title": "TRX Squat",
            "thumb": "/assets/thumbs/TRX-0011.png",
            "guide": [
                "팔꿈치를 굽혀 가슴앞에서 TRX를 잡고 선다.",
                "팔을 펴고 무릎을 90°로 굽혀 대퇴부가 바닥과 수평이 되도록 앉았다 일어선다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "TRX/TRX-0012",
            "title": "TRX Reverse Lunge",
            "thumb": "/assets/thumbs/TRX-0012.png",
            "guide": [
                "팔꿈치를 굽혀 가슴앞에서 TRX를 잡고 선다.",
                "팔을 펴고 한 발을 뒤로 보내고 무릎을 굽혀 앉았다 일어선다.",
                "같은 방법으로 반대쪽 다리를 뒤로 보내 실시한다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "TRX/TRX-0013",
            "title": "TRX Lunge squat",
            "thumb": "/assets/thumbs/TRX-0013.png",
            "guide": [
                "한 발을 뒤로 보내 발등을 TRX 풋크래들에 걸어 정강이가 바닥과 수평이 되도록 한다.",
                "풋크래들에 건 다리를 뒤로 밀어내면서 앞쪽 다리의 무릎을 굽히고 앉았다 원위치로 돌아온다.",
                "10~15회 반복 후 발을 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "TRX/TRX-0014",
            "title": "TRX Piriformis stretch",
            "thumb": "/assets/thumbs/TRX-0014.png",
            "guide": [
                "팔을 가슴앞으로 뻗어 TRX 손잡이를 잡고 선다.",
                "한 쪽 다리를 굽혀 발목을 반대쪽 다리 대퇴부에 올린다.",
                "바닥을 지지한 다리의 무릎을 굽혀 앉았다 일어선다.",
                "10 ~15회 반복 후 다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "TRX/TRX-0015",
            "title": "TRX Plank",
            "thumb": "/assets/thumbs/TRX-0015.png",
            "guide": [
                "양팔을 90°로 굽혀 팔꿈치를 TRX 풋크래들에 걸고 엎드린다.",
                "다리를 뒤로 뻗어 머리부터 발까지 사선형태를 만들어 30초부터 근력에 따라 3분 이상 자세를 유지한다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "TRX/TRX-0016",
            "title": "Plank single arm raise feet on TRX",
            "thumb": "/assets/thumbs/TRX-0016.png",
            "guide": [
                "양팔을 어깨와 수직으로 뻗어 바닥을 짚고 엎드려서 양쪽 다리를 펴 발등을 TRX 풋크래들에 건다.",
                "한 팔을 앞으로 뻗어 귀높이로 올리고 5~10초간 균형을 유지한다.",
                "10~15회 반복 후 팔을 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "TRX/TRX-0017",
            "title": "Plank up down feet on TRX",
            "thumb": "/assets/thumbs/TRX-0017.png",
            "guide": [
                "양팔을 어깨와 수직으로 뻗어 바닥을 짚고 엎드려서 다리를 펴 발등을 TRX 풋크래들에 건다.",
                "한 쪽 팔을 90°로 굽혀 팔꿈치로 바닥을 짚은 후 반대쪽 팔도 굽혀 플랭크자세를 만든다.",
                "팔꿈치를 한 쪽씩 펴면서 원위치로 올라온다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "TRX/TRX-0018",
            "title": "TRX Plank with roll",
            "thumb": "/assets/thumbs/TRX-0018.png",
            "guide": [
                "무릎을 꿇고 앉아 팔을 앞으로 뻗어 TRX 손잡이를 잡는다.",
                "손잡이를 누르며 팔과 함께 몸을 앞으로 밀어냈다(허리가 꺾이지 않도록 주의) 돌아온다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "TRX/TRX-0019",
            "title": "TRX Knee tuck",
            "thumb": "/assets/thumbs/TRX-0019.png",
            "guide": [
                "푸쉬업 자세로 엎드려서 양쪽 다리를 펴 발등을 TRX 풋크래들에 건다.",
                "무릎을 굽혀 가슴쪽으로 끌어당겼다 처음위치로 돌아온다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "TRX/TRX-0020",
            "title": "TRX Knee tuck and push up",
            "thumb": "/assets/thumbs/TRX-0020.png",
            "guide": [
                "푸쉬업 자세로 엎드려서 양쪽 다리를 펴 발등을 TRX 풋크래들에 건다.",
                "무릎을 굽혀 가슴쪽으로 끌어 당겼다 다리를 편 후 팔꿈치를 굽히면서 몸을 아래로 내렸다 올라온다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "TRX/TRX-0021",
            "title": "TRX Drop Lunge",
            "thumb": "/assets/thumbs/TRX-0021.png",
            "guide": [
                "한쪽 다리를 뒤로 보내 발등을 TRX 풋크래들에 걸고 선다.",
                "바닥을 지지한 다리를 굽히면서 앉았다 점프하면서 일어선다.",
                "10~15회 반복 후 다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "TRX/TRX-0022",
            "title": "TRX Plank Pike",
            "thumb": "/assets/thumbs/TRX-0022.png",
            "guide": [
                "푸쉬업 자세로 엎드려서 양쪽 다리를 펴 발등을 TRX 풋크래들에 건다.",
                "다리를 편 채 엉덩이를 위로 끌어 올려 몸을 역 V자 형태로 만들었다 시작위치로 돌아온다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "TRX/TRX-0023",
            "title": "TRX Mountain climbing",
            "thumb": "/assets/thumbs/TRX-0023.png",
            "guide": [
                "푸쉬업 자세로 엎드려서 양 쪽 다리를 펴 발등을 TRX 풋크래들에 건다.",
                "한 쪽 다리의 무릎을 굽혀 가슴쪽으로 끌어당겼다 원위치로 돌아온 후 다리를 바꿔 같은 방법으로 실시한다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Knee-0191",
            "title": "TRX Crouch",
            "thumb": "/assets/thumbs/MS-Knee-0191.png",
            "guide": [
                "양 손으로 TRX 손잡이를 잡고 쪼그려 앉는다.",
                "자세를 유지한 채 양쪽 뒤꿈치를 들어 올렸다 내린다. 10~15회 3세트 반복한다."
            ]
        },
    ],

    "dumbbell": [
        {
            "id": "Dumbbell/Dumbbell-0018",
            "title": "덤벨플라이(Dumbbell Fly)",
            "thumb": "/assets/thumbs/Dumbbell-0018.png",
            "guide": [
                "양손에 덤벨을 들고 벤치에 누워서 팔을 가슴앞으로 뻗고 손바닥을 마주보게 한다.",
                "팔꿈치를 살짝 구부리며 팔을 옆으로 천천히 벌린다.",
                "반원을 그리며 덤벨을 가슴앞으로 모은다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0017",
            "title": "덤벨 벤치프레스(Dumbbell Bench Press)",
            "thumb": "/assets/thumbs/Dumbbell-0017.png",
            "guide": [
                "양손에 덤벨을 들고 벤치에 눕는다.",
                "숨을 내쉬면서 팔을 가슴앞으로 뻗어 올리고, 들이 마시면서 팔꿈치를 굽혀 팔을 수직으로 내린다.",
                "팔꿈치가 수직으로 움직여야 가슴근육에 효과적으로 자극을 줄 수 있다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0019",
            "title": "덤벨 싱글암 프레스(Dumbbell One Arm Press)",
            "thumb": "/assets/thumbs/Dumbbell-0019.png",
            "guide": [
                "양손에 덤벨을 들고 벤치에 눕는다.",
                "한 쪽 팔을 가슴 앞으로 뻗어올렸다가 팔꿈치를 굽혀 수직으로 내리고, 동시에 반대쪽 팔을 가슴 앞으로 뻗는다.",
                "팔을 번갈아가며 실시하고, 10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0027",
            "title": "덤벨 로우(Dumbbell Row)",
            "thumb": "/assets/thumbs/Dumbbell-0027.png",
            "guide": [
                "양 손에 덤벨을 잡고 다리를 살짝 구부려 상체를 45° 앞으로 기울이고 선다.",
                "팔은 자연스럽게 늘어뜨린 후 팔꿈치를 굽혀 덤벨을 등쪽으로 당기고 견갑골 사이를 수축시킨다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0026",
            "title": "싱글암 덤벨 로우(Single Arm Dumbbell Row)",
            "thumb": "/assets/thumbs/Dumbbell-0026.png",
            "guide": [
                "한 쪽 손과 무릎을 벤치에 올려 지지하고 다른 한 손은 덤벨을 들어 아래로 뻗는다.",
                "팔꿈치를 굽혀 상완(팔꿈치 위)이 바닥과 수평이 될때까지 덤벨을 끌어 올린다.",
                "10~15회 2~3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0028",
            "title": "덤벨 리버스 플라이(Dumbbell reverse fly)",
            "thumb": "/assets/thumbs/Dumbbell-0028.png",
            "guide": [
                "벤치에 상체를 45° 정도 기울이고 앉는다.",
                "양 손에 덤벨을 들고 팔을 자연스럽게 내린다.",
                "팔꿈치를 가볍게 구부려 양 팔을 어깨높이에 맞춰 옆으로 벌린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0030",
            "title": "덤벨 레니게이드 로우(Dumbbell Renegade Row)",
            "thumb": "/assets/thumbs/Dumbbell-0030.png",
            "guide": [
                "푸쉬업 자세로 엎드려 양 손에 덤벨을 잡는다.",
                "머리부터 발까지 사선을 유지한 채 한 쪽 팔꿈치를 90°로 굽혀 덤벨을 등쪽으로 끌어 올린다.",
                "팔을 교대로 실시하고, 10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0009",
            "title": "옆으로 누워 덤벨 외회전(Dumbbell External Rotation, Lying)",
            "thumb": "/assets/thumbs/Dumbbell-0009.png",
            "guide": [
                "옆으로 누워 양쪽 팔꿈치를 90°로 굽혀서 안쪽 팔로 바닥을 짚고 바깥쪽 팔은 몸옆에 붙여 덤벨을 잡는다.",
                "덤벨을 든 팔을 몸에 붙인 채 어깨를 외회전 한다.",
                "10~15회 반복하고 반대쪽으로 실시한다. 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0010",
            "title": "덤벨 숄더 프레스(Dumbbell Shoulder press)",
            "thumb": "/assets/thumbs/Dumbbell-0010.png",
            "guide": [
                "양 손에 덤벨을 들고 팔을 어깨높이에 맞춰 옆으로 들어올려 팔꿈치를 90°로 굽힌다.",
                "팔을 머리 위로 뻗어 올렸다 팔꿈치를 굽혀 어깨높이까지 내려온다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0004",
            "title": "덤벨 바이셉 컬 & 오버헤드 프레스(Dumbbell Biceps curl & overhead press)",
            "thumb": "/assets/thumbs/Dumbbell-0004.png",
            "guide": [
                "양 손에 덤벨을 잡고 선다.",
                "어깨를 외회전하면서(손바닥이 몸쪽을 향하게) 팔꿈치를 굽혀 덤벨을 가슴앞으로 들어 올린다.",
                "어깨를 내회전하면서(손바닥이 밖을 향하게) 팔을 뻗어 덤벨을 머리 위로 들어 올린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0005",
            "title": "덤벨 싱글 암 오버헤드 프레스 얼터너티브(Dumbbell Single Arm overhead press)",
            "thumb": "/assets/thumbs/Dumbbell-0005.png",
            "guide": [
                "양 손에 덤벨을 들고 팔꿈치를 굽혀 어깨높이로 올린다.",
                "한 쪽 팔을 뻗어 덤벨을 머리 위로 들어올렸다 내린 후 반대쪽 팔을 위로 뻗는다.",
                "양쪽 팔을 교대로 실시하고, 10~15회 2~3세트 반복한다."
            ]
        },

        {
            "id": "Dumbbell/Dumbbell-0016",
            "title": "덤벨 스캡션(Scaption)",
            "thumb": "/assets/thumbs/Dumbbell-0016.png",
            "guide": [
                "양 손에 덤벨을 들고 어깨를 가볍게 외회전 시킨다.",
                "팔을 벌려(양 팔의 각도 약 120°) 손을 이마높이까지 들어 올린 후 견갑골 사이를 수축시켰다 푼다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0006",
            "title": "프론트 덤벨 레이즈(Front Dumbbell Raise)",
            "thumb": "/assets/thumbs/Dumbbell-0006.png",
            "guide": [
                "양 손에 덤벨을 들고 손바닥이 뒤쪽을 향하도록 하여 덤벨을 허벅지(대퇴부) 앞에 둔다.",
                "팔을 앞으로 뻗어 어깨높이까지 들어 올렸다 내린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0011",
            "title": "덤벨 쿠반 프레스(Dumbbell Cuban Press)",
            "thumb": "/assets/thumbs/Dumbbell-0011.png",
            "guide": [
                "양 손에 덤벨을 들고 선다.",
                "팔꿈치를 90°로 굽혀 어깨높이로 들어 올려 어깨를 외회전 시킨다.",
                "어깨를 내회전 시키고 팔을 내려 시작자세로 돌아온다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0014",
            "title": "덤벨 숄더 레더럴 레이즈(Shoulder Abduction, Lateral raise)",
            "thumb": "/assets/thumbs/Dumbbell-0014.png",
            "guide": [
                "양 손에 덤벨을 들고 선다.",
                "팔을 펴서(또는 약간 굽혀서) 옆으로 들어 어깨높이까지 올렸다(외전) 내린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0013",
            "title": "덤벨 숄더 PNF 패턴 운동(Shoulder PNF D2)",
            "thumb": "/assets/thumbs/Dumbbell-0013.png",
            "guide": [
                "한 손에 덤벨을 들고 어깨를 내회전하여 팔을 45° 안쪽으로 뻗는다.(내전)",
                "팔꿈치를 편 채 어깨를 외회전하여 팔을 머리 위 대각선 방향으로 들어 올렸다(외전) 어깨를 내회전하면서 팔을 내려 시작자세로 돌아온다.",
                "10~15회 반복 후 팔을 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0045",
            "title": "싱글암 덤벨 클린(Single Arm Dumbbell Clean)",
            "thumb": "/assets/thumbs/Dumbbell-0045.png",
            "guide": [
                "한 팔을 달 사이로 내려 덤벨을 잡고, 무릎을 굽혀 앉는다.",
                "무릎을 펴 일어나면서 팔꿈치를 굽혀 덤벨을 어깨높이로 들어 올린 후 다시 팔을 펴서 머리 위로 올린다.",
                "10~15회 반복 후대쪽도 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0031",
            "title": "덤벨 겟업(Dumbbell get up)",
            "thumb": "/assets/thumbs/Dumbbell-0031.png",
            "guide": [
                "1. 누운 자세(supine) - 바로 누워 한 팔을 가슴앞으로 뻗어 덤벨을 들고, 같은 쪽 무릎을 굽힌다.",
                "2. 앉은 자세(Tall Sit) - 앞으로 뻗은 팔을 그대로 유지한 채 바닥에 둔 팔로 지지하여 상체를 일으켜 앉는다.",
                "3. 하프닐 자세(Half-Kneel) - 골반을 들고 뻗은 다리를 뒤로 보내 무릎을 꿇는다.",
                "4. 선 자세(Standing) - 양 쪽 무릎을 펴며 일어난다.",
                "5. 역순으로 자세를 만들며(하프닐 자세, 앉은 자세, 누운 자세) 시작 위치로 돌아온다.",
                "6. 10~15회 반복 후 반대쪽으로 실시하고, 2~3세트 수행한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0001",
            "title": "덤벨 컬(Dumbbell curl)",
            "thumb": "/assets/thumbs/Dumbbell-0001.png",
            "guide": [
                "손바닥이 앞을 향하게 하여 양 손에 덤벨을 들고 선다.",
                "팔꿈치를 굽혀 덤벨을 가슴까지 들어 올린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0020",
            "title": "덤벨 컨센트레이션 컬(Concentration curl)",
            "thumb": "/assets/thumbs/Dumbbell-0020.png",
            "guide": [
                "다리를 어깨넓이 보다 넓게 벌려 벤치에 앚는다.",
                "한 손에 덤벨을 들고 상체를 숙여 팔꿈치를 무릎 안 쪽에 고정한다.",
                "팔꿈치를 굽혀 덤벨을 들어 올린다.",
                "10~15회 반복하고, 팔을 바꿔 실시한다. 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0002",
            "title": "덤벨 해머 컬(Dumbbell Hammer curl)",
            "thumb": "/assets/thumbs/Dumbbell-0002.png",
            "guide": [
                "손바닥을 마주 보게 하여(중립상태) 덤벨을 든다.",
                "팔꿈치를 굽혀 덤벨을 가슴쪽으로 들어 올린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0021",
            "title": "덤벨 드래그 컬(Dumbbell drag curl)",
            "thumb": "/assets/thumbs/Dumbbell-0021.png",
            "guide": [
                "손바닥이 위로 향하게 하여 양 손으로 덤벨을 든다. 팔꿈치를 굽히며 덤벨을 등쪽으로 끌어 당긴다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0008",
            "title": "덤벨 트라이셉 킥백(Dumbbell Triceps kick back)",
            "thumb": "/assets/thumbs/Dumbbell-0008.png",
            "guide": [
                "무릎을 가볍게 굽히고 상체를 45°정도 앞으로 숙이고 선다.",
                "양 손에 덤벨을 들고 팔꿈치를 굽혀 몸에 붙인 후 상완(위 팔)을 고정한 채 팔꿈치를 편다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0003",
            "title": "덤벨 오버헤드 트라이셉 익스텐션(Dumbbell Overhead Triceps extension)",
            "thumb": "/assets/thumbs/Dumbbell-0003.png",
            "guide": [
                "두손으로 덤벨을 잡고 팔꿈치를 굽혀 수직으로 들어 올린다.",
                "상완(위 팔)을 고정한 채 팔꿈치를 펴 덤벨을 위로 들어 올린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0024",
            "title": "덤벨 굴곡/신전(Dumbbell flexion/extension)",
            "thumb": "/assets/thumbs/Dumbbell-0024.png",
            "guide": [
                "손바닥을 마주보게 하여 양손에 덤벨을 잡고 벤치(또는 테이블) 가장자리에 전완(팔꿈치 아래)을 고정한다.",
                "손목에 힘을 풀어 덤벨을 천천히 내렸다(척골측위) 손목을 위쪽으로 굽혀(요골측위) 덤벨을 들어 올린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0023",
            "title": "덤벨 리스트컬(Dumbbell wrist curl)",
            "thumb": "/assets/thumbs/Dumbbell-0023.png",
            "guide": [
                "손바닥이 위를 향하게 하여 양손에 덤벨을 잡고 벤치(또는 테이블) 가장자리에 전완(팔꿈치 아래)을 고정한다.",
                "손목과 손가락의 힘을 풀어 덤벨을 가볍게 늘어뜨린다.(손목 신전)",
                "주먹을 쥐듯 덤벨을 손바닥으로 감싸며 손목을 위로 끌어 올린다.(손목 굴곡)",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0025",
            "title": "덤벨 회외/회내(Forearm supination/pronation)",
            "thumb": "/assets/thumbs/Dumbbell-0025.png",
            "guide": [
                "엄지손가락이 위로 향하게 하여 덤벨을 들고 벤치나 테이블에 전완(아래팔)을 고정한다.",
                "손바닥이 위로 향하도록 손목을 밖으로 돌린다.(회외)",
                "다시 손바닥이 아래로 향하도록 손목을 안으로 돌린다.(회내)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0032",
            "title": "앉아 러시안 트위스트(Russian Twist, sitting)",
            "thumb": "/assets/thumbs/Dumbbell-0032.png",
            "guide": [
                "무릎을 굽혀 발을 들고 앉는다.",
                "가슴높이에서 두 손으로 덤벨을 들고 상체를 좌우로 회전한다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0033",
            "title": "덤벨 사이드밴드(Dumbbell Sidebend)",
            "thumb": "/assets/thumbs/Dumbbell-0033.png",
            "guide": [
                "한 손에 덤벨을 잡고, 반대쪽 팔은 굽혀 손을 귀 뒤에 두고 선다.",
                "가슴을 펴고 골반을 고정한 채 덤벨을 잡은 방향으로 상체를 최대한 기울인다.(측굴)",
                "10~15회 반복 후 팔을 바꿔 실시하고, 2~3세트 수행한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0034",
            "title": "덤벨 우드 춉(Dumbbell Wood Chop)",
            "thumb": "/assets/thumbs/Dumbbell-0034.png",
            "guide": [
                "양 손으로 덤벨을 잡고 머리 위 대각선 방향으로 팔을 뻗는다.",
                "무릎을 굽히며 팔을 대각선 방향으로(무릎 바깥쪽)으로 뻗어 내린다.",
                "10~15회 반복 후 반대쪽으로 실시하고, 2~3세트 수행한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0036",
            "title": "덤벨 풀오버 크런치(Dumbbell Pullover crunch)",
            "thumb": "/assets/thumbs/Dumbbell-0036.png",
            "guide": [
                "등을 대고 누워 팔 다리를 위아래로 뻗어 두 손으로 덤벨을 잡는다.",
                "무릎을 굽혀 가슴쪽으로 최대한 끌어 당기고 동시에 상체를 무릎쪽으로 들어 올린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0037",
            "title": "덤벨 코디네이션 플라이(Coordination Fly)",
            "thumb": "/assets/thumbs/Dumbbell-0037.png",
            "guide": [
                "등을 대고 누워서 손에 덤벨을 들어 양 옆으로 벌리고 다리를 90°로 굽혀 들어 올린다.",
                "양 팔을 가슴쪽으로 모으면서 상체를 올리고 동시에 다리를 사선으로 뻗는다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0038",
            "title": "덤벨 불가리안 스플릿 스쿼트(Bulgarian split squat)",
            "thumb": "/assets/thumbs/Dumbbell-0038.png",
            "guide": [
                "양 손에 덤벨을 들고 서서 한 발을 벤치나 의자 위에 올린다.",
                "상체를 세운 상태로 무릎을 굽혀 수직으로 앉았다 일어난다.",
                "10~15회 반복 후 다리를 바꿔 실시한다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0039",
            "title": "덤벨 스모 스쿼트(Dumbbell Sumo Squat)",
            "thumb": "/assets/thumbs/Dumbbell-0039.png",
            "guide": [
                "두 손으로 덤벨을 들고 서서 다리를 어깨넓이 보다 넓게 벌리고 발을 45° 외회전시킨다.",
                "상체를 세우고 무릎을 굽히면서 수직으로 앉았다 일어난다.",
                "10~15회 반복하여 3세트 실시한다.",
                "※ 양 발의 간격 : 무릎을 굽혀 앉을 때 직각이 될 정도"
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0029",
            "title": "덤벨 벤트 레그 데드리프트(Dumbbell Bent Leg Deadlift)",
            "thumb": "/assets/thumbs/Dumbbell-0029.png",
            "guide": [
                "다리를 어깨넓이로 벌리고 서서 양 손에 덤벨을 든다.",
                "무릎을 굽히고 앉으면서 허리가 꺾이지 않게 상체를 앞으로 숙여 덤벨을 무릎 또는 정강이까지 내린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0040",
            "title": "덤벨 스텝업(Dumbbell step up)",
            "thumb": "/assets/thumbs/Dumbbell-0040.png",
            "guide": [
                "양손에 덤벨을 들고 한 발로 스텝박스에 올라 서서 반대쪽 무릎을 90°로 굽혀 가슴쪽으로 끌어 올려 2~3초 유지한다.",
                "10~15회 반복 후 반대쪽으로 실한다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0046",
            "title": "덤벨 싱글레그 루마니안 데드리프트(Single Romanian deadlift with dumbbell)",
            "thumb": "/assets/thumbs/Dumbbell-0046.png",
            "guide": [
                "양 손에 덤벨을 들고 한 발로 선다.",
                "지지한 다리의 무릎을 굽히고 반대쪽 다리를 뒤로 보내면서 상체를 내려 바닥과 수평을 만든다.(hinge joint exercise)",
                "3초간 유지하여 10~15회 반복하고, 3세트 실시한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0049",
            "title": "덤벨 싱글레그 루마니안 데드리프트 PNF 패턴(Single leg romanian deadlift PNF pattern with dumbbell)",
            "thumb": "/assets/thumbs/Dumbbell-0049.png",
            "guide": [
                "한 다리로 지지하고 서서 반대쪽 손에 덤벨을 든다.",
                "무릎을 굽히고 상체를 숙이면서 덤벨을 든 팔을 안쪽 대각선 방향으로 뻗어 내린다.",
                "무릎을 펴면서 팔을 바깥쪽 대각선 방향으로 뻗어 올린다.",
                "10~15회 반복 후 팔다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0048",
            "title": "덤벨 한발 스쿼트 터치 다운 후 오버헤드프레스(Single leg squat touchdown, curl to overhead press with dumbbell)",
            "thumb": "/assets/thumbs/Dumbbell-0048.png",
            "guide": [
                "한 발로 서서 반대쪽 손에 덤벨을 든다.",
                "무릎을 굽히고 상체를 내리면서 덤벨을 든 팔을 아래로 뻗어 내린다.",
                "시작자세로 돌아오면서 팔꿈치를 굽혔다 위로 펴 올린다.",
                "10~15회 반복 후 반대쪽으로 실시한다.",
                "2~3세트 반복한다.",
                "1. 한 손(오른쪽)에 덤벨을 들고 같은 쪽(오른쪽) 다리를 들어 올린다.",
                "2. 지지하고 있는 무릎을 굽혀 내리면서 덤벨 든 손을 바닥에 내려놓듯 팔을 아래쪽으로 뻗는다.",
                "3. 무릎을 펴 상체를 세우면서 덤벨을 어깨 위로 들어 올린다(쇼울더 프레스).",
                "4. 10~15회 반복하고 반대쪽을 실시한다.",
                "5. 2~3세트 수행한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0047",
            "title": "덤벨 한 손에 들고 팔다리 교차하여 외전운동(Alternate Arm raise & hip abduction)",
            "thumb": "/assets/thumbs/Dumbbell-0047.png",
            "guide": [
                "한 손에 덤벨을 들고 선다.",
                "덤벨을 든 팔을 옆으로 뻗어 올리고(견관절외전) 동시에 반대쪽 다리를 옆으로 뻗어 올린(고관절외전)다.",
                "10~15회 반복 후 반대쪽으로 실시한다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0051",
            "title": "덤벨 크로스오버 스텝업(Cross over step up with dumbbell)",
            "thumb": "/assets/thumbs/Dumbbell-0051.png",
            "guide": [
                "양 손에 덤벨을 들고 오른쪽 다리 옆에 스텝박스를 두고 선다.",
                "왼쪽 다리를 앞으로 교차하여 박스 위에 올리고, 오른쪽 다리도 따라 올려 박스 위에 선다.",
                "왼쪽 다리를 뒤로 교차하여 바닥에 내리고, 오른쪽 다리도 내린 후 반대방향으로 실시한다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0050",
            "title": "네발자세에서 덤벨 무릎 뒤에 두고 다리 들어올리기(Glute extension with dumbbell)",
            "thumb": "/assets/thumbs/Dumbbell-0050.png",
            "guide": [
                "네 발 기기 자세로 엎드려 한쪽 오금(무릎 뒤)에 덤벨을 올린다.",
                "무릎을 90°로 유지한 채 다리를 엉덩이 높이로 들어 올린다.(고관절 신전)",
                "10~15회 반복 후 다리를 바꿔 실시한다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0041",
            "title": "덤벨 스쿼트(Dumbbell Squat)",
            "thumb": "/assets/thumbs/Dumbbell-0041.png",
            "guide": [
                "양 손에 덤벨을 들고 서서 다리를 어깨보다 약간 넓게 벌린다.",
                "허리를 세운 채 무릎을 굽혀 대퇴부가 바닥과 수평이 될때까지 엉덩이를 수직으로 내려 앉는다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0044",
            "title": "덤벨 싱글레그 스쿼트(Single Leg Squat with dumbbell)",
            "thumb": "/assets/thumbs/Dumbbell-0044.png",
            "guide": [
                "양 손에 덤벨을 들고 한 다리로 선다.",
                "허리를 세운 채 무릎을 굽혀 대퇴부가 바닥과 수평이 될 때까지 엉덩이를 수직으로 내려 앉는다.",
                "10회 반복 후 다리를 바꿔 실시한다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0042",
            "title": "덤벨 런지(Dumbbell Lunge)",
            "thumb": "/assets/thumbs/Dumbbell-0042.png",
            "guide": [
                "양 손에 덤벨을 들고 선다.",
                "상체를 세운 채 한 발을 충분히 앞으로 내 딛고 무릎을 굽혀 수직으로 앉았다 일어선다.",
                "다리를 바꿔가며 10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0052",
            "title": "덤벨 사이드런지(Dumbbell Lunge, Side)",
            "thumb": "/assets/thumbs/Dumbbell-0052.png",
            "guide": [
                "양 손에 덤벨을 들고 다리를 넓게 벌리고 선다.",
                "한 쪽 무릎을 90°로 굽혀 체중을 실으면서 수직으로 앉았다 일어난 후 반대방향으로 실시한다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0043",
            "title": "덤벨 스쿼트 & 오버헤드 프레스(Dumbbell Squat & Overhead Press)",
            "thumb": "/assets/thumbs/Dumbbell-0043.png",
            "guide": [
                "양 손에 덤벨을 들고 서서 팔꿈치를 굽혀 손바닥이 뒤쪽을 향하게(어깨 외회전) 한다.",
                "대퇴가 바닥과 수평이 될 때까지 무릎을 굽히며 앉는다.",
                "무릎을 펴며 일어나 손바닥이 앞쪽을 향하게(어깨 내회전)하여 머리 위로 뻗어 올린다.(오버헤드 프레스)",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0054",
            "title": "덤벨들고 종아리들기(Calf raise with dumbbell)",
            "thumb": "/assets/thumbs/Dumbbell-0054.png",
            "guide": [
                "무릎을 90°로 굽혀 의자에 앉아 두 발을 스텝박스의 가장자리에 올린다.",
                "무릎 위에 덤벨을 올려 손으로 잡는다.",
                "덤벨의 무게저항을 느끼면서 뒤꿈치를 들어 올렸다 내린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0053",
            "title": "덤벨들고 한 발 종아리 들기(Standing calf raise)",
            "thumb": "/assets/thumbs/Dumbbell-0053.png",
            "guide": [
                "한 손에 덤벨을 들고 같은 쪽 다리로 지지하여 스텝박스 가장자리에 선다.",
                "지지한 다리의 뒤꿈치를 들어 올렸다 내린다.",
                "10~15회 반복 후 다리를 바꿔 실시한다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0007",
            "title": "덤벨 스컬 크러셔(Dumbbell Skull crusher)",
            "thumb": "/assets/thumbs/Dumbbell-0007.png",
            "guide": [
                "벤치에 등을 대고 누워 양 손에 덤벨을 들고 팔을 가슴앞으로 뻗는다.",
                "덤벨이 머리 위로 오도록 팔꿈치를 굽혔다 펴면서 원위치로 돌아온다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0012",
            "title": "덤벨 숄더 PNF 패턴 운동(Shoulder PNF D1)",
            "thumb": "/assets/thumbs/Dumbbell-0012.png",
            "guide": [
                "한 손에 덤벨을 들고 어깨를 외회전하여 팔을 45° 바깥쪽으로 뻗는다.(외전)",
                "팔꿈치를 편 채 어깨를 내회전하여 팔을 머리 위 대각선 방향으로 들어 올렸다(내전) 어깨를 외회전하면서 팔을 내려 시작자세로 돌아온다.",
                "10~15회 반복 후 팔을 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0015",
            "title": "덤벨 쉬러그(Dumbbell Shrug)",
            "thumb": "/assets/thumbs/Dumbbell-0015.png",
            "guide": [
                "양 손에 덤벨을 들고 팔을 아래로 편 채 어깨만 위로 끌어올렸다 내린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Dumbbell/Dumbbell-0035",
            "title": "덤벨 풀오버 크런치-폼롤러(Dumbbell Pullover crunch with foam roller)",
            "thumb": "/assets/thumbs/Dumbbell-0035.png",
            "guide": [
                "바로 누워 팔을 머리 위로 뻗어서 덤벨을 잡는다.",
                "무릎을 굽혀서 폼롤러를 무릎 뒤 공간에 가로로 두고 발과 엉덩이로 고정한다.",
                "상체를 고정한 채 하체를 들어 무릎을 가슴쪽으로 끌어당겼다 처음위치로 돌아온다.",
                "10~15회 2~3세트 반복한다."
            ]
        }
    ],

    "medicine-ball": [
        {
            "id": "MB/MB-0008",
            "title": "메디슨 볼 푸시업(Medicine Ball Push up, One Ball)",
            "thumb": "/assets/thumbs/MB-0008.png",
            "guide": [
                "한 손을 메디슨볼에 올리고 엎드려 머리부터 발까지 사선을 만든다.",
                "팔꿈치를 굽혀 몸을 아래로 내렸다 팔꿈치를 펴면서 올라온다.",
                "5~8회 2~3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "MB/MB-0013",
            "title": "메디슨 볼 푸시업, 투볼(Medicine Ball Push Up, Two ball)",
            "thumb": "/assets/thumbs/MB-0013.png",
            "guide": [
                "두 개의 메디슨볼에 손을 올리고 팔을 뻗어 엎드린다.(머리부터 발까지 사선유지)",
                "팔꿈치를 굽히며 몸을 내렸다 팔꿈치를 펴면서 올라온다.",
                "10~15회 2~3세트 수행한다."
            ]
        },
        {
            "id": "MB/MB-0019",
            "title": "메디슨 볼 토 터치(Medicine ball toe touch)",
            "thumb": "/assets/thumbs/MB-0019.png",
            "guide": [
                "양 손으로 메디슨볼을 잡아 가슴앞으로 뻗고 누워 다리를 90°로 들어 올린다.",
                "상체를 세워 메디슨볼로 발등을 터치한다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "MB/MB-0011",
            "title": "메디슨 볼 러시안 트위스트(Medicine ball twist)",
            "thumb": "/assets/thumbs/MB-0011.png",
            "guide": [
                "무릎을 굽혀 발을 들고 앉는다.",
                "가슴높이에서 두 손으로 메디슨볼을 들고 상체를 좌우로 회전한다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "MB/MB-0021",
            "title": "메디슨 볼 바이시클(Medicine ball bicycle)",
            "thumb": "/assets/thumbs/MB-0021.png",
            "guide": [
                "앉아 다리를 앞으로 뻗고 양 손으로 메디슨볼을 든다.",
                "한 쪽 무릎을 굽혀 가슴쪽으로 끌어오면서 메디슨볼을 무릎 뒤로 돌려 받은 후 다리를 편다.",
                "반대쪽 다리를 굽히면서 같은 방법으로 메디슨볼을 무릎 뒤로 돌려 받는다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "MB/MB-0022",
            "title": "메디신볼 V 업 회전(Medicine Ball V up Circle)",
            "thumb": "/assets/thumbs/MB-0022.png",
            "guide": [
                "앉아 발바닥을 바닥에서 띄워 무릎을 굽히고 양 손으로 메디슨볼을 잡는다.",
                "메디신 볼을 무릎 뒤쪽으로 돌려 받는다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "MB/MB-0023",
            "title": "메디슨 볼 롤업(Medicine ball roll up)",
            "thumb": "/assets/thumbs/MB-0023.png",
            "guide": [
                "다리를 펴고 누워 한 쪽 무릎을 굽히고 같은 방향으로 팔을 가슴앞으로 뻗어 메디슨볼을 든다.",
                "메디슨볼의 위치를 고정한 채 반대쪽 팔로 바닥을 짚어 상체를 일으켜 앉는다.",
                "10~15회 반복하고 반대쪽도 실시하여 2~3세트 반복한다."
            ]
        },
        {
            "id": "MB/MB-0024",
            "title": "메디신 볼 우드춉(Medicine Ball Wood Chop)",
            "thumb": "/assets/thumbs/MB-0024.png",
            "guide": [
                "두 손으로 메디슨 볼을 잡고 서서 팔을 바깥쪽 대각선 방향으로 뻗어 올린다.",
                "무릎을 굽혀 수직으로 앉으면서 팔을 안쪽 대각선 방향으로 뻗어 내린다.",
                "10~15회 반복 후 반대쪽으로 실시한다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "MB/MB-0016",
            "title": "짐볼 누워 러시안 트위스트(Russian Twists on Stability ball with Medicine Ball)",
            "thumb": "/assets/thumbs/MB-0016.png",
            "guide": [
                "짐볼에 등을 대고 누워 팔을 가슴 앞으로 뻗어 메디슨볼을 잡는다.",
                "무릎을 굽히고 엉덩이를 들어 몸을 수평으로 만든다.",
                "흉추를 회전하여 메디슨볼을 좌우로 보낸다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "MB/MB-0018",
            "title": "엎드려 메디신 볼 끌어당기기(Prone Pike with Feet on Medicine Ball)",
            "thumb": "/assets/thumbs/MB-0018.png",
            "guide": [
                "푸쉬업 자세로 엎드려 두 발을 메디슨볼 위에 올린다.",
                "무릎을 편 채 메디슨 볼을 가슴쪽으로 끌어당겨 몸을 역 V자 형태로 만든다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "MB/MB-0006",
            "title": "메디슨 볼 싱글레그 스쿼트(Medicine Ball Single Leg Squat)",
            "thumb": "/assets/thumbs/MB-0006.png",
            "guide": [
                "팔을 가슴 앞으로 뻗어 두 손으로 메디슨 볼을 잡는다.",
                "한쪽 다리를 앞으로 뻗고 반대쪽 다리의 무릎을 굽히면서 앉았다 일어난 후 다리를 바꿔 실시한다.",
                "(근력에 따라 한 쪽 다리를 연속으로 5~10회 수행하고 반대쪽을 실시할 수 있다.)",
                "10회 2~3세트 실시한다."
            ]
        },
        {
            "id": "MB/MB-0026",
            "title": "메디슨 볼 싱글레그 브릿지(Medicine ball Single leg bridge)",
            "thumb": "/assets/thumbs/MB-0026.png",
            "guide": [
                "바로 누워 한 쪽 무릎을 굽혀 발을 메디슨볼 위에 두고 반때쪽 다리를 허벅지 높이로 뻗어 올린다.",
                "발로 메디슨볼을 누르면서 골반을 들어 올렸다 내린다.",
                "10~15회 반복 후 다리를 바꿔 실시한다.",
                "2~3세트 수행한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0007",
            "title": "월볼 스모 스쿼트(Sumo Squat, Wall ball)",
            "thumb": "/assets/thumbs/FitBW-0007.png",
            "guide": [
                "양손으로 월볼을 들고 서서 다리를 어깨넓이 보다 넓게 벌리고 발을 45° 외회전시킨다.",
                "상체를 세우고 무릎을 굽히면서 수직으로 앉았다 일어난다.",
                "10~15회 반복하여 3세트 실시한다.",
                "※ 양 발의 간격 : 무릎을 굽혀 앉을 때 직각이 될 정도"
            ]
        },
        {
            "id": "FitFunction/FitFunction-0003",
            "title": "메디신볼을 이용한 고관절 가동성 운동(Medicine Ball Hip Mobility)",
            "thumb": "/assets/thumbs/FitFunction-0003.png",
            "guide": [
                "다리를 넓게 벌리고 서서 메디슨볼을 다리 중앙에 둔다.",
                "한 쪽 다리를 굽혀 체중을 실어 앉으며(사이드 런지) 양 팔을 뻗어 메디슨볼을 굽힌 다리쪽으로 굴린다.",
                "무릎을 펴면서 다리를 바꿔 같은 방법으로 실시한다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0007",
            "title": "메디신볼 몸통 돌리기(Medicine Ball around back)",
            "thumb": "/assets/thumbs/FitFunction-0007.png",
            "guide": [
                "메디슨볼을 들고 한 발로 중심을 잡고 선다.",
                "허리를 중심으로 메디슨볼을 시계방향, 반시계방향으로 각각 10회씩 돌린다.",
                "다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0008",
            "title": "볼 회전 밸런스(Ball circles around leg balance exercise)",
            "thumb": "/assets/thumbs/FitFunction-0008.png",
            "guide": [
                "한 발로 중심을 잡고 서서 반대쪽 발을 메디슨볼 위에 올린다.",
                "지지한 다리를 중심으로 메디슨볼을 시계방향, 반시계방향으로 각각 10회씩 돌린다.",
                "다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0009",
            "title": "한발 들고 볼 던지기(Single leg stance Ball throws)",
            "thumb": "/assets/thumbs/FitFunction-0009.png",
            "guide": [
                "메디슨볼을 들고 한 발로 중심을 잡고 선다.",
                "공을 던졌다 받으면서 한 쪽 방향으로 몸통을 회전한다.",
                "10~15회 반복 후 다리를 바꿔 실시한다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "MB/MB-0001",
            "title": "짐볼 앉아 메디신 볼 패스(Gymball Seated Medicine Ball Chest Pass)",
            "thumb": "/assets/thumbs/MB-0001.png",
            "guide": [
                "짐볼에 앉아 메디슨볼을 가슴높이에서 던지고 받는다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "MB/MB-0002",
            "title": "머리 위에서 메디신 볼 던지기(Overhead Medicine Ball Toss)",
            "thumb": "/assets/thumbs/MB-0002.png",
            "guide": [
                "짐볼에 앉아 메디슨볼을 머리 위쪽으로 던지고 받는다. 10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "MB/MB-0003",
            "title": "메디신 볼 런지(Medicine Ball Lunge)",
            "thumb": "/assets/thumbs/MB-0003.png",
            "guide": [
                "메디슨볼을 가슴 앞에서 들고 서서 한 발을 충분히 앞으로 보내고 무릎을 90°로 굽혀 앉는다.",
                "시작자세로 돌아와 다리를 바꿔 같은 방법으로 실시한다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "MB/MB-0004",
            "title": "메디신 볼 런지 트위스트(Lunge Russian twist-Medicine Ball)",
            "thumb": "/assets/thumbs/MB-0004.png",
            "guide": [
                "두 손으로 메디슨볼을 들고 팔을 가슴앞으로 뻗으면서 한 발을 앞으로 보내 무릎을 90°로 굽혀 앉는다.",
                "팔과 함께 몸통을 앞으로 보낸 다리 방향으로 회전시킨다.",
                "다리를 바꿔가며 10~15회 반복하고, 2~3세트 실시한다."
            ]
        },
        {
            "id": "MB/MB-0005",
            "title": "메디신 볼 사이드 런지(Lateral Lunge-Medicine Ball)",
            "thumb": "/assets/thumbs/MB-0005.png",
            "guide": [
                "다리사이를 넓게 벌리고 서서 메디신 볼을 두 손으로 잡는다.",
                "팔을 가슴앞으로 뻗으면서 한 쪽 다리의 무릎을 굽혀 체중을 싣는다.(사이드 런지)",
                "시작자세로 돌아와 반대쪽으로 실시하고, 10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "MB/MB-0007",
            "title": "짐볼 크런치 메디신 볼 던지기(Crunch and Toss-Medicine Ball)",
            "thumb": "/assets/thumbs/MB-0007.png",
            "guide": [
                "짐볼에 앉아 메디슨볼을 받으면서 상체를 뒤로 눕혀 메디슨볼을 머리 위로 뻗어올린다.",
                "상체를 일으키면서 메디슨볼을 던진다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "MB/MB-0009",
            "title": "메디신 볼 무릎 신전(Knee Extension-Medicine Ball)",
            "thumb": "/assets/thumbs/MB-0009.png",
            "guide": [
                "양 손으로 바닥을 짚고 앉아 무릎을 굽혀 메디슨 볼을 양쪽 발 사이에 고정한다.",
                "다리를 45° 방향으로 뻗어 올린 후 무릎을 굽혀 가슴쪽으로 끌어당겼다 다시 편다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "MB/MB-0010",
            "title": "메디신 볼 런지 & 오버헤드 프레스(Lunge and Overhead Press-Medicine Ball)",
            "thumb": "/assets/thumbs/MB-0010.png",
            "guide": [
                "두 손으로 메디슨볼을 잡고 팔을 가슴앞으로 뻗으면서 한 쪽 다리를 앞으로 보내 무릎을 굽혀 앉는다.",
                "무릎을 펴고 일어나 반대쪽 무릎을 굽혀 가슴쪽으로 당겨올리고 팔은 머리 위로 뻗는다.",
                "들어 올린 다리를 뒤로 보내 무릎을 굽히고 앉으면서 팔을 가슴앞으로 뻗었다 시작자세로 돌아온다.",
                "다리를 바꿔가며 10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "MB/MB-0012",
            "title": "짐볼 누워 메디신 볼 오블리끄 크런치(Oblique Crunch-Medicine Ball)",
            "thumb": "/assets/thumbs/MB-0012.png",
            "guide": [
                "짐볼 위에 등을 대고 누워 무릎을 굽히고, 손으로 메디슨볼을 잡아 팔을 머리 위로 들어 올린다.",
                "상체를 한 쪽 방향으로 틀면서 세워 올렸다 내린 후 같은 방법으로 반대방향으로 실시한다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "MB/MB-0014",
            "title": "짐볼 앉아 메디신 볼 밸런스( Seated Balance-Medicine Ball)",
            "thumb": "/assets/thumbs/MB-0014.png",
            "guide": [
                "짐볼에 앉아 한 발을 들고 반대쪽 발은 메디슨볼 위에 올려 균형을 잡으면서 30초간 유지한다.",
                "다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "MB/MB-0015",
            "title": "메디신 볼 푸시 스쿼트(Push Squat-Medicine Ball)",
            "thumb": "/assets/thumbs/MB-0015.png",
            "guide": [
                "두 손으로 메디슨볼을 잡고 서서 팔을 뻗어 머리 위로 메디슨볼을 들어 올린다.",
                "무릎을 굽히고 앉으면서 팔을 내려 메디슨볼로 바닥을 터치한 후 다시 일어서면서 팔을 위로 뻗어 올린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "MB/MB-0017",
            "title": "메디신 볼 다이나믹 레그 리프트(Medicine Ball Dynamic Leg Lift)",
            "thumb": "/assets/thumbs/MB-0017.png",
            "guide": [
                "메디슨볼을 발등에 올려 한 손으로 잡는다.",
                "손으로 메디신 볼을 고정한 채 다리를 뻗어 올렸다 시작자세로 돌아와 다리를 바꿔 실시한다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "MB/MB-0020",
            "title": "메디신 볼 싯업(Medicine Ball sit up)",
            "thumb": "/assets/thumbs/MB-0020.png",
            "guide": [
                "무릎을 세우고 누워 팔을 머리 위로 올려 두 손으로 메디슨볼을 잡는다.",
                "메디슨볼을 가슴 앞쪽으로 가져오면서 상체를 세워 앉는다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "MB/MB-0025",
            "title": "옆으로 누워 메디신 볼 들어올리기(Lying Double Leg Raise with Medicine Ball)",
            "thumb": "/assets/thumbs/MB-0025.png",
            "guide": [
                "옆으로 누워 메디슨볼을 양 발 사이에 두고 고정한다.",
                "상체를 고정한 채 메디슨볼과 함께 두 다리를 위로 들어 올렸다 내린다.",
                "10~15회 반복 후 반대쪽으로 실시하고, 2~3세트 반복한다."
            ]
        },
    ],

    "bosu-ball": [
        {
            "id": "BOSU/BOSU-0005",
            "title": "짐볼 위에서 보수볼 플랭크(BOSU Plank with feet on Stability ball)",
            "thumb": "/assets/thumbs/BOSU-0005.png",
            "guide": [
                "보수볼을 거꾸로 두고 팔을 가슴앞으로 뻗어 양 쪽 가장자리를 짚고 엎드린다.",
                "다리를 펴서 발등을 짐볼 위에 올려 몸을 수평으로 만들고 20초~1분간 유지한다. 2~3세트 반복한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0001",
            "title": "보수볼 플랭크(BOSU Plank)",
            "thumb": "/assets/thumbs/BOSU-0001.png",
            "guide": [
                "팔꿈치를 굽혀 보수볼 위에 어깨와 수직으로 올리고 엎드린다.",
                "두 다리를 펴서 어깨부터 발까지 사선형태를 만들고 20초~1분간 유지한다. 2~3세트 반복한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0002",
            "title": "보수볼 사이드 플랭크(BOSU Side plank)",
            "thumb": "/assets/thumbs/BOSU-0002.png",
            "guide": [
                "한 쪽 팔꿈치를 굽혀 보수볼 위에 어깨와 수직으로 올리고 옆으로 앉는다.",
                "두 다리를 펴서 어깨부터 발까지 사선형태를 만들어 20초~1분간 유지한다. 2~3세트 반복한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0003",
            "title": "보수볼 V-UP(BOSU V-up)",
            "thumb": "/assets/thumbs/BOSU-0003.png",
            "guide": [
                "보수볼 위에 앉아 상체와 다리를 들어 올리고 20초~1분간 균형을 유지한다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0004",
            "title": "보수볼 레그레이즈(BOSU leg raise)",
            "thumb": "/assets/thumbs/BOSU-0004.png",
            "guide": [
                "보수볼을 거꾸로 두고 팔을 펴서 양 쪽 가장자리를 잡고 엎드려 다리를 편다.",
                "어깨부터 발까지 사선형태를 유지한 채 한 쪽 다리를 들어 올려 20초~1분간 균형을 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 10회 2~3세트 반복한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0006",
            "title": "보수볼 누워 메디신 볼 토스(BOSU Sit up & Ball toss)",
            "thumb": "/assets/thumbs/BOSU-0006.png",
            "guide": [
                "두 손으로 메디슨볼을 들고 보수볼 위에 앉는다.",
                "상체를 뒤로 기울이면서 팔을 들어 메디슨볼을 머리 위로 올렸다 상체를 세우면서 메디슨볼을 앞으로 던진다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0007",
            "title": "보수볼 러시안 트위스트(BOSU Russian Twist)",
            "thumb": "/assets/thumbs/BOSU-0007.png",
            "guide": [
                "두 손으로 메디슨볼을 잡고 보수볼 위에 앉는다.",
                "발을 들어 올리고 가슴높이에서 흉추와 함께 메디슨 볼을 좌우로 회전시킨다. 10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0008",
            "title": "BOSU Single Leg Glute Bridge(Straight leg)",
            "thumb": "/assets/thumbs/BOSU-0008.png",
            "guide": [
                "바로 누워 한 쪽 다리를 굽혀 발을 보수볼 위에 올리고, 반대쪽 다리는 허벅지 높이로 뻗은 후 골반을 들어 올린다.",
                "10~15회 반복 후 다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0009",
            "title": "보수볼 서클(BOSU circle)",
            "thumb": "/assets/thumbs/BOSU-0009.png",
            "guide": [
                "보수볼을 거꾸로 두고 팔을 가슴앞으로 뻗어 양 쪽 가장자리를 짚고 엎드린다.",
                "두 다리를 뻗어 머리부터 발까지 사선형태를 유지한 채 보수볼을 시계방향, 반시계방향으로 각각 5번씩 돌린다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0010",
            "title": "보수볼 런지(BOSU Lunge)",
            "thumb": "/assets/thumbs/BOSU-0010.png",
            "guide": [
                "한 발을 앞으로 보내 보수볼을 위에 올린다.",
                "무릎을 90°로 굽혀 수직으로 앉았다 일어나 시작자세로 돌아온다.",
                "다리를 바꿔가며 10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0011",
            "title": "보수볼 스텝다운(BOSU step down)",
            "thumb": "/assets/thumbs/BOSU-0011.png",
            "guide": [
                "보수볼 위에 한 발로 선다.",
                "지지하고 있는 다리의 무릎을 굽히면서 반대쪽 발바닥을 바닥에 가깝게 앞으로 뻗어 내린다.",
                "10~15회 반복 후 다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0012",
            "title": "보수볼 싱글레그 밸런스(BOSU Single leg balance)",
            "thumb": "/assets/thumbs/BOSU-0012.png",
            "guide": [
                "보수볼 위에 한 발로 선다.",
                "지지하고 있는 다리의 무릎을 굽히고 반대쪽 다리를 뒤로 뻗으면서 상체를 앞으로 숙여 머리부터 허리까지 직선을 만든다.",
                "20~30초 유지 후 다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0013",
            "title": "보수볼 우드챱(BOSU Wood chop)",
            "thumb": "/assets/thumbs/BOSU-0013.png",
            "guide": [
                "보수볼 위에 서서 두 손으로 메디슨볼을 잡아 팔을 바깥쪽 대각선 방향으로 뻗어 올린다.",
                "무릎을 굽혀 앉으며 팔을 안쪽 대각선 방향으로 뻗어 내렸다 시작자세로 돌아온다.",
                "10~15회 반복 후 반대쪽으로 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0015",
            "title": "보수볼위 메디신 볼 몸통회전(BOSU Trunk rotation with medicine ball)",
            "thumb": "/assets/thumbs/BOSU-0015.png",
            "guide": [
                "보수볼을 거꾸로 두고 올라서 두 손으로 메디슨볼을 잡는다.",
                "무릎을 굽혀 앉으면서 팔을 가슴앞으로 뻗어 흉추와 함께 좌우로 회전한다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0016",
            "title": "보수볼 사이드스텝(BOSU Side step)",
            "thumb": "/assets/thumbs/BOSU-0016.png",
            "guide": [
                "보수볼 위에 한 발을 두고 옆으로 선다.",
                "가볍게 점프를 하면서 발을 바꿔 반대쪽으로 이동하여 무릎을 굽혀 착지하고 반대쪽 팔을 아래로 뻗는다.",
                "같은 방법으로 점프를 하며 반대쪽으로 이동한다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0017",
            "title": "보수볼 싱글레그 밸런스-메디신 볼(BOSU Single leg balance with medicine ball)",
            "thumb": "/assets/thumbs/BOSU-0017.png",
            "guide": [
                "보수볼 위에 한발로 서서 두 손으로 메디슨볼을 잡는다.",
                "지지한 다리의 무릎을 굽히고 팔을 가슴앞으로 뻗어 20~30초간 균형을 유지한다.",
                "원위치로 돌아와 발을 바꿔 같은 방법으로 실시하고,  2~3세트 반복한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0018",
            "title": "보수볼 마운틴 클라이밍(BOSU Mountain climbing)",
            "thumb": "/assets/thumbs/BOSU-0018.png",
            "guide": [
                "보수볼을 거꾸로 두고 팔을 뻗어 양쪽 가장자리를 짚고 엎드린다.",
                "다리를 펴서 머리부터 발까지 사선형태를 유지한 채 한 쪽 무릎을 옆으로 굽혀 가슴쪽으로 끌어 당겼다 원위치로 돌아간다.",
                "같은 방법으로 다리를 바꿔 실시하고, 10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0019",
            "title": "보수볼 사이드 쓰러스트(BOSU Side Thrust)",
            "thumb": "/assets/thumbs/BOSU-0019.png",
            "guide": [
                "보수볼을 거꾸로 두고 팔을 뻗어 양쪽 가장자리를 짚고 다리를 편다.",
                "몸통을 틀면서 한 무릎을 안쪽 사선방향으로 굽혀 가슴쪽으로 끌어 올린다.",
                "원위치로 돌아와 같은 방법으로 다리를 바꿔 실시하고, 10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0020",
            "title": "보수볼 버피(BOSU Burpee)",
            "thumb": "/assets/thumbs/BOSU-0020.png",
            "guide": [
                "보수볼 바닥을 양 손으로 잡고 엎드려 다리를 편다.",
                "가볍게 점프하여 발을 가슴쪽으로 보낸 후 보수볼을 들고 일어나 팔을 머리 위로 뻗어 올린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0021",
            "title": "보수볼 레그레이즈, 앉아서(BOSU Leg raise, sitting)",
            "thumb": "/assets/thumbs/BOSU-0021.png",
            "guide": [
                "보수볼 위에 앉아 양쪽 팔을 뒤로 보내 바닥을 짚고 다리를 수평으로 편다.",
                "다리를 모아 위로 최대한 들어올렸다 내린다. 10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0022",
            "title": "보수볼 플랭크 업&다운(BOSU Plank up down)",
            "thumb": "/assets/thumbs/BOSU-0022.png",
            "guide": [
                "팔꿈치를 90°로 굽혀 보수볼 위에 올리고 엎드려 다리를 편다.",
                "한 쪽씩 팔꿈치를 펴서 푸쉬업 자세를 만들었다 다시 팔꿈치를 차례로 굽혀 시작자세로 돌아온다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0023",
            "title": "보수볼 네 발 밸런스(BOSU Quadruped balance)",
            "thumb": "/assets/thumbs/BOSU-0023.png",
            "guide": [
                "보수볼 위에 네 발 기기 자세로 엎드린다.",
                "한 쪽 팔과 반대쪽 다리를 위아래로 뻗어 수평으로 들어 올리고 20~30초간 균형을 유지한다.",
                "시작자세로 돌아와 팔과 다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "BOSU/BOSU-0014",
            "title": "보수볼 밸런스(BOSU balance)",
            "thumb": "/assets/thumbs/BOSU-0014.png",
            "guide": [
                "보수볼에 메디신 볼을 들고 선다. 팔을 뻗어 메디신 볼을 앞으로 내밀고 무릎을 굽혀 앉는다(스쿼트) 20 ~30초 유지하고 10~15회 실시한다. 2~3세트 반복한다."
            ]
        },
    ],


    "stability-ball": [
        {
            "id": "GB/GB-0010",
            "title": "짐볼 새사냥개 다리들기(Bird Dog Leg Lift)",
            "thumb": "/assets/thumbs/GB-0010.png",
            "guide": [
                "짐볼 위에 배를 대고 네 발 기기 자세로 엎드린다.",
                "한 쪽 다리를 펴서 엉덩이 높이로 올리고(고관절신전) 20~30초간 유지한다.",
                "같은 방법으로 반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0001",
            "title": "짐볼 월스쿼트(Gymball Wall Squat)",
            "thumb": "/assets/thumbs/GB-0001.png",
            "guide": [
                "벽과 등 사이에 짐볼을 두고 기대어 서서 짐볼을 가볍게 밀면서 무릎을 90°로 굽혀 앉았다 일어선다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0002",
            "title": "짐볼 허그 월 스쿼트(Gymball Hug Wall Squat)",
            "thumb": "/assets/thumbs/GB-0002.png",
            "guide": [
                "벽과 등 사이에 짐볼을 두고 기대어 서서 가슴앞으로 짐볼을 안는다.",
                "짐볼을 밀면서 무릎을 90°로 굽혀 앉았다 일어선다. 10~15회 3세트 반복한다"
            ]
        },
        {
            "id": "GB/GB-0003",
            "title": "짐볼 허그 스쿼트(Gymball Hug Squat)",
            "thumb": "/assets/thumbs/GB-0003.png",
            "guide": [
                "팔을 가슴앞으로 뻗어 짐볼을 안고 서서 무릎을 90°로 굽혀 앉았다 일어선다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0004",
            "title": "짐볼 앉아 고관절 굴곡(Gymball Alternative hip flexion)",
            "thumb": "/assets/thumbs/GB-0004.png",
            "guide": [
                "무릎을 굽히고 짐볼 위에 앉아 한 쪽 무릎을 가슴쪽으로 끌어올렸다 내린 후 다리를 바꿔 실시한다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0005",
            "title": "짐볼 레그익스텐션(Gymball Leg Extension)",
            "thumb": "/assets/thumbs/GB-0005.png",
            "guide": [
                "무릎을 굽히고 짐볼 위에 앉아 한 쪽 다리를 수평으로 편다.",
                "10~15회 반복 후 다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0006",
            "title": "짐볼 기대어 사이드레그 리프트(Gymball Thigh Lift)",
            "thumb": "/assets/thumbs/GB-0006.png",
            "guide": [
                "짐볼 옆으로 무릎을 꿇고 앉아 몸을 옆으로 기울여 아래쪽 팔꿈치로 짐볼을 짚는다.",
                "바깥쪽 다리를 펴서 옆으로 들어 올렸다 내린다.",
                "10~15회 반복 후 반대쪽으로 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0007",
            "title": "짐볼 다리 올려 푸시업(Push up feet on Gymball)",
            "thumb": "/assets/thumbs/GB-0007.png",
            "guide": [
                "푸쉬업 자세로 엎드려 양 쪽 발을 짐볼 위에 올린다.",
                "팔꿈치를 굽혀 상체를 바닥쪽으로 내렸다 팔을 펴며 상체를 들어 올린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0008",
            "title": "짐볼 푸시업(Gymball Push up)",
            "thumb": "/assets/thumbs/GB-0008.png",
            "guide": [
                "두 손으로 짐볼을 짚고 푸쉬업 자세로 엎드린다.",
                "팔꿈치를 굽혀 몸을 짐볼쪽으로 내렸다 팔을 펴며 몸을 들어 올린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0009",
            "title": "짐볼 백익스텐션(Gymball Back extension)",
            "thumb": "/assets/thumbs/GB-0009.png",
            "guide": [
                "짐볼 위에 배를 대고 엎으려서 다리를 펴고 팔을 굽혀 손을 귀 뒤에 둔다.",
                "가슴을 펴 상체를 들어 올렸다 내린다. 10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0011",
            "title": "짐볼 새사냥개(Gymball Bird Dog Arm Lift)",
            "thumb": "/assets/thumbs/GB-0011.png",
            "guide": [
                "짐볼 위에 배를 올리고 네 발 기기 자세로 엎드린다.",
                "한 쪽 팔과 반대쪽 다리를 위아래로 뻗어 수평으로 들어 올리고 20~30초간 유지한다.",
                "원위치로 돌아와 반대쪽도 같은 방법으로 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0012",
            "title": "짐볼 무릎당기기(Gymball Knee Tuck)",
            "thumb": "/assets/thumbs/GB-0012.png",
            "guide": [
                "짐볼 위에 양 쪽 다리를 올리고 푸쉬업 자세로 엎드린다.",
                "무릎을 굽혀 짐볼과 함께 가슴쪽으로 끌어 당겼다 시작자세로 돌아간다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0013",
            "title": "짐볼 플랭크(Gymball plank)",
            "thumb": "/assets/thumbs/GB-0013.png",
            "guide": [
                "팔꿈치를 굽혀 어깨와 수직으로 짐볼 위에 올리고 엎드린다.",
                "다리를 펴서 머리부터 발까지 사선형태로 만들어 20초~1분간 유지하여 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0014",
            "title": "짐볼 플랭크 & 볼 회전(Gymball Prone circle)",
            "thumb": "/assets/thumbs/GB-0014.png",
            "guide": [
                "팔꿈치를 굽혀 어깨와 수직으로 짐볼 위에 올리고 엎드린다.",
                "다리를 펴서 머리부터 발까지 사선형태로 만든다.",
                "짐볼을 시계방향, 반시계방향으로 5~10회씩 돌리고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0015",
            "title": "짐볼 플랭크 볼 굴리기(Gymball Prone ball roll)",
            "thumb": "/assets/thumbs/GB-0015.png",
            "guide": [
                "짐볼 앞에서 무릎을 꿇고 앉아 몸을 앞으로 숙여 양 쪽 팔꿈치를 짐볼 위에 올린다.",
                "짐볼을 눌러 몸과 함께 앞으로 밀어내 머리부터 무릎까지 사선형태를 만든다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0016",
            "title": "짐볼 엎드려 한 발 무릎 당기기(Gymball Single Knee Tuck)",
            "thumb": "/assets/thumbs/GB-0016.png",
            "guide": [
                "푸쉬업 자세로 엎드려 양 쪽 발을 짐볼 위에 올린다.",
                "한 쪽 무릎을 굽혀 가슴쪽으로 끌어 당겼다 시작자세로 돌아와 다리를 바꿔 실시한다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0017",
            "title": "짐볼 플랭크 레그레이즈(Gymball Plank Leg raise)",
            "thumb": "/assets/thumbs/GB-0017.png",
            "guide": [
                "푸쉬업 자세로 엎드려 양 쪽 발을 짐볼 위에 올린다.",
                "한 쪽 다리를 편 채 위로 들어 올렸다 내린 후 다리를 바꿔 실시한다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0018",
            "title": "짐볼 트위스트(Gymball twist)",
            "thumb": "/assets/thumbs/GB-0018.png",
            "guide": [
                "양 쪽 다리 사이에 짐볼을 고정하고 푸쉬업 자세로 엎드린다.",
                "짐볼과 함께 하체를 좌우로 회전시킨다. 10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0019",
            "title": "짐볼 크런치(Gymball Crunch)",
            "thumb": "/assets/thumbs/GB-0019.png",
            "guide": [
                "짐볼에 앉아 팔꿈치를 굽혀 손을 귀 뒤에 둔다.",
                "상체를 뒤로 기울여 짐볼 위에 누웠다 복부를 이용하여 상체를 들어 올린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0020",
            "title": "짐볼 브릿지 & 컬(Gymball Glute Bridge & curl)",
            "thumb": "/assets/thumbs/GB-0020.png",
            "guide": [
                "등을 대고 누워 두 발을 짐볼 위에 올려 무릎을 굽힌다.",
                "골반을 들어 올린 후 다리를 펴면서 짐볼을 밀어냈다 무릎을 굽혀 돌아온다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0021",
            "title": "짐볼 스트레이트 레그 데드버그(Gymball Straight Leg Dead Bug)",
            "thumb": "/assets/thumbs/GB-0021.png",
            "guide": [
                "바닥에 등을 대고 누워 오른쪽 팔과 왼쪽 다리를 위로 들어 짐볼을 고정하고, 반대쪽 팔과 다리는 일자로 뻗는다.",
                "짐볼을 같은 위치에 고정한 채 팔과 다리를 교체하여 짐볼을 고정하고 동시에 반대쪽 팔과 다리를 일자로 뻗는다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "GB/GB-0022",
            "title": "짐볼 오블리끄 크런치(Gymball Oblique crunch)",
            "thumb": "/assets/thumbs/GB-0022.png",
            "guide": [
                "짐볼에 등을 대고 누워 무릎을 굽히고 팔꿈치를 굽혀 손을 귀 뒤에 둔다.",
                "상체를 한 쪽 방향으로 틀면서 들어 올렸다 내린 후 반대쪽으로 실시한다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0023",
            "title": "짐볼 싯업(Gymball Sit up)",
            "thumb": "/assets/thumbs/GB-0023.png",
            "guide": [
                "무릎을 굽혀 짐볼 위에 올리고 누워 팔꿈치를 굽혀 양 손을 귀 뒤에 둔다.",
                "하체를 고정한 채 복부를 수축하여 상체를 들어올렸다 내린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0024",
            "title": "짐볼 레그리프트(Gymball Leg Lift)",
            "thumb": "/assets/thumbs/GB-0024.png",
            "guide": [
                "양쪽 다리로 짐볼을 잡고 누워 팔꿈치를 굽히고 손을 귀 뒤에 댄다.",
                "짐볼과 함께 다리를 수직으로 들어 올렸다 바닥과 수평이 될 때까지 내린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0025",
            "title": "누워 짐볼 몸통회전(Gymball Trunk rotation, Supine)",
            "thumb": "/assets/thumbs/GB-0025.png",
            "guide": [
                "바로 누워 양쪽 다리 사이에 짐볼을 고정한다.",
                "상체를 고정한 채 짐볼과 함께 다리를 들어 좌우로 회전시킨다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0026",
            "title": "짐볼 싱글레그 리프트(Gymball Single Leg Lift)",
            "thumb": "/assets/thumbs/GB-0026.png",
            "guide": [
                "다리를 펴고 누워 오른쪽 팔과 왼쪽 다리를 위로 들어 짐볼을 고정한다.",
                "왼쪽 팔로 바닥을 짚어 상체를 세우면서 짐볼과 함께 왼쪽 다리를 바닥쪽으로 내린다.",
                "10~15회 반복 후 반대쪽으로 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0027",
            "title": "짐볼 V업(Gymball V up)",
            "thumb": "/assets/thumbs/GB-0027.png",
            "guide": [
                "팔과 다리를 위아래로 뻗고 누워 머리 위에서 짐볼을 잡는다.",
                "상하체를 들어 올려 V형태를 만들어 짐볼을 다리로 옮겨 잡은 후 팔과 다리를 바닥쪽으로 내린다.",
                "다시 상하체를 들어 올려 짐볼을 손으로 옮겨 잡은 후 팔과 다리를 바닥쪽으로 내린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0028",
            "title": "누워 짐볼 레그 트위스트(Gymball Supine Leg Twists)",
            "thumb": "/assets/thumbs/GB-0028.png",
            "guide": [
                "바로 누워 양쪽 다리 사이에 짐볼을 고정한다.",
                "상체를 고정한 채 짐볼과 함께 다리를 들어 좌우로 회전시킨다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0029",
            "title": "짐볼 롤링(Gymball rolling)",
            "thumb": "/assets/thumbs/GB-0029.png",
            "guide": [
                "짐볼에 등을 대고 누워 무릎을 굽히고 골반을 들어올리고, 팔은 가슴앞에서 팔짱을 껴 바(bar)를 잡는다.",
                "발을 조금씩 옆으로 이동시켜 등을 짐볼의 한 쪽 끝으로 이동시킨 후 다시 반대쪽으로 이동한다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0030",
            "title": "짐볼 싱글레그 브릿지(Gymball Single Leg Glute Bridge)",
            "thumb": "/assets/thumbs/GB-0030.png",
            "guide": [
                "짐볼에 등을 대고 누워서 무릎을 90°로 굽히고, 팔을 굽혀 손을 귀 뒤로 보내 가슴을 편다.",
                "골반을 수평으로 들어 올린 후 한 쪽 다리를 들고 10~20초간 균형을 유지한 후 다리를 바꿔 실시한다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0031",
            "title": "짐볼 파이크(Gymball Pike)",
            "thumb": "/assets/thumbs/GB-0031.png",
            "guide": [
                "푸쉬업 자세로 엎드려 두 발을 짐볼 위에 올린다.",
                "다리를 편 채 엉덩이를 위로 들어 올리면서 짐볼과 함께 발을 가슴쪽으로 끌어 당겼다 시작자세로 돌아온다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0032",
            "title": "짐볼 사이드업(Gymball Side up)",
            "thumb": "/assets/thumbs/GB-0032.png",
            "guide": [
                "짐볼 위에 옆으로 누워 다리를 펴고 팔꿈치를 굽혀 손을 귀 뒤로 보낸다.",
                "상체를 아래로 굽혔다 들어 올린다.",
                "10~15회 반복 후 반대쪽으로 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0033",
            "title": "벽 기대고 짐볼 싱글레그 스쿼트(Single Leg Squat with Gymball)",
            "thumb": "/assets/thumbs/GB-0033.png",
            "guide": [
                "벽과 등 사이에 짐볼을 두고 기대어 선다.",
                "한 쪽 발을 들고 지지한 다리의 무릎을 굽혀 앉았다 일어선다.",
                "10~15회 반복 후 다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0034",
            "title": "짐볼 옆으로 벽 기대고 싱글레그 스쿼트(Gymball on a Wall Single Leg Squat)",
            "thumb": "/assets/thumbs/GB-0034.png",
            "guide": [
                "벽 옆에 서서 안쪽 다리를 들어 무릎을 굽히고 무릎과 벽 사이에 짐볼을 두고 기댄다.",
                "지지하고 선 다리를 굽히고, 짐볼과 함께 안쪽 다리를 끌어 내리면서 앉았다 일어난다.",
                "10~15회 반복 후 다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0035",
            "title": "짐볼에 한발 올려놓고 스쿼트(Single leg Gymball squat)",
            "thumb": "/assets/thumbs/GB-0035.png",
            "guide": [
                "한 쪽 다리를 옆으로 뻗어 발을 짐볼 위에 올리고 선다.",
                "지지하고 선 다리의 무릎을 굽혀 앉았다 일어선다.",
                "10~15회 반복 후 다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0036",
            "title": "짐볼 햄스트링 고정 후 싱글레그 스쿼트(Gymball Single leg squat)",
            "thumb": "/assets/thumbs/GB-0036.png",
            "guide": [
                "한 다리로 서서 반대쪽 다리를 들어 무릎을 굽히고 엉덩이와 뒤꿈치 사이에 짐볼을 고정한다.",
                "지지하고 선 다리의 무릎을 굽히며 앉았다 일어선다.",
                "10~15회 반복 후 다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "GB/GB-0037",
            "title": "짐볼 엎드려 교차로 무릎 당기기(Gymball Alternative knee tuck)",
            "thumb": "/assets/thumbs/GB-0037.png",
            "guide": [
                "짐볼에 손을 짚고 다리를 뻗어 푸쉬업 자세로 엎드린다.",
                "한 쪽 무릎을 굽혀 가슴쪽으로 끌어 올렸다 시작위치로 돌아온 후 다리를 바꿔 실시한다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "GolfCon/GolfCon-0002",
            "title": "등척성 목 측굴(Isometric Neck Side flexion with ball)",
            "thumb": "/assets/thumbs/GolfCon-0002.png",
            "guide": [
                "벽과 머리 사이에 짐볼(45cm 정도)을 두고 옆으로 선다. 머리를 옆으로 짐볼쪽으로 기울이려는 힘을 써서 짐볼을 가볍게 누르고 5초간 유지한다. 5~10회 반복하고, 반대쪽도 실시한다. * 근육통 여부를 확인하고 세트와 강도를 늘리고, 너무 강하게 힘을 쓰지 않도록 한다."
            ]
        },
        {
            "id": "GolfCon/GolfCon-0003",
            "title": "등척성 목 회전운동((Isometric Neck Rotation with ball)",
            "thumb": "/assets/thumbs/GolfCon-0003.png",
            "guide": [
                "벽과 머리 사이에 짐볼(45cm 정도)을 두고 옆으로 선다. 머리를 짐볼쪽으로 회전하려는 힘을 써서 짐볼을 가볍게 누르고 5초간 유지한다. 5~10회 반복하고, 반대쪽도 실시한다. * 근육통 여부를 확인하고 세트와 강도를 늘리고, 너무 강하게 힘을 쓰지 않도록 한다."
            ]
        },
        {
            "id": "GolfCon/GolfCon-0004",
            "title": "등척성 목 신전(Isometric Neck Extension with ball)",
            "thumb": "/assets/thumbs/GolfCon-0004.png",
            "guide": [
                "머리 뒤쪽으로 짐볼(45cm 정도)을 두고 기대어 선다. 고개를 뒤로 젖히려는 힘을 써서 짐볼을 가볍게 압박하여 5초간 유지한다. 5~10회 반복한다. * 근육통 여부를 확인하고 세트와 강도를 늘리고, 너무 강하게 힘을 쓰지 않도록 한다."
            ]
        },
        {
            "id": "GolfCon/GolfCon-0005",
            "title": "등척성 목 굴곡(Isometric Neck flexion with ball)",
            "thumb": "/assets/thumbs/GolfCon-0005.png",
            "guide": [
                "벽과 이마 사이에 짐볼(45cm 정도)을 두고 기대어 선다. 고개를 앞으로 숙이려는 힘을 써서 짐볼을 가볍게 압박하여 5초간 유지한다.",
                "5~10회 반복한다. * 근육통 여부를 확인하고 세트와 강도를 늘리고, 너무 강하게 힘을 쓰지 않도록 한다."
            ]
        },
        {
            "id": "MS/MS-Neck-0055",
            "title": "네발기기자세 등척성 목 굴곡-짐볼(Isometric Neck flexion with Stability ball, Quadruped)",
            "thumb": "/assets/thumbs/MS-Neck-0055.png",
            "guide": [
                "이마 밑에 짐볼을 두고 네 발 기기 자세로 엎드린다. 짐볼을 누르면서 목을 가볍게 굽혀 3~5초간 유지한다.(3~5회 반복)"
            ]
        },
        {
            "id": "MS/MS-Neck-0056",
            "title": "목 신전근 활성화-짐볼 벽에 대고 머리로 밀기(Posterior cervical muscle activation-Static Neck Extension with ball)",
            "thumb": "/assets/thumbs/MS-Neck-0056.png",
            "guide": [
                "벽에 짐볼을 정수리로 고정하고 앞으로 위로 밀면서 유지한다. 5초간 유지한다. 3~5번 반복한다."
            ]
        },
    ],

    "cable": [
        {
            "id": "CB/CB-0012",
            "title": "케이블 벤치프레스(Cable Bench Press)",
            "thumb": "/assets/thumbs/CB-0012.png",
            "guide": [
                "벤치에 누워 양 손으로 케이블을 잡고 팔꿈치를 펴서 가슴앞(수직)으로 뻗어 올린다.",
                "10~15회 반복하고, 2~3세트 수행한다."
            ]
        },
        {
            "id": "CB/CB-0013",
            "title": "케이블 벤치 플라이(Cable Bench Fly)",
            "thumb": "/assets/thumbs/CB-0013.png",
            "guide": [
                "양손으로 케이블을 잡고 벤치에 누워서 팔을 가슴앞으로 뻗고 손바닥을 마주보게 한다.",
                "팔꿈치를 살짝 구부리며 팔을 옆으로 천천히 벌린다.",
                "반원을 그리며 손을 가슴앞으로 모은다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0008",
            "title": "스탠딩 케이블 프레스(Standing Cable Press)",
            "thumb": "/assets/thumbs/CB-0008.png",
            "guide": [
                "양 손에 케이블을 뒤에서 앞으로 잡고 팔꿈치를 90°로 굽혀 어깨높이로 들어 올린다.",
                "팔꿈치를 펴서 케이블을 앞으로 밀어낸다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0009",
            "title": "스탠딩 싱글암 케이블 펀치(Standing Single Arm Cable Punch)",
            "thumb": "/assets/thumbs/CB-0009.png",
            "guide": [
                "양손에 케이블을 뒤에서 앞으로 잡고 선다.",
                "펀치 하듯 한 팔을 가슴앞으로 뻗었다 굽히면서 반대쪽 팔을 뻗는다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0011",
            "title": "스탠딩 케이블 플라이(Standing Cable Fly)",
            "thumb": "/assets/thumbs/CB-0011.png",
            "guide": [
                "양손에 케이블을 뒤에서 앞으로 잡고 선다.",
                "팔꿈치를 가볍게 굽혀 어깨높이에 맞춰 옆으로 벌린다.",
                "케이블을 당겨 손을 가슴앞으로 모은다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0021",
            "title": "케이블 외회전운동(Cable External Rotation, Standing)",
            "thumb": "/assets/thumbs/CB-0021.png",
            "guide": [
                "옆으로 서서 바깥쪽 손으로 케이블을 안에서 밖으로 잡는다.",
                "케이블을 잡은 팔을 90°로 굽혀 몸 옆에 붙이고 전완(팔꿈치 아래)을 밖으로 회전한다.(어깨 외회전)",
                "10~15회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "CB/CB-0015",
            "title": "케이블 벤트오버 로우(Cable Row, Bent over)",
            "thumb": "/assets/thumbs/CB-0015.png",
            "guide": [
                "무릎을 굽히고 서서 상체를 앞으로 숙이고 양쪽 팔을 뻗어 아래쪽에서 케이블을 잡는다.",
                "팔꿈치를 굽혀 등쪽으로 케이블을 끌어 올렸다 내린다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0017",
            "title": "싱글암 벤트오버 케이블 로우(Bent over Single Arm Cable Row)",
            "thumb": "/assets/thumbs/CB-0017.png",
            "guide": [
                "무릎을 굽히고 서서 상체를 앞으로 숙이고 한 쪽 팔을 뻗어 아래쪽에서 케이블을 잡는다.",
                "팔꿈치를 굽혀 등쪽으로 케이블을 끌어 올렸다 내린다.",
                "10~15회 3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "CB/CB-0016",
            "title": "케이블 리버스 플라이(Cable Reverse Fly, Standing)",
            "thumb": "/assets/thumbs/CB-0016.png",
            "guide": [
                "양손으로 케이블을 위에서 잡아 어깨높이 맞춰 뒤로 당긴다.(Reverse fly or Wide Row)",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0014",
            "title": "케이블 풀 다운(Cable Pull Down)",
            "thumb": "/assets/thumbs/CB-0014.png",
            "guide": [
                "무릎을 가볍게 굽혀 상체를 앞으로 기울이고 선다.",
                "양쪽 팔을 위로 뻗어 손으로 케이블을 잡고 아래로 당겨 몸 옆으로 내린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0024",
            "title": "90도 외전 90도 어깨 외회전(90degree abduction & External Rotation)",
            "thumb": "/assets/thumbs/CB-0024.png",
            "guide": [
                "케이블 앞으로 서서 한 손으로 손잡이를 잡는다.",
                "팔꿈치를 90°로 굽혀 어깨높이에 맞춰 옆으로 들어 올린다.(90°외전)",
                "상완(위 팔)을 고정한 채 전완(아래 팔)을 뒤쪽으로 90° 회전시킨다.(90°외회전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "CB/CB-0022",
            "title": "케이블 어깨 내회전(Shoulder Internal Rotation)",
            "thumb": "/assets/thumbs/CB-0022.png",
            "guide": [
                "케이블 옆으로 서서 안쪽 손으로 손잡이를 잡고 팔꿈치를 90°로 굽혀 몸에 붙인다.",
                "상완(팔꿈치 위)을 고정한 채 전완(팔꿈치 아래)을 안쪽으로 회전(내회전)한다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "CB/CB-0021",
            "title": "케이블 어깨 외회전(Shoulder External Rotation)",
            "thumb": "/assets/thumbs/CB-0021.png",
            "guide": [
                "옆으로 서서 바깥쪽 손에 케이블을 안에서 밖으로 잡고 팔꿈치를 90°로 굽혀 몸에 붙인다.",
                "상완(팔꿈치 위)을 고정하고 전완(팔꿈치 아래)을 바깥쪽으로 회전(외회전)한다.",
                "10~15회 반복하고, 팔을 바꿔 실시한다. 2~3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0010",
            "title": "케이블 프론트 레이즈(Cable Front Raise)",
            "thumb": "/assets/thumbs/CB-0010.png",
            "guide": [
                "양 손에 케이블을 뒤에서 앞으로 잡고 선다.",
                "팔꿈치를 편 채 두 팔을 앞으로 뻗어 어깨높이로 올린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0019",
            "title": "케이블 어깨 PNF D1 패턴 운동",
            "thumb": "/assets/thumbs/CB-0019.png",
            "guide": [
                "케이블 옆으로 서서 안쪽 손으로 케이블 손잡이를 아래쪽에서 잡고 어깨를 외회전하여 팔을 45°로 옆으로 벌린다.(외전)",
                "팔꿈치를 편 채 어깨를 내회전하여 케이블을 머리 위 대각선 방향으로 당겨 올린다.(내전)",
                "어깨를 외전하면서 팔을 내려 시작위치로 돌아온다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "CB/CB-0020",
            "title": "케이블 어깨 PNF D2 패턴 운동",
            "thumb": "/assets/thumbs/CB-0020.png",
            "guide": [
                "케이블 옆으로 서서 바깥쪽 손으로 케이블 손잡이를 잡고 어깨를 내회전하여 팔을 45° 안쪽으로 뻗는다.(내전)",
                "팔꿈치를 편 채 어깨를 외회전하여 팔을 머리 위 대각선 방향으로 들어 올린다.(외전)",
                "어깨를 내회전하면서 팔을 내려 시작위치로 돌아온다.",
                "10~15회 반복하여 2세트 실시한다."
            ]
        },
        {
            "id": "CB/CB-0001",
            "title": "케이블컬(Cable curl)",
            "thumb": "/assets/thumbs/CB-0001.png",
            "guide": [
                "손바닥이 위로 향하게 하여 양 손으로 케이블을 잡는다.",
                "팔꿈치를 굽혀 케이블을 가슴쪽으로 당겨 올린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0002",
            "title": "케이블 드래그 컬(Cable drag curl)",
            "thumb": "/assets/thumbs/CB-0002.png",
            "guide": [
                "손바닥이 위로 향하게 하여 양 손으로 케이블을 잡는다.",
                "팔꿈치를 굽히며 케이블을 등쪽으로 끌어 당긴다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0007",
            "title": "하이 케이블 컬(High Cable single arm curl)",
            "thumb": "/assets/thumbs/CB-0007.png",
            "guide": [
                "케이블 옆으로 서서 안 쪽 팔을 옆으로 들어 케이블을 어깨높이 또는 어깨보다 약간 높게 잡는다.",
                "팔꿈치를 굽혀 케이블을 당긴다.",
                "10~15회 반복하고 팔을 바꿔 실시한다. 2~3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0004",
            "title": "케이블 트라이셉 킥백(Triceps Kick back, cable or band)",
            "thumb": "/assets/thumbs/CB-0004.png",
            "guide": [
                "무릎을 가볍게 굽히고 상체를 45° 정도 앞으로 숙이고 선다.",
                "한 손에 케이블을 잡고 팔꿈치를 굽혀 몸 옆에 붙인 후 상완(위 팔)을 고정한 채 케이블을 당겨 팔꿈치를 편다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "CB/CB-0005",
            "title": "케이블 트라이셉 익스텐션(Triceps Extension)",
            "thumb": "/assets/thumbs/CB-0005.png",
            "guide": [
                "양 손에 케이블을 잡고 팔꿈치를 굽혀 몸 옆에 붙이고 선다.",
                "상완(위 팔)을 고정한 채 케이블을 당기면서 팔꿈치를 편다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "CB/CB-0006",
            "title": "케이블 오버헤드 트라이셉 익스텐션(Cable Overhead Triceps Extension",
            "thumb": "/assets/thumbs/CB-0006.png",
            "guide": [
                "케이블을 등지고 서서 두 손으로 케이블을 잡고 팔꿈치를 굽혀 머리 위로 들어 올린다.",
                "상완(위 팔)을 고정한 채 케이블을 당기면서 팔꿈치를 편다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "CB/CB-0025",
            "title": "케이블 사이드밴드(Cable Sidebend)",
            "thumb": "/assets/thumbs/CB-0025.png",
            "guide": [
                "케이블 옆으로 서서 안쪽 손으로 케이블을 잡는다.",
                "가슴을 펴고 골반을 고정한 채 상체를 케이블 반대쪽으로 최대한 기울인다.(측굴)",
                "10~15회 반복 후 반대쪽으로 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0027",
            "title": "케이블 러시안 트위스트(Cable Russian Twist-Trunk Rotation)",
            "thumb": "/assets/thumbs/CB-0027.png",
            "guide": [
                "케이블 옆에 서서 팔을 가슴앞으로 뻗어 두 손을 모아 케이블을 잡는다.",
                "다리를 고정한 채 흉추를 회전하면서 케이블을 바깥방향으로 끌어 당긴다.",
                "10~15회 반복 후 반대쪽으로 실시하여 2~3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0034",
            "title": "짐볼 안고 케이블 몸통 회전(Cable Trunk rotation with Stability ball)",
            "thumb": "/assets/thumbs/CB-0034.png",
            "guide": [
                "케이블을 옆으로 두고 서서 가슴높이에서 양 팔로 짐볼을 안고 바깥쪽 손으로 케이블을 잡는다.",
                "다리를 고정한 채 흉추를 회전하면서 케이블을 바깥방향으로 끌어 당긴다.",
                "10~15회 반복 후 반대쪽으로 실시하여 2~3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0029",
            "title": "케이블 리버스 우드 챱(Cable Reverse wood chop)",
            "thumb": "/assets/thumbs/CB-0029.png",
            "guide": [
                "케이블 옆으로 무릎을 굽히고 서서 팔을 앞으로 뻗어 케이블을 아래쪽에서 잡는다.",
                "무릎을 펴면서 팔을 바깥쪽 대각선 방향으로 뻗어 올린다.",
                "10~15회 반복 후 반대쪽으로 실시하여 2~3세트 수행한다."
            ]
        },
        {
            "id": "CB/CB-0030",
            "title": "케이블 우드 챱(Cable wood chop)",
            "thumb": "/assets/thumbs/CB-0030.png",
            "guide": [
                "케이블 옆으로 서서 머리 위 대각선 방향으로 팔을 뻗어 케이블을 위쪽에서 잡는다.",
                "무릎을 굽히며 팔을 대각선 방향으로(무릎 바깥쪽)으로 뻗어 내린다.",
                "10~15회 반복 후 반대쪽으로 실시하여 2~3세트 수행한다."
            ]
        },
        {
            "id": "CB/CB-0038",
            "title": "케이블 스탠딩 힙 익스텐션(Cable Hip Extension, standing)",
            "thumb": "/assets/thumbs/CB-0038.png",
            "guide": [
                "한 쪽 발목에 케이블을 앞에서 뒤로 걸고 선다.",
                "케이블을 건 다리를 뒤로 뻗는다.(고관절 신전)",
                "10~15회 반복 후 다리를 바꿔 실시한다.",
                "2~3세트 수행한다."
            ]
        },
        {
            "id": "CB/CB-0036",
            "title": "케이블 레그 어브덕션(Cable Leg Abduction)",
            "thumb": "/assets/thumbs/CB-0036.png",
            "guide": [
                "케이블 옆으로 서서 바깥쪽 발목에 케이블을 건다.",
                "케이블을 건 다리를 옆으로 뻗어 올린다.(고관절 외전)",
                "10~15회 반복 후 다리를 바꿔 실시한다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0035",
            "title": "케이블 풀 스로우(Cable pull through)",
            "thumb": "/assets/thumbs/CB-0035.png",
            "guide": [
                "케이블을 등지고 서서 양 손을 모아 다리 사이로 케이블을 잡는다.",
                "무릎을 굽히고 앉았다 일어나면서 양팔을 뻗어 케이블을 어깨 높이로 들어 올린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0037",
            "title": "케이블 힙 플렉션(Cable Hip Flexion)",
            "thumb": "/assets/thumbs/CB-0037.png",
            "guide": [
                "케이블을 등지고 서서 한 쪽 발목에 케이블을 건다.",
                "케이블을 건 다리의 무릎을 굽혀 가슴높이까지 들어 올렸다 내린다.",
                "10~15회 반복 후 다리를 바꿔 실시한다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0036",
            "title": "케이블 힙 어브덕션(Cable Hip abduction)",
            "thumb": "/assets/thumbs/CB-0036.png",
            "guide": [
                "케이블 옆으로 서서 바깥쪽 다리의 발목에 케이블을 건다.",
                "다리를 옆으로 뻗어 올렸다(고관절 외전) 내린다.",
                "10~15회 반복 후 다리를 바꿔 실시한다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0040",
            "title": "케이블 레그 컬(Cable Leg Curl)",
            "thumb": "/assets/thumbs/CB-0040.png",
            "guide": [
                "케이블을 정면에 두고 서서 한 쪽 발목에 케이블을 건다.",
                "케이블을 건 다리의 무릎을 굽혀 뒤꿈치를 엉덩이 쪽으로 끌어 올렸다 내린다.",
                "(이 때 무릎이 앞으로 밀리지 않도록 하고, 필요 시 케이블 머신을 잡아 자세를 유지할 수 있도록 한다.)",
                "10~15회 반복 후 다리를 바꿔 실시한다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "GolfCon/GolfCon-0057",
            "title": "90도 외전 90도 어깨 내회전(Shoulder 90 degree abduction & internal rotation)",
            "thumb": "/assets/thumbs/GolfCon-0057.png",
            "guide": [
                "케이블을 등지고 서서 한 손으로 손잡이를 잡는다.",
                "팔꿈치를  90°로 굽혀 어깨높이에 맞춰 옆으로 들어 올린(90°외전) 후 전완(아래 팔)을 수직으로 세운다.",
                "상완(위 팔)을 고정한 채 전완(아래 팔)을 앞쪽으로 90° 회전시킨다.(90°내회전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "CB/CB-0003",
            "title": "케이블 어깨굴곡(Cable Shoulder Flexion)",
            "thumb": "/assets/thumbs/CB-0003.png",
            "guide": [
                "케이블을 등지고 서서 양 손으로 손잡이를 잡는다.",
                "팔꿈치를 편 채 양 팔을 가슴앞으로 당겨 올렸다 내린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0031",
            "title": "케이블 스쿼트 & 로우(Cable Squat & row)",
            "thumb": "/assets/thumbs/CB-0031.png",
            "guide": [
                "양쪽 손으로 케이블 손잡이를 잡고 선다.",
                "팔을 편 채 무릎을 굽혀 앉았다 일어서면서 팔꿈치를 굽혀 케이블을 뒤쪽으로 끌어 당긴다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0018",
            "title": "싱글암 케이블 리버스 플라이(Single Arm Cable reverse fly(Horizontal abduction)",
            "thumb": "/assets/thumbs/CB-0018.png",
            "guide": [
                "케이블을 옆에 두고 선다. 한 팔을 뻗어 케이블을 안쪽에서 잡고 상체를 숙인다. 케이블을 등쪽으로 당기면서 팔꿈치를 편다(수평외전). 10 ~15회 2~3세트 반복한다. 반대쪽도 실시한다."
            ]
        },
        {
            "id": "CB/CB-0023",
            "title": "케이블 숄더 프레스(Cable shoulder press)",
            "thumb": "/assets/thumbs/CB-0023.png",
            "guide": [
                "벤치에 앉거나 서서 어깨 높이에서 팔꿈치를 굽혀 두 손으로 케이블을 잡는다. 팔꿈치를 펴 머리위로 뻗어 올린다. 10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0026",
            "title": "케이블 사이드 스쿼트(Cable side squat)",
            "thumb": "/assets/thumbs/CB-0026.png",
            "guide": [
                "케이블을 옆에서 잡고 무릎을 굽혀 스쿼트 한다. 10~15회 2~3세트 반복한다. 반대쪽도 실시한다."
            ]
        },
        {
            "id": "CB/CB-0027",
            "title": "케이블 수평회전(Horizontal Trunk Rotation)",
            "thumb": "/assets/thumbs/CB-0027.png",
            "guide": [
                "케이블을 옆에 두고 두 팔을 앞으로 뻗어 케이블을 잡는다. 몸통을 수평으로 오른쪽 왼쪽 회전한다. 10 ~15회 3세트 반복한다."
            ]
        },
        {
            "id": "CB/CB-0028",
            "title": "케이블 싱글암 스쿼트 & 로우(Single arm squat & row)",
            "thumb": "/assets/thumbs/CB-0028.png",
            "guide": [
                "한 손으로 케이블을 잡는다. 케이블 잡은 쪽(오른쪽) 다리를 들어올린다. 지지하고 있는 무릎을 굽혀 앉으면서 팔을 뻗는다. 무릎을 펴 일어나면서 팔꿈치를 굽혀 케이블을 당긴다. 10~15회 2~3세트 반복한다. 반대쪽도 실시한다."
            ]
        },
        {
            "id": "CB/CB-0033",
            "title": "케이블 킥(Cable Kick)",
            "thumb": "/assets/thumbs/CB-0033.png",
            "guide": [
                "한 손을 뻗어 케이블을 정면에서 잡는다. 반대쪽 무릎을 가슴 높이로 들어 올리면서(kick) 일어나면서 팔을 굽혀 케이블을 당긴다. 처음 시작 위치로 돌아가서 10~15회 2~3세트 반복한다. 반대쪽도 실시한다."
            ]
        },
    ],
    "kettlebell": [
        {
            "id": "KB/KB-0002",
            "title": "케틀벨 데드리프트(Dead lift)",
            "thumb": "/assets/thumbs/KB-0002.png",
            "guide": [
                "다리를 어깨넓이로 벌리고 서서 두 손으로 케틀벨을 잡는다.",
                "무릎과 고관절(hinge joint)을 굽혀 케틀벨이 바닥에 닿을 때까지 내렸다 시작자세로 돌아온다.",
                "이 때 허리가 꺾이지 않게 주의하고, 10~15회 반복하여 3세트 실시한다.",
                "※ 케틀벨을 든 팔이 내려가는 정도는 바닥에서 약 20~30cm까지로 스텝박스 등을 활용한다."
            ]
        },
        {
            "id": "KB/KB-0003",
            "title": "숫자 8(Figure 8)",
            "thumb": "/assets/thumbs/KB-0003.png",
            "guide": [
                "오른손에 케틀벨을 들고 선다.",
                "무릎을 굽히고 상체를 숙여 케틀벨을 왼쪽 무릎 안에서 밖으로 교차하여 왼손으로 잡는다.",
                "왼손의 케틀벨을 오른쪽 무릎 안에서 밖으로 교차하여 오른손으로 잡는다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "KB/KB-0007",
            "title": "케틀벨 싱글암 스윙(Single arm swing)",
            "thumb": "/assets/thumbs/KB-0007.png",
            "guide": [
                "한 쪽 팔을 다리 사이로 뻗어 내려 케틀벨을 잡고, 무릎을 굽혀 앉는다.",
                "무릎을 펴 일어서면서 반동을 이용해 팔을 가슴앞으로 들어 올린다.",
                "10~15회 반복 후 팔을 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "KB/KB-0012",
            "title": "케틀벨 로우(Row)",
            "thumb": "/assets/thumbs/KB-0012.png",
            "guide": [
                "오른발을 앞으로 보내 무릎을 가볍게 굽히고 상체를 숙인다.",
                "자세를 유지한 채 왼팔을 아래로 뻗어 케틀벨을 잡고 팔꿈치를 굽혀 케틀벨을 등쪽으로 끌어 올린다.",
                "10~15회 반복 후 반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "KB/KB-0016",
            "title": "케틀벨 싱글레그 데드리프트(Kettlebell Single leg deadlift)",
            "thumb": "/assets/thumbs/KB-0016.png",
            "guide": [
                "한 발로 서서 반대쪽 손에 케틀벨을 들고 팔을 아래로 내린다.",
                "바닥을 지지한 다리를 가볍게 굽히고 상체를 앞으로 기울이면서 반대쪽 다리는 엉덩이 높이까지 뒤로 뻗는다.",
                "단, 상체는 고관절(hinge joint)의 움직임에 의해 자연스럽게 숙여지도록 한다.",
                "10~15회 반복하여 3세트 실시한다.",
                "※ 케틀벨을 든 팔이 내려가는 정도는 바닥에서 약 20~30cm까지로 스텝박스 등을 활용한다."
            ]
        },
        {
            "id": "KB/KB-0001",
            "title": "케틀벨 몸통회전(Around the body pass)",
            "thumb": "/assets/thumbs/KB-0001.png",
            "guide": [
                "케틀벨을 잡고 서서 몸의 앞뒤로 손을 바꿔가며 케틀벨을 돌린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "KB/KB-0004",
            "title": "케틀벨 스쿼트(Squat)",
            "thumb": "/assets/thumbs/KB-0004.png",
            "guide": [
                "다리를 어깨넓이로 벌리고 서서 팔꿈치를 굽혀 두 손으로 케틀벨을 잡아 가슴높이로 올린다.",
                "무릎을 90°로 굽혀 앉았다 일어선다. 10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "KB/KB-0005",
            "title": "케틀벨 하프 켓업(Half get up)",
            "thumb": "/assets/thumbs/KB-0005.png",
            "guide": [
                "팔 다리를 펴고 바로 눕는다.",
                "한 팔을 가슴앞으로 뻗어 케틀벨을 들고 같은 쪽 무릎을 가볍게 굽힌다.",
                "케틀벨의 위치를 고정한 채 바닥에 둔 팔로 지지하여 상체를 일으킨다. 10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "KB/KB-0006",
            "title": "케틀벨 스윙(Swing)",
            "thumb": "/assets/thumbs/KB-0006.png",
            "guide": [
                "팔을 다리 사이로 뻗어 내려 두 손으로 케틀벨을 잡고 무릎을 굽혀 앉는다.",
                "무릎을 펴 일어서면서 반동을 이용해 팔을 가슴앞으로 들어 올린다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "KB/KB-0008",
            "title": "케틀벨 클린(Clean)",
            "thumb": "/assets/thumbs/KB-0008.png",
            "guide": [
                "한 손으로 케틀벨을 잡고 팔을 내려 무릎 사이에 두고 무릎을 굽혀 앉는다.",
                "일어나면서 한 팔을 어깨 높이로 들어 올리면서 연속적으로 팔을 굽혀 머리 위로 들어 올린다.",
                "처음 시작 위치로 돌아와 반복한다. 10회 3세트 수행 후 반대쪽도 실시한다."
            ]
        },
        {
            "id": "KB/KB-0009",
            "title": "케틀벨 윈드밀(Kettlebell Windmill)",
            "thumb": "/assets/thumbs/KB-0009.png",
            "guide": [
                "다리를 넓게 벌리고 서서 왼팔을 머리 위로 뻗어 케틀벨을 잡는다.",
                "왼팔의 위치를 고정한 채 상체를 오른쪽으로 기울여(측굴) 오른팔을 발등까지 내린다.",
                "10~15회 반복 후 반대쪽으로 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "KB/KB-0010",
            "title": "원 핸드 스내치(One hand Snatch)",
            "thumb": "/assets/thumbs/KB-0010.png",
            "guide": [
                "오른팔을 아래로 내려 케틀벨을 잡고 왼팔은 어깨높이에 맞춰 옆으로 뻗는다.",
                "무릎을 굽혀 앉았다 일어서면서 팔꿈치를 굽혀 케틀벨을 어깨높이로 들어 올리고 잠시 멈춘다.",
                "다시 팔을 뻗어 케틀벨을 머리 위로 들어 올린다.",
                "10~15회 반복 후 반대쪽으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "KB/KB-0011",
            "title": "케틀벨 런지 푸시(Lunge with push)",
            "thumb": "/assets/thumbs/KB-0011.png",
            "guide": [
                "두 손으로 케틀벨을 잡아 가슴쪽에 붙이고 선다.",
                "한 쪽 다리를 충분히 앞으로 보내 무릎을 굽혀 앉으면서 팔을 가슴앞으로 뻗는다.",
                "다리를 바꿔가며 10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "KB/KB-0014",
            "title": "케틀벨 푸시프레스(Push Press)",
            "thumb": "/assets/thumbs/KB-0014.png",
            "guide": [
                "오른손으로 케틀벨을 들고 팔꿈치를 굽혀 옆으로 들어 올리고, 왼팔은 어깨높이에 맞춰 옆으로 뻗는다.",
                "무릎을 굽혀 앉았다 일어서면서 오른팔을 펴서 케틀벨을 머리 위로 들어 올린다.",
                "10~15회 반복 후 팔을 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "KB/KB-0015",
            "title": "케틀벨 사이드플랭크 & 로우(Side Plank Row)",
            "thumb": "/assets/thumbs/KB-0015.png",
            "guide": [
                "왼손으로 케틀벨을 잡고 엎드려 푸쉬업 자세를 만든다.",
                "왼팔을 굽혀 케틀벨을 등쪽으로 끌어 당기면서 몸통을 왼쪽으로 회전하여 사이드 플랭크 자세를 만든다.",
                "10회 반복 후 팔을 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "KB/KB-0018",
            "title": "케틀벨 우드챱(Wood chop)",
            "thumb": "/assets/thumbs/KB-0018.png",
            "guide": [
                "무릎을 굽히고 앉아서 두 손으로 케틀벨을 잡아 팔을 왼쪽 대각선 방향으로 뻗어 내린다.",
                "무릎을 펴고 일어서 몸통을 틀면서 케틀벨과 함께 팔을 오른쪽 대각선 방향으로 뻗어 올린다.",
                "10~15회 반복 후 반대쪽으로 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "KB/KB-0019",
            "title": "케틀벨 바이셉컬(Biceps Curl)",
            "thumb": "/assets/thumbs/KB-0019.png",
            "guide": [
                "손바닥을 앞으로 향하게 하여 양 손에 케틀벨을 각각 들고 선다.",
                "교대로 팔꿈치를 굽혀 케틀벨을 가슴까지 들어 올렸다 내린다. 10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "KB/KB-0020",
            "title": "케틀벨 트라이셉스(Triceps extension)",
            "thumb": "/assets/thumbs/KB-0020.png",
            "guide": [
                "양쪽 팔을 위로 올려서 팔꿈치를 굽혀 머리 뒤로 케틀벨을 잡는다.",
                "상완(위 팔)을 고정한 채 팔꿈치를 펴서 케틀벨을 머리 위로 들어 올렸다 내린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "KB/KB-0021",
            "title": "케틀벨 겟업(Get up)",
            "thumb": "/assets/thumbs/KB-0021.png",
            "guide": [
                "1. 누운 자세(supine) - 바로 누워 한 팔을 가슴앞으로 뻗어 케틀벨을 들고, 같은 쪽 무릎을 굽힌다.",
                "2. 앉은 자세(Tall Sit) - 앞으로 뻗은 팔을 그대로 유지한 채 바닥에 둔 팔로 지지하여 상체를 일으켜 앉는다.",
                "3. 하프닐 자세(Half-Kneel) - 골반을 들고 뻗은 다리를 뒤로 보내 무릎을 꿇는다.",
                "4. 선 자세(Standing) - 양 쪽 무릎을 펴며 일어난다.",
                "5. 역순으로 자세를 만들며(하프닐 자세, 앉은 자세, 누운 자세) 시작 위치로 돌아온다.",
                "6. 10~15회 반복 후 반대쪽으로 실시하고, 2~3세트 수행한다."
            ]
        },
        {
            "id": "KB/KB-0022",
            "title": "케틀벨 레니게이드 로우(Renegade Row)",
            "thumb": "/assets/thumbs/KB-0022.png",
            "guide": [
                "푸쉬업 자세로 엎드려 한 손에 케틀벨을 잡는다.",
                "머리부터 발까지 사선을 유지한 채 케틀벨을 잡은 팔을 90°로 굽혀 덤벨을 등쪽으로 끌어 올린다.",
                "10~15회 반복 후 반대쪽으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "KB/KB-0023",
            "title": "케틀벨 오블리끄 트위스트(Oblique twist)",
            "thumb": "/assets/thumbs/KB-0023.png",
            "guide": [
                "무릎을 가볍게 굽혀 양 발을 띄우고 앉아 두 손으로 케틀벨을 잡는다.",
                "몸통과 함께 가슴 높이에서 케틀벨을 좌우로 회전한다. 10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "KB/KB-0024",
            "title": "케틀벨 싯업(Sit up)",
            "thumb": "/assets/thumbs/KB-0024.png",
            "guide": [
                "바닥에 등을 대고 누워 무릎을 굽히고, 가슴앞에서 두 손으로 케틀벨을 잡는다.",
                "복부를 수축하여 케틀벨과 함께 상체를 세웠다 천천히 누우면서 원위치로 돌아온다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "KB/KB-0013",
            "title": "케틀벨 사이드런지 & 패스(Lateral Lunge and Pass)",
            "thumb": "/assets/thumbs/KB-0013.png",
            "guide": [
                "왼손에 케틀벨을 들고 다리를 넓게 벌리고 선다.",
                "오른쪽 무릎을 굽히고 상체를 숙여 케틀벨을 안쪽에서 보내고 바깥쪽에서 오른손으로 받는다.",
                "팔을 바꿔가며 10~15회 반복하여 3세트 실시한다."
            ]
        },
    ],

    "band": [
        {
            "id": "Band/Band-0026",
            "title": "밴드 푸시업(Band Push up)",
            "thumb": "/assets/thumbs/Band-0026.png",
            "guide": [
                "밴드를 등 뒤로 돌려 양손으로 고정하고 엎으려 머리부터 발까지 사선을 만든다.",
                "팔꿈치를 굽혀 가슴이 바닥에 닿기 전까지 몸을 내렸다 팔꿈치를 펴서 올라온다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0021",
            "title": "밴드 브릿지(Glute Bridge)",
            "thumb": "/assets/thumbs/Band-0021.png",
            "guide": [
                "양쪽 다리에 밴드를 걸어 무릎을 굽히고 바르게 눕는다.",
                "골반을 들어 올려 어깨부터 무릎까지 사선형태를 만들고 5초간 유지한다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0013",
            "title": "밴드 외회전(Band Pull apart-Horizontal abduction)",
            "thumb": "/assets/thumbs/Band-0013.png",
            "guide": [
                "양 손에 밴드를 잡고 팔을 가슴앞으로 뻗어 어깨넓이로 벌린다.",
                "밴드의 저항을 느끼며 양 팔을 수평으로 벌린다.",
                "견갑골사이를 수축시켰다 풀고 처음 위치로 돌아온다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0006",
            "title": "밴드 벤트오버 로우(Band Shoulder Row, Standing)",
            "thumb": "/assets/thumbs/Band-0006.png",
            "guide": [
                "양손으로 밴드를 잡고 발고 밴드의 가운데를 고정하고 선다.",
                "무릎을 굽혀 상체를 앞으로 숙이고 팔을 편다.",
                "팔꿈치를 90°로 굽혀 밴드를 등쪽으로 끌어 당겨 등(견갑골 사이)을 수축시킨다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0015",
            "title": "밴드 시티드 로우(Band Row, Seated)",
            "thumb": "/assets/thumbs/Band-0015.png",
            "guide": [
                "양쪽 다리를 앞으로 뻗고 앉아 발에 밴드를 걸어 두 손으로 잡고 팔꿈치를 편다.",
                "팔꿈치를 90°로 굽혀 밴드를 등쪽으로 당기고 등을 수축시킨다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0027",
            "title": "밴드저항 족저굴곡운동(Plantar Flexion With Resistance Band)",
            "thumb": "/assets/thumbs/Band-0027.png",
            "guide": [
                "한 쪽 다리를 펴고 앉아 밴드를 발바닥에 걸고 양 손으로 잡는다.",
                "밴드를 밀어내듯 발목을 바닥쪽으로 신전(폄)시켰다(족저굴곡) 돌아온다.",
                "10~15회 반복 후 발을 바꿔 실시한다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0028",
            "title": "밴드저항 족배굴곡운동(Dorsi Flexion, Band)",
            "thumb": "/assets/thumbs/Band-0028.png",
            "guide": [
                "한 쪽 다리를 펴고 앉아 밴드를 발등에 건다.",
                "밴드를 끌어당기듯 발목을 발등쪽으로 굽혔다(족배굴곡) 돌아온다.",
                "10~15회 반복 후 발을 바꿔 실시한다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0029",
            "title": "밴드저항 외반운동(Eversion exercise, band)",
            "thumb": "/assets/thumbs/Band-0029.png",
            "guide": [
                "다리를 펴고 앉아 한 쪽 발에 밴드를 걸어 안쪽에서 잡아 고정한다.",
                "발등을 바깥방향으로 들어 올리듯 발목을 외반한다.(발목을 바깥으로 돌리는 외회전이 아님을 유의)",
                "10~15회 반복 후 발을 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0030",
            "title": "밴드저항 내반운동(Inversion exercise, band)",
            "thumb": "/assets/thumbs/Band-0030.png",
            "guide": [
                "다리를 펴고 앉아 한 쪽 발에 밴드를 걸어 바깥쪽에서 잡아 고정한다.",
                "발등을 안쪽 방향으로 들어 올리듯 발목을 내반한다.(발목을 안으로 돌리는 내회전이 아님을 유의)",
                "10~15회 반복 후 발을 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0032",
            "title": "밴드저항 몬스터 스텝(Band Monster step)",
            "thumb": "/assets/thumbs/Band-0032.png",
            "guide": [
                "다리를 모아 무릎 약간 위쪽에 밴드를 묶고 선다.",
                "무릎을 굽힌 상태로 고관절을 크게 밖으로 돌리면서(외회전) 앞, 뒤로 각각 10보씩 걷는다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0034",
            "title": "밴드저항 고관절 굴곡(Band Knee up)",
            "thumb": "/assets/thumbs/Band-0034.png",
            "guide": [
                "양 쪽 발에 밴드를 걸고 서서 한 쪽 무릎을 굽혀 가슴쪽으로 끌어 올렸다 내린다.",
                "10~15회 반복 후 다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0033",
            "title": "밴드저항 사이드 워킹(Band side walk, 게걸음)",
            "thumb": "/assets/thumbs/Band-0033.png",
            "guide": [
                "다리를 어깨넓이 보다 좁게 벌리고 서서 발목에 밴드를 건다.",
                "무릎을 굽힌 상태로 발을 어깨넓이 보다 넓게 벌리며 오른쪽, 왼쪽으로 각각 10보씩 걷는다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0008",
            "title": "밴드 스쿼트(Squat)",
            "thumb": "/assets/thumbs/Band-0008.png",
            "guide": [
                "발로 밴드를 고정하고 서서 양쪽 팔꿈치를 굽혀 어깨 위에서 밴드를 잡는다.",
                "무릎을 90°로 굽혀 앉았다 일어선다. 10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0016",
            "title": "밴드 레그프레스-앉아서(Leg Press, sitting)",
            "thumb": "/assets/thumbs/Band-0016.png",
            "guide": [
                "무릎을 구부리고 앉아 왼발에 밴드를 걸고 왼손으로 밴드를 고정한다.",
                "왼쪽 다리를 들어 밴드의 저항을 느끼면서 무릎을 편다.",
                "10~15회 반복 후 반대쪽으로 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0003",
            "title": "밴드 숄더 프레스(Shoulder Press, Seated)",
            "thumb": "/assets/thumbs/Band-0003.png",
            "guide": [
                "발로 밴드를 고정하고 손으로 양 끝을 잡는다.",
                "양 팔을 어깨높이에 맞춰 옆으로 뻗은 후 90°로 굽혀 손바닥이 앞을 향하게 한다.",
                "팔을 수직으로 펴서 밴드를 머리 위로 끌어 올린다. 10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0029",
            "title": "밴드 외반(Eversion exercise, band)",
            "thumb": "/assets/thumbs/Band-0029.png",
            "guide": [
                "다리를 펴고 앉아 한 쪽 발에 밴드를 걸어 안쪽에서 잡아 고정한다.",
                "발등을 바깥방향으로 들어 올리듯 발목을 외반한다.(발목을 바깥으로 돌리는 외회전이 아님을 유의)",
                "10~15회 반복 후 발을 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0001",
            "title": "밴드 바이셉 컬(Biceps Curl)",
            "thumb": "/assets/thumbs/Band-0001.png",
            "guide": [
                "손바닥이 앞을 향하게 하여 양 손으로 밴드를 잡고 선다.",
                "팔꿈치를 굽혀 밴드를 가슴까지 끌어 올렸다 내린다. 10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0002",
            "title": "밴드 트라이셉 익스텐션(Triceps Extension)",
            "thumb": "/assets/thumbs/Band-0002.png",
            "guide": [
                "왼쪽 팔꿈치를 굽혀 수직으로 들어 올리고, 오른손은 허리 뒤로 보내 밴드 양 끝을 잡는다.",
                "왼쪽 팔꿈치를 펴서 밴드를 머리 위로 당겨 올렸다 원위치로 돌아온다.",
                "10~15회 반복 후 팔을 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0004",
            "title": "밴드 랫풀(Band Lat Pull, Standing)",
            "thumb": "/assets/thumbs/Band-0004.png",
            "guide": [
                "팔을 어깨넓이 보다 넓게 벌리고 가슴앞으로 뻗어 밴드를 잡는다.",
                "팔을 위로 들어 올렸다 밴드를 당기면서 팔을 어깨높이에 맞춰 옆으로 벌린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0005",
            "title": "밴드 솔더 로우(Shoulder Row, Standing)",
            "thumb": "/assets/thumbs/Band-0005.png",
            "guide": [
                "양 팔을 어깨넓이로 벌리고 가슴앞으로 뻗어 밴드를 잡는다.",
                "한 팔은 고정한 채 반대쪽 팔을 굽혀 밴드를 뒤로 당긴다.",
                "10~15회 반복 후 팔을 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0006",
            "title": "밴드 벤트오버 로우(Bent or Row, Standing)",
            "thumb": "/assets/thumbs/Band-0006.png",
            "guide": [
                "무릎을 가볍게 굽히고 상체를 앞으로 숙이고 선다.",
                "팔을 아래로 뻗어 밴드의 양 끝을 잡고 발로 고정한 후 팔꿈치를 굽히면서 밴드를 당겨 올린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0007",
            "title": "밴드 리버스 우드 챱(Reverse wood chop)",
            "thumb": "/assets/thumbs/Band-0007.png",
            "guide": [
                "밴드를 왼발로 고정하고 두 손으로 밴드를 모아 잡고 선다.",
                "무릎을 굽혀 앉아 팔을 왼쪽 대각선 방향으로 뻗어 내린다.",
                "무릎을 펴 일어서면서 팔을 오른쪽 대각선 방향으로 뻗어 올린다.",
                "10~15회 반복 후 반대쪽으로 실시하고,  2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0009",
            "title": "밴드 런지(Lunge)",
            "thumb": "/assets/thumbs/Band-0009.png",
            "guide": [
                "한 발을 충분히 앞으로 보내 밴드를 걸고 밴드 양 끝을 손으로 잡는다.",
                "무릎을 90°로 굽혀 수직으로 앉았다 일어선다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Band/Band-0010",
            "title": "밴드 어깨 외회전(Shoulder External rotation)",
            "thumb": "/assets/thumbs/Band-0010.png",
            "guide": [
                "밴드를 팔꿈치 높이로 고정하고 옆으로 선다.",
                "바깥쪽 손으로 밴드를 잡고 팔꿈치를 90°로 굽혀 상완(팔꿈치 위)을 몸 옆에 붙인다.",
                "상완을 고정한 채 전완(팔꿈치 아래)을 바깥쪽으로 회전시켰다 천천히 원위치로 돌아온다.",
                "10~15회 반복 후 반대쪽으로 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0011",
            "title": "밴드 어깨 내회전(Shoulder Internal rotation)",
            "thumb": "/assets/thumbs/Band-0011.png",
            "guide": [
                "밴드를 팔꿈치 높이로 고정하고 옆으로 선다.",
                "안쪽 손으로 밴드를 잡고 팔꿈치를 90°로 굽혀 상완(팔꿈치 위)을 몸 옆에 붙인다.",
                "상완을 고정한 채 전완(팔꿈치 아래)을 안쪽으로 회전시켰다 천천히 원위치로 돌아온다.",
                "10~15회 반복 후 반대쪽으로 실시하고, 2~3세트 반복한다.",
                "밴드를 잡고 팔꿈치를 90도 굽혀 몸통 옆쪽에 붙인다. 이때 필요하다면 팔과 몸통 사이에 수건 등을 두는 것도 좋다.",
                "상완(위팔)을 고정하고 전완(아래팔)을 몸통 안으로 회전(내회전)시킨다.",
                "처음 시작 위치로 돌아온다. 10~15회 반복 후 다른 팔을 운동하고 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0012",
            "title": "밴드 어깨 90도 외전 90도 외회전(Shoulder 90 degree abduction & External rotation)",
            "thumb": "/assets/thumbs/Band-0012.png",
            "guide": [
                "두 손으로 밴드를 잡고 팔꿈치를 90°로 굽혀 어깨높이에 맞춰 옆으로 들어 올린다.(90° 외전)",
                "상완(위 팔)을 고정한 채 전완(아래 팔)을 뒤쪽으로 90° 회전시킨다.(90° 외회전)",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "Band/Band-0013",
            "title": "밴드 수평외전(Pull Apart)",
            "thumb": "/assets/thumbs/Band-0013.png",
            "guide": [
                "양 손으로 밴드를 잡고 팔을 가슴앞으로 뻗는다.",
                "밴드를 당기며 팔을 양 옆으로 벌렸다 천천히 시작자세로 돌아온다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0014",
            "title": "밴드 월 슬라이드(Wall slide)",
            "thumb": "/assets/thumbs/Band-0014.png",
            "guide": [
                "루프밴드를 양 쪽 손에 끼워 약간 벌리고 벽에 기댄다.",
                "밴드를 벌린 채 벽을 가볍게 쓸 듯이 밴드를 가슴높이로부터 시작하여 머리 위로 올렸다 내린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0015",
            "title": "밴드 시티드 로우(Seated Row)",
            "thumb": "/assets/thumbs/Band-0015.png",
            "guide": [
                "다리를 펴고 앉아 발바닥에 밴드를 걸어 고정하고 팔을 뻗어 양 끝을 잡는다.",
                "팔꿈치를 굽히면서 밴드를 뒤로 끌어 당긴다. 10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0017",
            "title": "밴드 레그프레스-누워서(Leg Press, supine)",
            "thumb": "/assets/thumbs/Band-0017.png",
            "guide": [
                "양쪽 무릎을 굽혀서 들어 올려 발에 밴드를 걸고 팔로 끝을 고정한다.",
                "밴드를 밀어 내면서 무릎을 폈다 원위치로 돌아온다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0018",
            "title": "밴드 누워서 고관절 외전(Hip Abduction, supine)",
            "thumb": "/assets/thumbs/Band-0018.png",
            "guide": [
                "다리에 루프밴드를 걸고 바로 누워 무릎을 굽힌다.",
                "발을 고정한 채 무릎을 양 옆으로 벌렸다(외전) 원위치로 돌아온다.",
                "10~15회 3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0019",
            "title": "밴드 고관절 외회전(Hip external rotation-Clamshell)",
            "thumb": "/assets/thumbs/Band-0019.png",
            "guide": [
                "다리에 밴드를 걸어 무릎을 굽히고 옆으로 눕는다.",
                "발을 고정한 채 위쪽 무릎을 바깥쪽으로 회전시켰다(외회전) 원위치로 돌아온다.",
                "10~15회 반복 후 반대쪽으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0020",
            "title": "밴드 고관절 외전-옆으로 누워서(Abduction, Straight Leg)",
            "thumb": "/assets/thumbs/Band-0020.png",
            "guide": [
                "옆으로 누워 다리를 일자로 펴서 밴드를 건다.",
                "위쪽 다리를 옆으로 들어 올렸다(외전) 원위치로 돌아온다.",
                "10~15회 반복 후 반대쪽으로 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0022",
            "title": "밴드 싱글레그 브릿지(Single leg glute bridge)",
            "thumb": "/assets/thumbs/Band-0022.png",
            "guide": [
                "양쪽 다리에 밴드를 걸고 무릎을 굽혀 바르게 눕는다.",
                "한 발로 지지하여 골반을 들어 올리고 반대쪽 다리는 허벅지 높이로 뻗어 올린다.",
                "10~15회 반복 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0023",
            "title": "밴드 브릿지 & 고관절 굴곡(Glute bridge & Hip flexion)",
            "thumb": "/assets/thumbs/Band-0023.png",
            "guide": [
                "양쪽 다리에 밴드를 걸고 무릎을 굽혀 바르게 눕는다.",
                "골반을 들어 올려 어깨에서 무릎까지 사선형태를 만든 후 한 쪽 무릎을 가슴쪽으로 당긴다.",
                "10~15회 반복 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0024",
            "title": "밴드 솔더 브릿지(Shoulder Bridge, Single Leg)",
            "thumb": "/assets/thumbs/Band-0024.png",
            "guide": [
                "오른쪽 다리를 펴 발에 밴드를 걸고 끝을 손으로 잡고 눕는다.",
                "왼쪽 다리로 지지하여 골반을 들어 올린 후 오른쪽 다리를 위로 올렸다 내린다.",
                "10~15회 반복 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0025",
            "title": "밴드 리버스 브릿지(Reverse Bridge, Quadruped)",
            "thumb": "/assets/thumbs/Band-0025.png",
            "guide": [
                "무릎을 굽히고 누워 골반위치에 밴드를 두고 양 끝을 손으로 고정한다.",
                "골반을 들어 올려 어깨부터 무릎까지 사선형태를 만들어 5초간 유지한 후 천천히 원위치로 돌아온다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0026",
            "title": "밴드 푸시업(Push up)",
            "thumb": "/assets/thumbs/Band-0026.png",
            "guide": [
                "푸쉬업 자세로 엎드려 밴드를 등에 가로로 두고 양 끝을 손으로 고정한다.",
                "팔꿈치를 굽혀 몸을 바닥쪽으로 내렸다 팔꿈치를 펴며 원위치로 돌아온다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0027",
            "title": "밴드 족저굴곡(Plantar Flexion with Band)",
            "thumb": "/assets/thumbs/Band-0027.png",
            "guide": [
                "다리를 펴고 앉아 한 쪽 발에 밴드를 걸어 양 끝을 손으로 잡아 당긴다.",
                "무릎을 편 채 발을 바닥쪽으로 밀어 내렸다(족저굴곡) 원위치로 돌아온다.",
                "10~15회 반복 후 발을 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0028",
            "title": "밴드 족배굴곡(Dorsi Flexion with Band)",
            "thumb": "/assets/thumbs/Band-0028.png",
            "guide": [
                "다리를 펴고 앉아 한 쪽 발등에 밴드를 걸어 발바닥 방향에서 잡아 당긴다.",
                "무릎을 편 채 발을 발등쪽으로 끌어 올렸다(족배굴곡) 원위치로 돌아온다.",
                "10~15회 반복 후 발을 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0030",
            "title": "밴드 내반(Inversion exercise, band)",
            "thumb": "/assets/thumbs/Band-0030.png",
            "guide": [
                "다리를 펴고 앉아 한 쪽 발에 밴드를 걸어 바깥쪽에서 잡아 고정한다.",
                "발등을 안쪽 방향으로 들어 올리듯 발목을 내반한다.(발목을 안으로 돌리는 내회전이 아님을 유의)",
                "10~15회 반복 후 발을 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0031",
            "title": "밴드 햄스트링 컬(Hamstring Curl, standing)",
            "thumb": "/assets/thumbs/Band-0031.png",
            "guide": [
                "두 발에 밴드를 고정하고 서서 한 쪽 무릎을 굽혀 발을 엉덩이 쪽으로 들어 올린다.",
                "10~15회 반복 후 다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0032",
            "title": "밴드 몬스터 워크(Monster Walk)",
            "thumb": "/assets/thumbs/Band-0032.png",
            "guide": [
                "다리를 모아 무릎 약간 위쪽에 밴드를 묶고 선다.",
                "무릎을 굽힌 상태로 고관절을 크게 밖으로 돌리면서(외회전) 앞, 뒤로 각각 10보씩 걷는다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0033",
            "title": "밴드 사이드 워킹(Side walking)",
            "thumb": "/assets/thumbs/Band-0033.png",
            "guide": [
                "양 쪽 발목에 밴드를 걸고 무릎을 굽힌다.",
                "밴드의 저항을 느끼며 오른쪽, 왼쪽으로 각각 10보씩 걷고, 3세트 반복한다."
            ]
        },
        {
            "id": "Band/Band-0034",
            "title": "밴드 고관절 굴곡(Hip flexion, standing)",
            "thumb": "/assets/thumbs/Band-0034.png",
            "guide": [
                "양 쪽 발에 밴드를 걸고 서서 한 쪽 무릎을 굽혀 가슴쪽으로 끌어 올렸다 내린다.",
                "10~15회 반복 후 다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "MS/MS-Neck-0052",
            "title": "밴드를 이용한 목 신전 저항(Posterior cervical muscle activation-Static Neck Extension-Band)",
            "thumb": "/assets/thumbs/MS-Neck-0052.png",
            "guide": [
                "양 손으로 밴드를 머리 후두에 두고 앞쪽 당긴다. 목은 뒤쪽으로 힘을 주고 버틴다 5초간 유지한다. 3~5번 반복한다."
            ]
        },
    ],
    "stretch": [
        {
            "id": "Stretch/Stretch-0001",
            "title": "후경근 스트레치-목 굴곡(Posterior cervical muscle stretch-Neck flexion)",
            "thumb": "/assets/thumbs/Stretch-0001.png",
            "guide": [
                "척추를 바로 세워 목을 앞으로 굽히고 10~15초간 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0002",
            "title": "흉쇄유돌근 스트레치-목 신전 (SCM stretch-Neck extension)",
            "thumb": "/assets/thumbs/Stretch-0002.png",
            "guide": [
                "척추를 바로 세우고 앉아 목을 뒤로 젖히고 10~15초간 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0003",
            "title": "승모근 스트레치-목 측굴 (Trapezius stretch-Neck side flexion)",
            "thumb": "/assets/thumbs/Stretch-0003.png",
            "guide": [
                "척추를 바로 세우고 앉거나 서서 목을 옆으로 굽혀서 15초간 유지한다.",
                "양쪽 모두 실시하고 3회씩 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0004",
            "title": "흉쇄유돌근 스트레치-목 회전 (SCM stretch-Neck Rotation)",
            "thumb": "/assets/thumbs/Stretch-0004.png",
            "guide": [
                "척추를 바로 세워서 목을 한 쪽으로 회전하여 10~15초간 유지하고, 3세트 반복한다.",
                "* 목을 회전한 상태에서 턱을 위로 들어올리면 흉쇄유돌근이 더 강하게 스트레칭 된다."
            ]
        },
        {
            "id": "Stretch/Stretch-0005",
            "title": "전사각근 스트레치(Anterior scalene stretch)",
            "thumb": "/assets/thumbs/Stretch-0005.png",
            "guide": [
                "목을 한 쪽으로 기울이고(측굴) 반대방향 위쪽으로 가볍게 회전(상방회전)하여 10초간 유지한다.",
                "반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0006",
            "title": "후사각근 스트레치(Posterior scalene stretch)",
            "thumb": "/assets/thumbs/Stretch-0006.png",
            "guide": [
                "목을 한 쪽으로 기울이고(측굴) 같은 방향 아래쪽으로 가볍게 회전(하방회전)하여 10초간 유지한다.",
                "반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0007",
            "title": "견갑거근 스트레치(Levator scapulae stretch)",
            "thumb": "/assets/thumbs/Stretch-0007.png",
            "guide": [
                "목을 옆으로 굽히고(측굴) 앞으로 숙인 후 안쪽으로 살짝 회전하여 15초간 유지한다.",
                "반대쪽도 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0008",
            "title": "수건을 이용한 목 신전 스트레치(Neck extension, towel)",
            "thumb": "/assets/thumbs/Stretch-0008.png",
            "guide": [
                "턱을 살짝 들어 후두부에 수건을 두고 양 끝을 손으로 잡는다.",
                "수건을 위로 당겨 10초간 유지하고, 3회 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0009",
            "title": "전삼각근 스트레치(Anterior Deltoid stretch)",
            "thumb": "/assets/thumbs/Stretch-0009.png",
            "guide": [
                "허리 뒤로 깍지를 껴 팔을 뻗어 올리고 15초간 유지한다. 3회 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0010",
            "title": "후삼각근 스트레치(Posterior deltoid stretch)",
            "thumb": "/assets/thumbs/Stretch-0010.png",
            "guide": [
                "오른쪽 팔을 안쪽으로 뻗어(수평내전) 왼쪽 팔꿈치를 굽혀 감싼다.",
                "오른팔을 가슴쪽으로 당겨 15초 유지한 후 팔을 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0011",
            "title": "삼두근 스트레치(Triceps stretch)",
            "thumb": "/assets/thumbs/Stretch-0011.png",
            "guide": [
                "한 팔을 위로 들어 팔꿈치를 굽히고, 반대쪽 손으로 팔꿈치를 잡아 뒤로 당겨 15초 유지한다.",
                "팔을 바꿔 반대쪽으로도 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0012",
            "title": "어깨 내회전 스트레치(Shoulder Internal stretch)",
            "thumb": "/assets/thumbs/Stretch-0012.png",
            "guide": [
                "팔을 뒤로 보내 왼손으로 오른쪽 손목을 잡아 왼쪽으로 당겨 15초 유지한다.",
                "2~3회 반복 후 반대쪽으로 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0013",
            "title": "어깨 외회전근 스트레치(Shoulder External rotator stretch)",
            "thumb": "/assets/thumbs/Stretch-0013.png",
            "guide": [
                "한 쪽 팔꿈치를 굽혀 손등을 허리와 등의 중간 부분에 댄 후 반대쪽 손으로 팔꿈치를 지그시 앞으로 당긴다.",
                "(단, 팔을 뒤로 보낼 수 없는 경우 영상처럼 손을 허리에 두고 실시한다.)",
                "15초간 유지한 후 반대쪽으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0014",
            "title": "어깨 내회전 스트레치(Shoulder Internal rotator, sleep stretch)",
            "thumb": "/assets/thumbs/Stretch-0014.png",
            "guide": [
                "옆으로 누워 아래쪽 팔을 가슴앞으로 뻗어 팔꿈치를 90°로 굽혀 세운다.",
                "위쪽 손으로 손목을 잡아 바닥쪽으로 천천히 내려 15초간 유지한다.",
                "2~3회 반복 후 반대쪽으로 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0015",
            "title": "흉근 스트레치-벽(Pectoralis stretch, wall)",
            "thumb": "/assets/thumbs/Stretch-0015.png",
            "guide": [
                "한 쪽 팔꿈치를 90°로 굽혀 벽에 대고 몸을 앞으로 밀어 15초간 유지한다.",
                "3회 반복하고 반대쪽도 실시한다.",
                "* 같은 방법으로 팔꿈치를 편 상태로 45° 아래로 내려서, 145° 위로 올려서 각각 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0016",
            "title": "흉근 스트레치-코너(Pectoralis stretch, corner)",
            "thumb": "/assets/thumbs/Stretch-0016.png",
            "guide": [
                "코너쪽에 서서 양쪽 팔꿈치를 90°로 굽히고 어깨높이에 맞춰 옆으로 벌려 벽에 기대어 선다.",
                "몸을 앞으로 밀어 15초간 유지하여 3회 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0017",
            "title": "흉근 스트레치-짐볼(Pectoralis stretch, Stability ball)",
            "thumb": "/assets/thumbs/Stretch-0017.png",
            "guide": [
                "네 발 기기 자세로 엎드려 한 쪽 팔을 90°로 굽혀 짐볼 위에 올린다.",
                "짐볼을 가볍게 압박하여 상체를 밑으로 내리고 15초간 유지한다.",
                "3회 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0018",
            "title": "능형근(등 상부) 스트레치(Rhomboid stretch)",
            "thumb": "/assets/thumbs/Stretch-0018.png",
            "guide": [
                "양 쪽 팔꿈치를 굽혀 손등을 허리와 등의 중간 부분에 댄다.",
                "팔꿈치가 앞에서 보일 정도로 어깨를 안으로 회전시킨다.(내회전)",
                "15초간 유지하고, 3회 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0019",
            "title": "능형근/중부승모근 스트레치-짐볼(Rhomboid stretch, Stability ball)",
            "thumb": "/assets/thumbs/Stretch-0019.png",
            "guide": [
                "네 발 기기 자세로 엎드려 왼팔을 오른쪽으로 뻗어 어깨를 짐볼 위에 올린다.",
                "왼팔을 앞쪽으로 더 밀어내(수평내전) 15초간 유지한다.",
                "팔을 바꿔 실시하고, 3회 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0020",
            "title": "능형근/중부승모근(등 상부) 스트레치(Rhomboid stretch, quadruped)",
            "thumb": "/assets/thumbs/Stretch-0020.png",
            "guide": [
                "네 발 기기 자세로 엎드려 한 쪽 팔을 어깨가 바닥에 닿을 때까지 안쪽으로 뻗어 밀어낸다.(수평내전)",
                "15초간 유지한 후 반대쪽으로 실시하고, 3회 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0021",
            "title": "중,하부승모근 스트레치(Lower, Middle Trapezius stretch-prayer stretch)",
            "thumb": "/assets/thumbs/Stretch-0021.png",
            "guide": [
                "네 발 기기 자세로 엎드린다.",
                "엉덩이를 뒤로 보내고 상체를 아래로 내려 15초간 유지하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0022",
            "title": "광배근 스트레치-짐볼(Latissimus dorsi stretch, stability ball)",
            "thumb": "/assets/thumbs/Stretch-0022.png",
            "guide": [
                "네 발 기기 자세로 엎드려 한 쪽 팔꿈치를 굽혀 손을 중립상태로 짐볼 위에 올린다.",
                "팔을 펴면서 짐볼을 가볍게 압박하여 위로 밀어올리고 15초간 유지한다.",
                "3회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0023",
            "title": "중부승모근/능형근 스트레치(Rhomboid & middle trapezius stretch)",
            "thumb": "/assets/thumbs/Stretch-0023.png",
            "guide": [
                "무릎을 꿇고 앉아 양팔을 가슴앞으로 뻗어 깍지를 낀다.",
                "등을 최대한 둥글게 만들어 15초간 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "TP/TP-0059",
            "title": "전거근 스트레치(Serratus anterior stretch)",
            "thumb": "/assets/thumbs/TP-0059.png",
            "guide": [
                "벤치에 앉아 한 쪽 팔을 뒤로 뻗어 벤치 가장자리를 잡고 몸통을 내회전 한다.",
                "15초간 유지하여 3회 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0042",
            "title": "대퇴근막장근 스트레치(TFL stretch, standing)",
            "thumb": "/assets/thumbs/Stretch-0042.png",
            "guide": [
                "오른쪽 다리를 뒤로 보내고 서서 오른팔을 머리 위로 뻗는다.",
                "상체와 함께 왼쪽으로 측굴 후 몸통을 오른쪽으로 회전하여 15초간 유지한다.",
                "3회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0044",
            "title": "90도 90도 고관절 스트레치(90/90 degree Hip stretch)",
            "thumb": "/assets/thumbs/Stretch-0044.png",
            "guide": [
                "한 쪽 다리를 뒤로 90°, 반대쪽 다리를 앞으로 90° 굽히고 앉는다.",
                "상체를 앞으로 숙여 15초간 유지한 후 방향을 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0024",
            "title": "요추기립근 스트레치-의자(Lumbar Erector spinae stretch forward Bending stretch)",
            "thumb": "/assets/thumbs/Stretch-0024.png",
            "guide": [
                "의자 끝에 앉아 양쪽 무릎을 어깨 넓이보다 넓게 벌린다.",
                "무릎 사이로 상체를 숙여 15초간 유지하고, 3회 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0043",
            "title": "고관절 내전근 스트레치(Hip adductor stretch, standing)",
            "thumb": "/assets/thumbs/Stretch-0043.png",
            "guide": [
                "다리를 넓게 벌리고 서서 오른발을 바깥쪽으로 회전한다.(고관절 외전, 외회전)",
                "왼쪽 무릎을 굽히고 앉으면서 체중을 실어 15초간 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0025",
            "title": "고양이 등 스트레치(Cat Stretch)",
            "thumb": "/assets/thumbs/Stretch-0025.png",
            "guide": [
                "네 발 기기 자세로 엎드린다.",
                "등을 최대한 둥글게 만들어 15초간 유지하고, 3회 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0026",
            "title": "누워 한 무릎 가슴 쪽 당기기(Single knee to chest)",
            "thumb": "/assets/thumbs/Stretch-0026.png",
            "guide": [
                "다리를 펴고 바로 누워 한 쪽 무릎을 굽혀 두 손으로 가슴쪽으로 당겨 15초간 유지한다.",
                "3회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0027",
            "title": "요방형근/복사근 스트레치-짐볼(Quadrutus lumborum & oblique stretch)",
            "thumb": "/assets/thumbs/Stretch-0027.png",
            "guide": [
                "짐볼 위에 옆으로 누워 팔과 다리를 위 아래로 뻗어 15초간 유지한다.",
                "3회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0028",
            "title": "요방형근 스트레치(Quadratus Lumborum stretch-Pelvic Shift)",
            "thumb": "/assets/thumbs/Stretch-0028.png",
            "guide": [
                "벽 옆에 서서 안쪽 팔꿈치를 굽혀 벽에 대고 안쪽 다리를 바깥쪽 다리 뒤로 교차시킨다.",
                "척추를 곧게 세운 채 골반을 벽쪽으로 밀어 15초간 유지한다.",
                "3회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0029",
            "title": "요추부 스트레치-누워 두 무릎 가슴쪽으로 당기기(Hip Extensor Stretch-Double Knee to Chest)",
            "thumb": "/assets/thumbs/Stretch-0029.png",
            "guide": [
                "바로 누워 무릎을 굽혀 들어 올린다.",
                "양손으로 무릎을 가슴쪽으로 당겨 15초간 유지하고, 3회 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0030",
            "title": "복직근 스트레치-옆드려(Rectus Abdominis stretch, prone)",
            "thumb": "/assets/thumbs/Stretch-0030.png",
            "guide": [
                "다리를 펴고 엎드려 양 팔을 굽혀 몸 옆에 둔다.",
                "팔꿈치를 펴서 상체를 세우고 15초간 유지하며, 3회 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0031",
            "title": "복직근 스트레치-짐볼(Rectus Abdominis stretch, Stability ball)",
            "thumb": "/assets/thumbs/Stretch-0031.png",
            "guide": [
                "짐볼 위에 등을 대고 눕는다.",
                "팔과 다리를 위 아래로 펴서 15초간 유지하고, 3회 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0032",
            "title": "누워 허리 회전근 스트레치(Lumbar Erector spinae stretch-Trunk rotation, supine)",
            "thumb": "/assets/thumbs/Stretch-0032.png",
            "guide": [
                "등을 대고 누워 다리를 모아 무릎을 세운다.",
                "좌우로 번갈아 가며 무릎을 최대한 바닥 쪽으로 넘겨 2~3초 유지한 후 돌아온다.",
                "10회 2~3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0033",
            "title": "요추기립근/복사근 스트레치-다리 뻗어 몸통회전(Lumbar Erector spinae stretch-Trunk rotation, leg straight)",
            "thumb": "/assets/thumbs/Stretch-0033.png",
            "guide": [
                "바로 누워 한 쪽 다리를 안쪽으로 뻗고 몸통을 반대방향으로 회전한다.",
                "10~15초 유지한 후 반대쪽으로 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0034",
            "title": "요추기립근/복사근 스트레치-무릎 굽혀 몸통회전(Lumbar Erector spinae stretch-Trunk rotation, Knee flexion)",
            "thumb": "/assets/thumbs/Stretch-0034.png",
            "guide": [
                "다리를 펴고 바로 누워 한 쪽 무릎을 굽혀 안쪽으로 넘기고 몸통을 반대방향으로 회전한다.",
                "15초간 유지한 후 반대쪽으로 실시하고, 3회 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0035",
            "title": "허리 신전운동(Back Extension, standing)",
            "thumb": "/assets/thumbs/Stretch-0035.png",
            "guide": [
                "손으로 허리를 잡고 서서 천천히 골반을 앞으로 밀어내면서 허리를 뒤로 젖힌다.(신전)",
                "15초 유지하고, 3회 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0036",
            "title": "소둔근 스트레치(Glute minimus stretch)",
            "thumb": "/assets/thumbs/Stretch-0036.png",
            "guide": [
                "바로 누워 한 쪽 무릎을 굽혀 안쪽 45° 방향으로 넘겨 가슴쪽으로 끌어당긴다.",
                "15초간 유지한 후 반대쪽으로 실시하고, 3회 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0037",
            "title": "중둔근 스트레치(Glute medius stretch, Quadruped)",
            "thumb": "/assets/thumbs/Stretch-0037.png",
            "guide": [
                "한 쪽 다리를 앞으로 보내 무릎을 굽혀 안쪽으로 살짝 들여놓고 반대쪽 다리는 뒤로 편다.",
                "상체를 바닥으로 내려 15초간 유지한 후 반대쪽으로 실시하고, 3회 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0038",
            "title": "이상근 스트레치-짐볼(Piriformis stretch, Stability ball)",
            "thumb": "/assets/thumbs/Stretch-0038.png",
            "guide": [
                "바로 누워 왼발을 짐볼 위에 올리고 오른쪽 다리를 굽혀 발목을 왼쪽 무릎 위에 올린다.",
                "왼쪽 무릎 뒤로 깍지를 껴 짐볼과 함께 다리를 가슴쪽으로 끌어 당겨 15초간 유지한다.",
                "3회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0039",
            "title": "이상근 스트레치(Piriformis stretch)",
            "thumb": "/assets/thumbs/Stretch-0039.png",
            "guide": [
                "등을 대고 누워 무릎을 굽히고 왼쪽 발목을 오른쪽 무릎 위에 올린다.",
                "오른쪽 무릎 뒤로(또는 정강이) 깍지를 껴 다리를 가슴쪽으로 당겨 올려 15초 유지한다.",
                "3회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0040",
            "title": "둔근 스트레치-무릎 굽혀 가슴 쪽 당기기(Glute stretch-Knee to chest, supine)",
            "thumb": "/assets/thumbs/Stretch-0040.png",
            "guide": [
                "무릎을 굽히고 누워 손으로 한 쪽 무릎을 가슴쪽으로 끌어 당긴다.",
                "15초간 유지한 후 반대쪽으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0041",
            "title": "고관절 굴곡근 스트레치(Hip flexor stretch, kneeling)",
            "thumb": "/assets/thumbs/Stretch-0041.png",
            "guide": [
                "무릎을 굽혀 오른쪽 다리를 뒤로 보내고, 왼쪽 발을 앞으로 보내 바닥을 밟는다.",
                "오른팔을 위로 뻗어 상체와 함께 왼쪽으로 측굴 후 몸통을 오른쪽으로 회전하고 골반을 뒤로 기울인다.(후방전위)",
                "15초간 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0045",
            "title": "고관절 내전근 스트레치-스텝박스(Hip adductor stretch, step)",
            "thumb": "/assets/thumbs/Stretch-0045.png",
            "guide": [
                "스텝박스를 옆으로 두고 선다.",
                "한 발을 스텝박스에 올리고, 반대쪽 다리는 옆으로 뻗어 발을 바깥쪽으로 회전한다.",
                "스텝박스에 올린 다리의 무릎을 굽히고 상체를 옆으로 뻗은 다리쪽으로 숙여 15초 유지한다.",
                "3회 반복하고 다리를 바꿔 실시한다."
            ]
        },
        {
            "id": "FMS/FMS-OH-0008",
            "title": "내전근 스트레치-짐볼(Adductor stretch, Stability ball)",
            "thumb": "/assets/thumbs/FMS-OH-0008.png",
            "guide": [
                "짐볼에 앉아 한 쪽 다리를 옆으로 쭉 펴고 발을 족배굴곡(발등 굽힘)한다.",
                "무릎을 굽힌 다리쪽으로 체중을 옮겨 15초간 유지한다.",
                "3회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0046",
            "title": "고관절 외회전근 스트레치(Hip external rotator stretch, supine)",
            "thumb": "/assets/thumbs/Stretch-0046.png",
            "guide": [
                "바로 누워 무릎을 세운다.",
                "왼쪽 발목을 오른쪽 무릎 위에 올려 무릎을 안쪽으로 끌어 내려 15초 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0047",
            "title": "서혜부 스트레치(Groin stretch-lotus)",
            "thumb": "/assets/thumbs/Stretch-0047.png",
            "guide": [
                "발바닥을 붙이고 앉아 양쪽 무릎을 옆으로 벌린다.",
                "팔꿈치로 다리를 누르거나 상체를 앞으로 숙여 15초 유지한다.",
                "3회 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0048",
            "title": "고관절 굴곡근 & 대퇴부 스트레치(Hip flexor & Quadriceps stretch, stability ball)",
            "thumb": "/assets/thumbs/Stretch-0048.png",
            "guide": [
                "한 쪽 다리를 90°로 굽혀 앞으로 보내고, 반대쪽 다리를 뒤로 보내 무릎을 굽혀 발등을 짐볼에 올린다.",
                "골반과 함께 몸을 앞으로 밀어 15초 유지한다. 3세트 반복하고, 반대쪽으로 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0049",
            "title": "서혜부 스트레치-개구리자세(Groin stretch, frog position)",
            "thumb": "/assets/thumbs/Stretch-0049.png",
            "guide": [
                "무릎을 굽혀 최대한 넓게 벌리고 팔을 뻗어 바닥을 지지하여 엎드린다.",
                "상체와 함께 골반을 위쪽으로 밀어 올려 15초 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0050",
            "title": "고관절 외회전근 스트레치(Hip external rotator stretch, standing)",
            "thumb": "/assets/thumbs/Stretch-0050.png",
            "guide": [
                "다리를 어깨넓이로 벌리고 선다.",
                "한 발을 안쪽으로 최대한 회전시키고, 몸통을 반대쪽으로 회전하여 15초 유지한다.",
                "원위치로 돌아와 반대쪽으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0051",
            "title": "고관절 내회전근 스트레치(Hip internal rotator stretch, standing)",
            "thumb": "/assets/thumbs/Stretch-0051.png",
            "guide": [
                "발을 30cm 정도 벌리고 선다.",
                "한 발을 바깥쪽으로 최대한 회전시키고, 몸통을 반대쪽으로 회전하여 15초 유지한다.",
                "원위치로 돌아와 반대쪽으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0052",
            "title": "대퇴부 신전 스트레치-서서(Quadriceps stretch, standing)",
            "thumb": "/assets/thumbs/Stretch-0052.png",
            "guide": [
                "한 쪽 무릎을 굽혀 뒤쪽에서 손으로 발목을 잡아 당기며 15초 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0053",
            "title": "옆으로 누워 대퇴부 스트레치(Quadriceps stretch, sidelying)",
            "thumb": "/assets/thumbs/Stretch-0053.png",
            "guide": [
                "옆으로 누워 다리를 편다.",
                "위쪽 무릎을 굽혀 뒤쪽에서 손으로 발목을 잡아 당겨 15초 유지한다.",
                "반대쪽도 실하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0055",
            "title": "햄스트링 스트레치-누워서(Hamstring stretch, supine)",
            "thumb": "/assets/thumbs/Stretch-0055.png",
            "guide": [
                "다리를 펴고 바로 누워 양 손으로 한 쪽 다리의 허벅지를 잡아 몸쪽으로 끌어 당긴다.",
                "15초간 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다.",
                "※ 발목을 족배굴곡하면 햄스트링이 더 강하게 스트레치 된다."
            ]
        },
        {
            "id": "Stretch/Stretch-0056",
            "title": "햄스트링 스트레치-서서(Hamstring stretch, standing)",
            "thumb": "/assets/thumbs/Stretch-0056.png",
            "guide": [
                "한 쪽 다리를 앞으로 뻗어 발끝(발목 족배굴곡)을 세운다.",
                "무릎을 편 채 상체를 앞으로 숙여 15초 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0057",
            "title": "햄스트링 스트레치-스텝박스(Hamstring stretch, step)",
            "thumb": "/assets/thumbs/Stretch-0057.png",
            "guide": [
                "한 쪽 다리를 펴서 뒤꿈치를 스텝박스 위에 올리고 선다.",
                "무릎을 편 채 상체를 앞으로 숙여 15초 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0058",
            "title": "대퇴이두근 스트레치-누워서(Biceps femoris stretch)",
            "thumb": "/assets/thumbs/Stretch-0058.png",
            "guide": [
                "다리를 펴고 바로 눕는다.",
                "한 쪽 다리를 들어 올린 후 다리를 편 채 안쪽 45° 방향으로 끌어당겨 15초간 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0059",
            "title": "대퇴이두근 스트레치-스텝박스(Biceps femoris stretch, step)",
            "thumb": "/assets/thumbs/Stretch-0059.png",
            "guide": [
                "한 쪽 다리를 앞으로 펴서 45°안쪽으로 기울여 뒤꿈치를 박스 위에 올린다.",
                "무릎을 편 채 상체를 앞으로 숙여 15초간 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0060",
            "title": "근신경 스트레치-햄스트링(Neuromuscula stretch, hamstring)",
            "thumb": "/assets/thumbs/Stretch-0060.png",
            "guide": [
                "의자에 앉아 척추를 바로 세우고 한 쪽 다리를 수평으로 뻗는다.",
                "목을 앞으로 숙이고 발목을 발등쪽으로 굽혀(족배굴곡) 15초간 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0061",
            "title": "비복근 스트레치(Gastrocnemius stretch)",
            "thumb": "/assets/thumbs/Stretch-0061.png",
            "guide": [
                "벽에 양 손을 짚고 기대어 선다.",
                "한 발을 앞으로 보내 무릎을 가볍게 굽히고, 반대쪽 다리를 뒤로 보내 무릎을 펴서 뒤꿈치를 바닥에 붙인다.",
                "15초 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0062",
            "title": "가자미근 스트레치(Soleus stretch)",
            "thumb": "/assets/thumbs/Stretch-0062.png",
            "guide": [
                "양 손으로 벽을 짚거나 Bar를 잡고 선다.",
                "스트레치 하려는 다리를 뒤로 보내 뒤꿈치를 바닥에 붙인 상태에서 무릎을 최대한 굽힌다.",
                "15초간 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0063",
            "title": "가자미근 스트레치-앉아서(Soleus stretch, sitting)",
            "thumb": "/assets/thumbs/Stretch-0063.png",
            "guide": [
                "무릎을 구부리고 앉아 스트레치 하려는 다리를 90°로 굽혀 앞으로 보낸다.",
                "뒤꿈치를 바닥에 붙인 채 앞으로 보낸 다리의 무릎을 최대한 앞쪽으로 밀어낸다.",
                "15초간 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0064",
            "title": "수건을 이용한 아킬레스 스트레치(Achilles stretch, towel)",
            "thumb": "/assets/thumbs/Stretch-0064.png",
            "guide": [
                "다리를 펴고 앉아 한 쪽 발에 수건을 걸고 양 끝을 손으로 잡는다.",
                "수건을 당겨 발목을 발등쪽으로 굽혀(족배굴곡) 15초 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0065",
            "title": "벽 기대고 아킬레스 스트레치(Achilles stretch, wall)",
            "thumb": "/assets/thumbs/Stretch-0065.png",
            "guide": [
                "스텝박스 가장자리에 한 쪽 발끝으로 올라 서서 손으로 벽을 짚는다.",
                "무릎을 편 채 뒤꿈치를 아래로 늘어뜨려 15초 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0066",
            "title": "아킬레스 스트레치-스텝박스(Achilles stretch, step)",
            "thumb": "/assets/thumbs/Stretch-0066.png",
            "guide": [
                "스텝박스 위에 서서 한 쪽 발끝을 스텝박스 가장자리에 둔다.",
                "무릎을 편 채 뒤꿈치를 아래로 늘어뜨려 15초 유지한다.",
                "원위치로 돌아와 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0067",
            "title": "손바닥모아 스트레치-손목 신전",
            "thumb": "/assets/thumbs/Stretch-0067.png",
            "guide": [
                "팔꿈치를 굽혀 가슴 높이에서 양 손바닥을 맞댄다.",
                "손바닥을 밀착한 채 팔을 밑으로 내려 10~15초간 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0068",
            "title": "손등모아 스트레치-손목 굴곡(Reverse prayer Stretch-wrist flexion)",
            "thumb": "/assets/thumbs/Stretch-0068.png",
            "guide": [
                "팔꿈치를 굽혀 양쪽 손등을 복부 높이에서 서로 맞댄다.",
                "손등을 밀착한 채 팔을 위로 올려 10~15초간 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0069",
            "title": "손목 굴곡/신전 스트레치(Wrist fexion/extension stretch)",
            "thumb": "/assets/thumbs/Stretch-0069.png",
            "guide": [
                "한 팔을 가슴앞으로 뻗어 손목을 손등쪽으로 굽히고 반대쪽 손으로 손바닥을 밀어 10~15초간 유지한다.",
                "손목을 바닥쪽으로 굽혀 반대쪽 손으로 손등을 밀어 10~15초간 유지한다.",
                "3세트 반복 후 팔을 바꿔 실시한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0070",
            "title": "엄지손가락 스트레치(Thumb Stretch)",
            "thumb": "/assets/thumbs/Stretch-0070.png",
            "guide": [
                "한 팔을 중립상태로 만들어 가슴앞으로 뻗는다.",
                "엄지손가락을 네 손가락으로 감싼 후 손목을 바닥쪽으로 굽혀 10~15초 유지한다.",
                "원위치로 돌아와 팔을 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0071",
            "title": "전완근 스트레치-네발기기자세(Wrist extensor stretch, Quadruped)",
            "thumb": "/assets/thumbs/Stretch-0071.png",
            "guide": [
                "네 발 기지 자세로 엎드린다.",
                "양 쪽 어깨를 밖으로 회전시켜 손가락이 몸쪽을 향하게 하여 바닥을 짚고 10~15초간 유지한다.",
                "3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0072",
            "title": "엄지손가락 신전 스트레치(Thumb extension stretch)",
            "thumb": "/assets/thumbs/Stretch-0072.png",
            "guide": [
                "손바닥을 위로 가게 하여 가슴앞으로 한 팔을 뻗는다.",
                "손목을 바닥쪽으로 굽힌 후 반대쪽 손으로 엄지손가락을 몸쪽으로 당겨 10~15초간 유지한다.",
                "원위치로 돌아와 팔을 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0073",
            "title": "견갑하근 스트레치(Subscapularis stretch)",
            "thumb": "/assets/thumbs/Stretch-0073.png",
            "guide": [
                "오른팔을 어깨높이에 맞춰 옆으로 들어 팔꿈치를 굽히고 전완(팔꿈치 아래)을 세운다.",
                "오른쪽 어깨가 외회전된 상태로 바(Bar)를 잡고, 왼손으로 바의 아래쪽을 잡는다.",
                "왼손으로 바를 앞쪽으로 당겨 오른쪽 어깨가 더 외회전 되도록하여 10~15초간 유지한다.",
                "원위치로 돌아와 팔을 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0074",
            "title": "상완요골근 스트레치 (Brachioradialis stretch)",
            "thumb": "/assets/thumbs/Stretch-0074.png",
            "guide": [
                "손바닥을 아래로 향하게 하여 오른 팔을 가슴앞으로 뻗어 손목을 바닥방향으로 굽힌다.",
                "왼손으로 오른쪽 손등을 감싼 후 새끼손가락이 안쪽으로 향하게 당겨 10~15초 유지한다.",
                "같은 방법으로 반대쪽으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0075",
            "title": "원회내근 스트레치(Pronator Teres stretch)",
            "thumb": "/assets/thumbs/Stretch-0075.png",
            "guide": [
                "손바닥이 위로 향하게 하여 오른팔을 가슴앞으로 뻗는다.",
                "왼손으로 오른쪽 손바닥을 감싸 몸쪽으로 당기고 15초간 유지한다.",
                "같은 방법으로 반대쪽으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0076",
            "title": "회외근 스트레치(Supinator stretch)",
            "thumb": "/assets/thumbs/Stretch-0076.png",
            "guide": [
                "오른팔을 가슴앞으로 뻗어 어깨를 안으로 회전한다.(어깨 내회전)",
                "왼손으로 오른손을 감싼 후 엄지손가락이 바깥쪽으로 향하게 당겨 10~15초 유지한다.",
                "같은 방법으로 반대쪽으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0077",
            "title": "봉공근 스트레치(Sartorius stretch)",
            "thumb": "/assets/thumbs/Stretch-0077.png",
            "guide": [
                "스트레치 하고자 하는 다리를 뒤로 보내(고관절신전) 안쪽 45° 방향으로 길게 뻗고(고관절내전) 발을 내회전 한다.",
                "10~15초 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다.",
                "※ 봉공근은 고관절 굴곡, 외전, 외회전 보조근육이다."
            ]
        },
        {
            "id": "Stretch/Stretch-0078",
            "title": "슬와근 스트레치(Popliteus stretch)",
            "thumb": "/assets/thumbs/Stretch-0078.png",
            "guide": [
                "의자에 앉아 무릎을 굽히고 발을 바깥쪽으로 회전하여 15초간 유지한다.",
                "같은 방법으로 발을 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0079",
            "title": "장지신근 스트레치(Extensor Digitorum stretch)",
            "thumb": "/assets/thumbs/Stretch-0079.png",
            "guide": [
                "한 쪽 발가락 끝을 바닥에 두고 신전하여 15초간 유지한다.",
                "발을 바꿔 같은 방법으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0080",
            "title": "전경골근 스트레치(Anterior tibialis stretch)",
            "thumb": "/assets/thumbs/Stretch-0080.png",
            "guide": [
                "스트레치 하려는 다리를 뒤로 보내고 무릎을 세워 앉는다.",
                "뒤쪽 다리의 발을 안쪽 45° 방향으로 보내 발등을 펴서 바닥에 대고 천천히 엉덩이를 내려 전경골근을 스트레치한다.",
                "10~15초간 유지한 후 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0081",
            "title": "서서 한쪽 무릎 가슴 쪽 당기기(Single Knee to chest, standing)",
            "thumb": "/assets/thumbs/Stretch-0081.png",
            "guide": [
                "다리를 어깨넓이로 벌리고 선다.",
                "한 쪽 다리를 굽혀 양 손으로 무릎을 가슴쪽으로 끌어 당기고 10~15초 유지한다.",
                "같은 방법으로 다리를 바꿔 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Stretch-0082",
            "title": "중둔근 스트레치(Glute medius stretch, supine)",
            "thumb": "/assets/thumbs/Stretch-0082.png",
            "guide": [
                "바로 누워 한 쪽 무릎을 굽혀 안쪽 45°방향으로 넘겨 가슴쪽으로 끌어 당긴다.",
                "15초간 유지한 후 반대쪽으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Stretch/Palmaris Longus",
            "title": "장장근 스트레치(Palmaris Longus stretch)",
            "thumb": "/assets/thumbs/Palmaris Longus.mp4_000008475.png",
            "guide": [
                "네 발 기지 자세로 엎드려 어깨를 외회전 하여(손가락이 몸쪽을 향하게) 손바닥으로 바닥을 짚는다.",
                "15초 유지하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Static/Static-S-0015",
            "title": "경추굴곡근 스트레치-네 발 기기 자세 목 신전(Posterior Cervical Muscle stretch-Neck extension, Quadruped)",
            "thumb": "/assets/thumbs/Static-S-0015.png",
            "guide": [
                "네 발 기기 자세로 엎드려 척추를 바르게 정렬한다. 목을 뒤로 젖히고 5초 유지한다.",
                "목을 앞으로 굽히고 5초 유지한다.",
                "목을 옆으로 돌려서 5초 유지한 후 반대쪽으로 실시한다. 각각 3회씩 반복한다."
            ]
        },
    ],
    "barbell": [
        {
            "id": "FitBody/FitBody-Barbell-0001",
            "title": "바벨 벤치프레스(Barbell Bench Press)",
            "thumb": "/assets/thumbs/FitBody-Barbell-0001.png",
            "guide": [
                "벤치에 누워 양 손으로 바벨을 잡는다.",
                "숨을 내쉬면서 바벨을 가슴앞으로 들어올리고, 들이 마시면서 팔꿈치를 굽혀 수직으로 내린다.",
                "관절부상의 위험이 있을 수 있으므로 팔꿈치를 완전히 다 펴지 않는다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitBody/FitBody-Barbell-0002",
            "title": "바벨 벤트오버 로우(Barbell Row, Bent-over)",
            "thumb": "/assets/thumbs/FitBody-Barbell-0002.png",
            "guide": [
                "무릎을 굽히고 상체를 숙이고 서서 양손으로 바벨을 잡고 팔을 자연스럽게 아래로 뻗는다.",
                "팔꿈치를 몸에 가깝게 붙여 굽히면서 바벨을 당겨 올린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitBody/FitBody-Barbell-0003",
            "title": "랜드마인 로우(Landmine row)",
            "thumb": "/assets/thumbs/FitBody-Barbell-0003.png",
            "guide": [
                "다리를 어깨넓이로 벌려 무릎을 굽히고 서서 상체를 45°로 숙인다.",
                "양쪽 다리 사이에 랜드마인(또는 바벨)을 두고 양손으로 바(Bar)의 상단부를 잡고 팔을 편다.",
                "팔꿈치를 굽혀 랜드마인(바벨)을 가슴까지 당겨 올렸다 내린다.",
                "10~15회 2~3세트 실시한다."
            ]
        },
        {
            "id": "FitBody/FitBody-Barbell-0004",
            "title": "바벨 미도우 로(Meadows row)",
            "thumb": "/assets/thumbs/FitBody-Barbell-0004.png",
            "guide": [
                "바벨을 몸 옆에 가로로 두고 서서 무릎을 굽힌다.",
                "상체를 앞으로 숙이고 한 쪽 팔을 뻗어 바벨을 잡는다.",
                "팔꿈치를 굽혀 바벨을 등쪽으로 당겼다 내린다.",
                "10~15회 2~3세트 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "FitBody/FitBody-Barbell-0005",
            "title": "바벨 프론트 레이즈(Front Bar Raise)",
            "thumb": "/assets/thumbs/FitBody-Barbell-0005.png",
            "guide": [
                "손등이 앞을 향하게 하여 양 손으로 바벨을 잡고 선다.",
                "팔을 앞으로 뻗어 어깨높이로 들어 올린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitBody/FitBody-Barbell-0006",
            "title": "바벨 숄더 프레스(Barbell Shoulder Press)",
            "thumb": "/assets/thumbs/FitBody-Barbell-0006.png",
            "guide": [
                "양 손으로 바벨을 잡고 팔꿈치를 굽혀 바벨을 어깨높이로 들어 올린다.",
                "팔을 뻗어 머리 위로 바벨을 들어 올린다. 이 때 팔꿈치는 완전히 펴지않고 살짝 굽힌다.",
                "팔꿈치를 굽히며 시작 위치로 돌아온다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitBody/FitBody-Barbell-0007",
            "title": "바벨 컬(Barbell curl)",
            "thumb": "/assets/thumbs/FitBody-Barbell-0007.png",
            "guide": [
                "손바닥이 앞을 향하게 하여 양 손으로 바벨을 잡는다.",
                "팔꿈치를 굽혀 바벨을 가슴쪽으로 들어 올린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitBody/FitBody-Barbell-0008",
            "title": "바벨 드래그 컬(Barbell drag curl)",
            "thumb": "/assets/thumbs/FitBody-Barbell-0008.png",
            "guide": [
                "손바닥이 앞을 향하게 하여 양 손으로 바벨을 잡는다.",
                "팔꿈치를 굽히면서 바벨을 등쪽으로 끌어 당긴다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitBody/FitBody-Barbell-0009",
            "title": "바벨 오버헤드 트라이셉 익스텐션(Barbell Standing Overhead Triceps Extension)",
            "thumb": "/assets/thumbs/FitBody-Barbell-0009.png",
            "guide": [
                "손등이 위로 가게 하여 바벨을 잡고 서서 팔꿈치를 굽혀 수직으로 들어 올린다.",
                "상완(위 팔)을 고정한 채 팔꿈치를 펴 바벨을 머리 위로 들어 올린다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "FitBody/FitBody-Barbell-0010",
            "title": "바벨 스쿼트(Barbell Squat)",
            "thumb": "/assets/thumbs/FitBody-Barbell-0010.png",
            "guide": [
                "양 손으로 바벨을 잡아 어깨 위에 올리고 서서 다리를 어깨보다 약간 넓게 벌린다.",
                "대퇴가 바닥과 수평이 될 때까지 무릎을 굽혀(90°) 앉았다 일어난다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitBody/FitBody-Barbell-0011",
            "title": "바벨 런지(Barbell Lunge)",
            "thumb": "/assets/thumbs/FitBody-Barbell-0011.png",
            "guide": [
                "양 손으로 바벨을 잡아 어깨 위에 올리고 선다.",
                "상체를 세운 채 한 발을 충분히 앞으로 보내 무릎을 굽혀(90°) 앉았다 일어난다.",
                "10~15회 반복하여 3세트 실시한다."
            ]
        },
        {
            "id": "FitBody/FitBody-Barbell-0012",
            "title": "바벨 대각선 런지(Barbell Diagonal Lunge)",
            "thumb": "/assets/thumbs/FitBody-Barbell-0012.png",
            "guide": [
                "양 손으로 바벨을 잡아 어깨 위에 올리고 선다.",
                "한 쪽 다리를 안쪽 대각선 방향 뒤로 보내 양쪽 무릎을 90°로 굽혀 앉았다 일어난다.",
                "다리를 바꿔가며 10~15회 반복하고 3세트 실시한다."
            ]
        },
    ],

    "foam-roller": [
        {
            "id": "FR/FR-0002",
            "title": "견갑거근 자가근막이완(Levator scapulae Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0002.png",
            "guide": [
                "폼롤러를 베개처럼 베고 눕는다. 목을 오른쪽으로 돌리고 턱을 아래쪽으로 굽힌다.",
                "10초 유지한다. 3회 반복하고 왼쪽도 같은 방법으로 실시한다."
            ]
        },
        {
            "id": "FR/FR-0001",
            "title": "후두하근 자가근막이완-폼롤러(Suboccipital muscle Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0001.png",
            "guide": [
                "베개처럼 폼롤러를 베고 눕는다. 목을 좌우로 회전한다. 좌우 10회 3세트 반복한다."
            ]
        },
        {
            "id": "FR/FR-0003",
            "title": "흉추신전운동-폼롤러(Thoracic extension, foam roller)",
            "thumb": "/assets/thumbs/FR-0003.png",
            "guide": [
                "폼롤러에 등으로 눕고 엉덩이를 든다. 등을 이용해 등 위쪽과 아래쪽으로 폼롤러를 밀면서 등을 편다"
            ]
        },
        {
            "id": "FR/FR-0004",
            "title": "이두근 자가근막이완(Biceps Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0004.png",
            "guide": [
                "바닥에 엎드려 팔을 옆으로 뻗어 상완(팔꿈치 위) 아래에 폼롤러를 둔다. 팔을 좌우로 움직여 상완이두근이 압박이완 되도록 한다. 30초~1분간 실시하고, 3~5세트 반복한다"
            ]
        },
        {
            "id": "FR/FR-0005",
            "title": "삼두근 자가근막이완(Triceps Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0005.png",
            "guide": [
                "옆으로 누워 아래쪽 팔을 손바닥이 위를 향하도록 머리 위로 뻗어 팔꿈치 윗부분에 폼롤러를 둔다. 폼롤러를 위아래로 굴려 삼두근을 압박이완 한다. 30초~1분간 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "FR/FR-0006",
            "title": "삼각근 자가근막이완(Deltoid Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0006.png",
            "guide": [
                "팔을 펴서 어깨 아래에 폼롤러를 두고 옆으로 눕는다. 30초~1분간 폼롤러를 위아래로 굴려 삼각근을 압박한다. 3~5회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "FR/FR-0007",
            "title": "대흉근/소흉근 자가근막이완(Pectoralis Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0007.png",
            "guide": [
                "한 쪽 팔과 가슴 사이에 폼롤러를 두고 엎드려 앞쪽으로 흉근을 압박하면서 폼롤러를 30초~1분 내외로 굴린다. 양쪽 모두 실시하고 3~5회씩 반복한다."
            ]
        },
        {
            "id": "FR/FR-0008",
            "title": "광배근 자가근막이완(Latissimus dorsi Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0008.png",
            "guide": [
                "겨드랑이 사이에 폼롤러를 두고 옆으로 눕는다. 옆쪽으로 광배근을 압박하면서 30초~1분 내외로 폼롤러를 위아래로 굴린다. 3~5회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "FR/FR-0009",
            "title": "전거근 자가근막이완(Serratus anterior Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0009.png",
            "guide": [
                "팔과 옆구리 사이에 폼롤러를 두고 엎드린다. 앞쪽으로 전거근을 압박하면서 30초~1분간 폼롤러를 위아래로 굴린다. 3~5회 반복하고 반대쪽도 실시한다."
            ]
        },
        {
            "id": "FR/FR-0010",
            "title": "고관절 굴곡근 자가근막이완(Hip flexor Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0010.png",
            "guide": [
                "골반 밑(고관절 굴곡근)에 폼롤러를 두고 엎드린다. 다리를 펴서 30초~1분간 폼롤러를 굴려 고관절 굴곡근을 압박이완 한다. 3~5세트 반복한다."
            ]
        },
        {
            "id": "FR/FR-0011",
            "title": "요추신전근 자가근막이완-폼롤러(Lumbar Erector spinae Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0011.png",
            "guide": [
                "폼롤러를 허리에(요추부)에 두고 위 아래로 허리를 압박 이완한다. 30초 5~10회 반복한다"
            ]
        },
        {
            "id": "FR/FR-0012",
            "title": "대퇴근막장근 자가근막이완-폼롤러(TFL Self Myofascial release, foam roller)",
            "thumb": "/assets/thumbs/FR-0012.png",
            "guide": [
                "옆으로 골반 쪽에 폼롤러들 두고 골반 아래 대퇴근막장근을 압박이완 한다. 30초~1분내외 3회반복한다. 양쪽 모두 수행한다"
            ]
        },
        {
            "id": "FR/FR-0013",
            "title": "내복사근 자가근막이완-폼롤러(Internal oblique Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0013.png",
            "guide": [
                "외측복부 아래에 마사지공이나 폼롤러를 두고 1분정도 압박한다. 3회반복한다."
            ]
        },
        {
            "id": "FR/FR-0014",
            "title": "대퇴이두근 자가근막이완-폼롤러(Biceps femoris Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0014.png",
            "guide": [
                "폼롤러 위에 다리를 뻗고 앉아 햄스트링을 압박 이완한다. 1분이상 3회반복."
            ]
        },
        {
            "id": "FR/FR-0015",
            "title": "고관절 내전근 자가근막이완-폼롤러(Hip Adductor Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0015.png",
            "guide": [
                "앞으로 엎드려 폼롤러를 안쪽 내전근에 놓고 체중을 이용하여 압박한다. 30초 3회 반복한다."
            ]
        },
        {
            "id": "FR/FR-0016",
            "title": "중둔근 자가근막이완(Glute medius Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0016.png",
            "guide": [
                "골반 아래 중둔근을 폼롤러를 놓고 앉아 체중을 이용하여 압박한다. 30초 3회 반복한다."
            ]
        },
        {
            "id": "FR/FR-0017",
            "title": "대둔근 자가근막이완(Glute maximus Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0017.png",
            "guide": [
                "한 쪽 대둔근(골반 아래) 밑에 폼롤러를 두고 앉는다. 폼롤러를 앞뒤로 굴려 30초~1분간 대둔근을 압박이완(마사지) 한다. 같은 방법으로 반대쪽도 실시하고, 3~5세트 반복한다"
            ]
        },
        {
            "id": "FR/FR-0018",
            "title": "이상근 자가근막이완(Piriformis Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0018.png",
            "guide": [
                "팔을 뒤로 보내 바닥을 짚고 폼롤러 위에 앉아 한 쪽 다리를 반대쪽 무릎 위에 올린다.",
                "올린 다리의 엉덩이 아래쪽 이상근을 압박하면서 30초~1분 내외로 폼롤러를 굴린다.",
                "3~5회 반복하고 반대쪽도 실시한다"
            ]
        },
        {
            "id": "FR/FR-0019",
            "title": "비복근 자가근막이완-폼롤러(Gastrocnemius Self Myofascial release, foam roller)",
            "thumb": "/assets/thumbs/FR-0019.png",
            "guide": [
                "폼롤러 위에 한발의 종아리를 올리고 다른 다리를 겹쳐 위에 두고 비복근을 압박 이완한다. 30초~1분내외 3회반복한다. 양쪽모두 수행한다."
            ]
        },
        {
            "id": "FR/FR-0020",
            "title": "비골근 자가근막이완-폼롤러(Peroneus Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0020.png",
            "guide": [
                "옆으로 누워 종아리 바깥쪽을 폼롤러에 올리고 종아리 마사지 하 듯이 근육을 압박 이완시킨다. 1분씩 3번반복한다"
            ]
        },
        {
            "id": "FR/FR-0021",
            "title": "전경골근 자가근막이완(Anterior tibialis Self Myofascial Release, foam roller)",
            "thumb": "/assets/thumbs/FR-0021.png",
            "guide": [
                "무릎 아래 정강이뼈(경골)에 폼롤러를 가로로 두고 푸쉬업 자세로 엎드린다. 폼롤러를 위 아래쪽으로 굴려 앞정강이 근육(전경골근)을 압박이완 한다. 30초~1분간 반복하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "FR/FR-0022",
            "title": "삼두근 자가근막이완-작은 폼롤러(Triceps self myofascial release, foam roller)",
            "thumb": "/assets/thumbs/FR-0022.png",
            "guide": [
                "팔을 굽혀 폼롤러를 팔꿈치 위쪽에 두고 앉는다. 체중을 실으면서 폼롤러를 앞뒤로 굴려 삼두근을 압박이완 한다. 30초~1분간 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "FR/FR-0023",
            "title": "수지신근 자가근막이완-폼롤러(Extensor carpi muscle self myofascial release, foam roller)",
            "thumb": "/assets/thumbs/FR-0023.png",
            "guide": [
                "벤치나 테이블에 작은 폼롤러를 두고 양 손 손바닥이 위로 향하게 하여 손등 위쪽부터 팔꿈치까지 폼러러에 압박을 가하여 굴린다. 30초~1분간 실시하게 3세트 반복한다."
            ]
        },
        {
            "id": "FR/FR-0024",
            "title": "슬와근 자가근막이완-폼롤러(Popliteus self myofascial release, foam roller)",
            "thumb": "/assets/thumbs/FR-0024.png",
            "guide": [
                "무릎 뒤쪽 오금 밑에 폼롤러를 가로로 두고 앉는다.",
                "엉덩이를 들어 폼롤러에 체중을 실어 위아래로 30초~1분간 굴려 슬와근을 압박이완(마시지) 한다.",
                "같은 방법으로 반대쪽도 실시하고, 3~5세트 반복한다."
            ]
        },
        {
            "id": "FR/FR-0025",
            "title": "폼롤러 밸런스(Balance, foam roller)",
            "thumb": "/assets/thumbs/FR-0025.png",
            "guide": [
                "폼롤러 위에 서서 무릎을 가볍게 굽히고 10~15초간 균형을 유지한다.(3~5회 반복)"
            ]
        },
        {
            "id": "FR/FR-0026",
            "title": "데드버그 레그리프트(Dead Bug leg lift, foam roller)",
            "thumb": "/assets/thumbs/FR-0026.png",
            "guide": [
                "폼롤러에 등을 대고 바로 눕는다. 양 손을 가슴 쪽에 모으고 한 발을 들고 10~15초간 균형을 유지한다. 발을 바꿔 같은 방법으로 실시한다.",
                "3세트 반복한다."
            ]
        },
        {
            "id": "FR/FR-0027",
            "title": "데드버그 팔 다리 교차운동(Dead Bug alternative arm & leg, foam roller)",
            "thumb": "/assets/thumbs/FR-0027.png",
            "guide": [
                "폼롤러에 등을 대고 바로 눕는다. 두 손을 어깨 높이에서 수직으로 들어 올린다. 한 발을 들고 10~15초간 균형을 유지한다.",
                "발을 바꿔 같은 방법으로 실시한다. 3세트 반복한다."
            ]
        },
        {
            "id": "FR/FR-0028",
            "title": "허리에 폼롤러 두고 네발기기자세 (Bird Dog with foam roller, on back)",
            "thumb": "/assets/thumbs/FR-0028.png",
            "guide": [
                "폼롤러를 허리에 수평으로 놓고 네발기기 자세를 만든다. 뒤로 한 다리를 뻗어 10초간 유지한다. 처음 위치로 돌아와 3번 반복하고 반대쪽도 같은 방법으로 실시한다."
            ]
        },
        {
            "id": "FR/FR-0029",
            "title": "네발기지자세 밸런스(Bird Dog with foam roller arm raise, Quadruped)",
            "thumb": "/assets/thumbs/FR-0029.png",
            "guide": [
                "폼롤러 두개를 바닥에 놓고 앞쪽 폼롤러에는 팔은 어깨에서 수직 아래로 잡고 뒤쪽 폼롤러는 무릎을 90도 굽혀 네발기기 자세로 폼롤러 위에 올라선다. 오른팔을 앞으로 뻗고 왼쪽 다리를 뒤로 뻗어 5초간 유지한다. 처음 위치로 돌아와 3번 반복하고 반대쪽도 같은 방법으로 실시한다"
            ]
        },
        {
            "id": "FR/FR-0030",
            "title": "폼롤러에 누워 스노우 엔젤(Supine Snow Angel, foam roller)",
            "thumb": "/assets/thumbs/FR-0030.png",
            "guide": [
                "일자 형태(세로)로 폼롤러를 놓고 등을 대고 눕는다. 양 팔을 옆으로 외전하여 최대한 머리위로 올린다. 10회 반복 3세트 실시한다."
            ]
        },
        {
            "id": "FR/FR-0031",
            "title": "흉추회전-폼롤러(Trunk rotation-Arm open, foam roller)",
            "thumb": "/assets/thumbs/FR-0031.png",
            "guide": [
                "폼롤러를 베개처럼 베고 옆으로 눕는다. 어깨 높이에서 두 팔을 뻗어 손바닥을 겹쳐 놓는다. 한 쪽 팔을 반대쪽으로 최대한 멀리 보내고 3~5초간 유지한다. 10회 반복하고 반대쪽도 같은 방법으로 실시한다."
            ]
        },
        {
            "id": "FR/FR-0032",
            "title": "몸통회전-어깨 90도 외전 외회전(Trunk Rotation Shoulder 90-90 degree, Foam Roller)",
            "thumb": "/assets/thumbs/FR-0032.png",
            "guide": [
                "폼롤러를 베개처럼 베고 한 쪽 팔을 90도 굽혀 폼롤러 아래쪽에 둔다. 무릎을 90도 굽혀 몸통을 반대쪽으로 회전하여 유지한다. 5초간 유지한다. 처음 위치로 돌아와 3회 반복한다. 반대쪽으로 같은 방법으로 실시한다."
            ]
        },
        {
            "id": "FR/FR-0033",
            "title": "폼롤러 오버헤드 익스텐션(Overhead/Extension, Foam Roller)",
            "thumb": "/assets/thumbs/FR-0033.png",
            "guide": [
                "폼롤러를 수평(가로)으로 두고 등으로 기대어 눕는다. 양 팔을 머리 위로 뻗어 바닥 쪽으로 내리면서 흉추를 신전한다. 10초 유지하고 3회 반복한다."
            ]
        },
    ],

    "tool-etc": [
        {
            "id": "FitBW/FitBW-0001",
            "title": "사이드 푸시업(Side push up)",
            "thumb": "/assets/thumbs/FitBW-0001.png",
            "guide": [
                "가볍게 무릎을 굽히고 옆으로 눕는다.",
                "위쪽 팔을 90°로 굽혀 가슴앞에서 바닥을 짚고 아래쪽 팔로 몸통을 감싼다.",
                "팔꿈치를 펴면서 상체를 일으켜 세운다.",
                "10~15회 반복하고, 반대쪽으로 실시한다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0002",
            "title": "트라이셉 딥스(Triceps dips)",
            "thumb": "/assets/thumbs/FitBW-0002.png",
            "guide": [
                "양 팔을 뒤로 보내 벤치의 가장자리를 손으로 짚고 무릎을 굽힌다.",
                "상완이 바닥과 평행이 될 때까지 팔꿈치를 굽히며 몸을 수직으로 내린다.",
                "팔에 체중을 실어 팔꿈치를 펴면서 몸을 수직으로 들어 올린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0003",
            "title": "Wrist Roller 운동(Wrist roller exercise)",
            "thumb": "/assets/thumbs/FitBW-0003.png",
            "guide": [
                "5kg 이내의 원반에 줄을 묶어 둥근 막대에 고정한다.",
                "양쪽 팔을 가슴앞으로 뻗어 막대끝을 잡고 손목을 이용해 줄을 감아올렸다 풀어내려 3~5회 반복한다.",
                "* 줄길이 :  완전히 풀었을 때 무릎 또는 허벅지 위치",
                "* 원반무게 : 근력에 따라 1~5kg까지"
            ]
        },
        {
            "id": "FitBW/FitBW-0004",
            "title": "새사냥개 운동(Bird dog exercise)",
            "thumb": "/assets/thumbs/FitBW-0004.png",
            "guide": [
                "네 발 기기 자세로 엎드린다.",
                "오른쪽 팔을 귀높이로 뻗어 올리고, 왼쪽 다리를 엉덩이 높이로 뻗어 올려 20초간 유지한다.",
                "손발을 바꿔 실시하고 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0005",
            "title": "싱글레그 브릿지(Singleg Glute bridge)",
            "thumb": "/assets/thumbs/FitBW-0005.png",
            "guide": [
                "등을 대고 누워 무릎을 세운다.",
                "한 쪽 다리를 90°로 들어 올린 후 골반을 들어 올려 어깨부터 무릎까지 사선을 만든다.",
                "(바닥을 지지한 발을 족배굴곡(발등굽힘) 해줌으로 써 강도를 높일 수 있다.)",
                "10~15회 반복 후 다리를 바꿔 실시한다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0013",
            "title": "싱글레그 밸런스 포워드 리치(Single leg balance foward reach)",
            "thumb": "/assets/thumbs/FitBW-0013.png",
            "guide": [
                "한 발로 지지하여 무릎을 굽히면서 반대쪽 다리를 바닥에 가깝게 앞쪽으로 최대한 뻗는다.",
                "10~15회 반복 후 다리를 바꿔 실시한다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "FitBody/FitBody-Barbell-0014",
            "title": "옆으로 누워 바 다리에 올려 내전운동(lying Leg Adduction)",
            "thumb": "/assets/thumbs/FitBody-Barbell-0014.png",
            "guide": [
                "한 쪽 팔꿈치로 바닥을 짚고 옆으로 누워 아래쪽 다리를 펴고 위쪽 다리는 무릎을 굽혀 세운다.",
                "손으로 바(Bar)를 잡아 아래쪽 다리 위에 올려 바(Bar)와 함께 다리를 들어 올린다.(고관절 내전)",
                "10~15회 반복 후 반대쪽으로 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0008",
            "title": "뒤꿈치 들기(Calf Raise)",
            "thumb": "/assets/thumbs/FitBW-0008.png",
            "guide": [
                "다리를 어깨넓이로 벌리고 두 발을 나란히 하여 선다.",
                "체중을 발가락에 실어 뒤꿈치를 들어 올렸다 내린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0009",
            "title": "발목 외회전 후 종아리들기(Calf Raise-External Rotation)",
            "thumb": "/assets/thumbs/FitBW-0009.png",
            "guide": [
                "발을 밖으로 회전시켜(외회전) 선다.",
                "체중을 발가락에 실어 뒤꿈치를 들어 올렸다 내린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0010",
            "title": "발목 내회전 후 종아리들기(Calf Raise-Internal Rotation)",
            "thumb": "/assets/thumbs/FitBW-0010.png",
            "guide": [
                "발을 안으로 회전시켜(내회전) 선다.",
                "체중을 발가락에 실어 뒤꿈치를 들어 올렸다 내린다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0011",
            "title": "한발 종아리 들기(Calf Raise- Single leg)",
            "thumb": "/assets/thumbs/FitBW-0011.png",
            "guide": [
                "한 발로 서서 체중을 발가락에 실으며 뒤꿈치를 들어 올렸다 내린다.",
                "10~15회 반복 후 다리를 바꿔 실시한다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0012",
            "title": "뒤꿈치로 걷기(Heel Walk)",
            "thumb": "/assets/thumbs/FitBW-0012.png",
            "guide": [
                "양 쪽 발목을 족배굴곡(발등 굽힘)하여 뒤꿈치로 선다.",
                "뒤꿈치를 이용하여 앞으로 10보 걸은 후 1분간 쉰다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0014",
            "title": "옆으로 뜀뛰기(Lateral Hop)",
            "thumb": "/assets/thumbs/FitBW-0014.png",
            "guide": [
                "세로중심선을 뛰어 넘듯 한 발로 옆으로 뜀뛰기를 한 후 다리를 바꿔 반대쪽으로 실시한다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0015",
            "title": "한 발 들고 손 바닥에 터치 후 점프(Single leg touch and hop)",
            "thumb": "/assets/thumbs/FitBW-0015.png",
            "guide": [
                "한 발로 점프 후 무릎을 굽혀 앉으면서 반대쪽 팔을 뻗어 바닥을 터치한다.",
                "10~15회 반복 후 손발을 바꿔 실시한다.",
                "2~3세트 반복한다."
            ]
        },
        {
            "id": "FitBW/FitBW-0016",
            "title": "옆으로 사이드 점프(Side skater hop)",
            "thumb": "/assets/thumbs/FitBW-0016.png",
            "guide": [
                "세로중심선을 뛰어 넘듯 한 발로 옆으로 점프하여 무릎을 굽혀 앉으면서 반대쪽 팔을 뻗어 바닥을 터치한다.",
                "같은 방법으로 손발을 바꿔 반대방향으로 실시한다.",
                "10~15회 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0001",
            "title": "싱글레그 밸런스 리치(Single leg balance  reach)",
            "thumb": "/assets/thumbs/FitFunction-0001.png",
            "guide": [
                "한 쪽 다리로 서서 무릎을 굽히면서 반대쪽 다리를 최대한 앞으로 뻗었다 원위치로 돌아온다.",
                "같은 방법으로 다리를 옆으로 45°와 90°로 외전하여 뻗었다 돌아온다.",
                "10회 반복 후 다리를 바꿔 실시하고, 각각 2~3세트씩 반복한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0002",
            "title": "런지 매트릭스(Lunge Matrix(Front, side, back)",
            "thumb": "/assets/thumbs/FitFunction-0002.png",
            "guide": [
                "한 발을 앞으로 보내 무릎을 굽혀 앉았다 일어선다.(프론트 런지)",
                "한 발을 옆으로 뻗어 내고 무릎을 굽혀 앉았다 일어선다.(사이드 런지)",
                "한 발을 뒤로 보내 무릎을 굽혀 앉았다 일어선다.(리버스 런지)",
                "프론트런지 - 사이드런지 - 리버스런지 동작을 연결하여 3~5회 반복하고, 2~3세트 실시한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0004",
            "title": "스타 리치(Star excursion)",
            "thumb": "/assets/thumbs/FitFunction-0004.png",
            "guide": [
                "왼 발로 서서 오른쪽 다리를 앞쪽 바닥으로 최대한 뻗었다 돌아온다.",
                "같은 방법으로 옆쪽 45°, 90°, 135°, 뒤쪽, 다리를 뒤로 교차하여 45°, 90°로 각각 뻗었다 돌아온다.",
                "10회 반복 후 다리를 바꿔 같은 방법으로 실시하고, 2~3세트 반복한다"
            ]
        },
        {
            "id": "FitFunction/FitFunction-0005",
            "title": "런지 트위스트(Lunge Twist)",
            "thumb": "/assets/thumbs/FitFunction-0005.png",
            "guide": [
                "한 발을 충분히 앞으로 보내 무릎을 90°로 굽혀 앉으면서 손을 모아 팔을 가슴앞으로 뻗는다.",
                "몸통과 함께 팔을 앞으로 보낸 다리 방향으로 회전시킨다.",
                "다리를 바꿔가며 10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0006",
            "title": "한발 네방향 뜀뛰기(Single Leg Hop, plus pattern)",
            "thumb": "/assets/thumbs/FitFunction-0006.png",
            "guide": [
                "한 발로 서서 앞, 뒤, 옆, 대각선 방향으로 가볍게 점프(Hop)한다.",
                "10~15회 반복 후 발을 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0010",
            "title": "싱글레그 밸런스 사이드 리치(Single leg balance, side reach)",
            "thumb": "/assets/thumbs/FitFunction-0010.png",
            "guide": [
                "한 발로 서서 무릎을 굽히며 반대쪽 다리를 앞쪽 바닥으로 최대한 뻗었다 돌아온다.",
                "같은 방법으로 다리를 옆쪽 90°, 뒤쪽, 다리를 뒤로 교차하여 옆 90°로 각각 뻗었다 돌아온다.",
                "10회 반복 후 다리를 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0011",
            "title": "3방향 밸런스 콘 터치(3way Balance and reach)",
            "thumb": "/assets/thumbs/FitFunction-0011.png",
            "guide": [
                "콘(Cone)을 앞, 오른쪽, 왼쪽에 두고 한 발로 선다.",
                "지지한 다리의 무릎을 굽히면서 반대쪽 팔을 앞으로 뻗어 손으로 콘을 터치하고 일어선다.",
                "같은 방법으로 오른쪽과 왼쪽의 콘을 각각 터치하고 일어선다.",
                "10~15회 반복 후 손발을 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0012",
            "title": "사이드 런지 콘 리치(Lateral lunge to cone)",
            "thumb": "/assets/thumbs/FitFunction-0012.png",
            "guide": [
                "다리를 넓게 벌리고 서서 양쪽 발 앞에 콘(Cone)을 둔다.",
                "한 쪽 다리를 굽혀 체중을 싣고(사이드 런지) 반대쪽 팔을 뻗어 콘을 터치한 후 돌아온다.",
                "같은 방법으로 팔과 다리를 바꿔 반대쪽으로 실시한다.",
                "10~15회 반복하여 2~3세트 실시한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0013",
            "title": "밸런스 디스크 콘 터치(Balance Disc Exercise with Cone Touch)",
            "thumb": "/assets/thumbs/FitFunction-0013.png",
            "guide": [
                "토구나 밸러스 패드에 두 발로 올라 서서 콘(Cone)을 앞쪽, 오른쪽, 왼쪽에 둔다.",
                "무릎을 굽히면서 한 쪽 팔을 뻗어 앞쪽에 있는 콘을 터치하고 돌아온다.",
                "같은 방법으로 오른쪽, 왼쪽 콘을 각각 터치하고 돌아온다.",
                "10~15회 반복 후 팔을 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0014",
            "title": "싱글레그 디스크 콘 터치(Single leg Balance Disc Exercise with Cone Touch)",
            "thumb": "/assets/thumbs/FitFunction-0014.png",
            "guide": [
                "토구나 밸러스 패드에 한 발로 올라 서서 콘(Cone)을 앞쪽, 오른쪽, 왼쪽에 둔다.",
                "지지한 다리의 무릎을 굽히면서 한 쪽 팔을 뻗어 손으로 앞쪽에 있는 콘을 터치하고 돌아온다.",
                "같은 방법으로 오른쪽, 왼쪽 콘을 각각 터치하고 돌아온다.",
                "10~15회 반복 후 손발을 바꿔 실시하고, 2~3세트 반복한다."
            ]
        },
        {
            "id": "FitFunction/FitFunction-0015",
            "title": "플랭크 리치(Plank reach)",
            "thumb": "/assets/thumbs/FitFunction-0015.png",
            "guide": [
                "푸쉬업(또는 플랭크) 자세로 엎드려 앞쪽, 오른쪽, 왼쪽에 콘(Cone)을 둔다.",
                "몸통을 안정되게 유지한 채 한 쪽 팔을 뻗어 앞쪽에 있는 콘을 터치하고 돌아온다.",
                "같은 방법으로 오른쪽, 왼쪽 콘을 각각 터치하고 돌아와 팔을 바꿔 실시한다.",
                "3~5세트 반복한다."
            ]
        },
        {
            "id": "FitBody/FitBody-Barbell-0013",
            "title": "옆으로 누워 바 다리에 올려 외전운동(lying Leg Abduction)",
            "thumb": "/assets/thumbs/FitBody-Barbell-0013.png",
            "guide": [
                "한 쪽 팔꿈치로 바닥을 짚고 옆으로 누워 안쪽 다리를 굽히고 바깥쪽 다리는 편다.",
                "손으로 바(Bar)를 잡아 위에 있는 다리에 올리고 바(Bar)와 함께 다리를 들어 올린다.(고관절 외전)",
                "10~15회 반복 후 반대쪽으로 실시하고, 3세트 반복한다."
            ]
        },
        {
            "id": "Static/Static-S-0018",
            "title": "목 측굴 저항(Static Neck Side Flexion)",
            "thumb": "/assets/thumbs/Static-S-0018.png",
            "guide": [
                "한 쪽 측두골에 손바닥을 대고 목을 측굴하려는 힘을 쓰고 손으로는 막아 5초간 버틴다.(3~5회 반복) 반대쪽도 실시한다."
            ]
        },
        {
            "id": "MS/MS-Neck-0050",
            "title": "등척성 목 회전저항(Isometric Neck)",
            "thumb": "/assets/thumbs/MS-Neck-0050.png",
            "guide": [
                "한 쪽 측두골에 손바닥을 대고 목을 바깥쪽으로 회전하려는 힘을 쓰고 손으로는 막아 5초간 버틴다.",
                "3~5회 반복하고, 반대쪽도 실시한다."
            ]
        },
        {
            "id": "Static/Static-S-0022",
            "title": "경장근 활성화-누워서 목 굴곡저항(Longus coli activation- Static Neck Flexion, supine)",
            "thumb": "/assets/thumbs/Static-S-0022.png",
            "guide": [
                "벤치에 누워 이마에 손을 댄 후 앞쪽으로 목의 굽히는 힘을 손으로 저항하며 버틴다. 5초간 유지한다. 3~5번 반복한다."
            ]
        },
        {
            "id": "Static/Static-S-0023",
            "title": "후경부근육 활성화-엎드려 신전저항 (Posterior cervical muscle activation-Static Neck Extension, prone)",
            "thumb": "/assets/thumbs/Static-S-0023.png",
            "guide": [
                "벤치에 엎드려 뒷머리에 손을 댄 후 뒤쪽으로 목의 신전시키는 힘을 손으로 저항하며 버틴다. 5초간 유지한다. 3~5번 반복한다."
            ]
        },
    ],
};

export const TITLES = {
    machine: "웨이트 기구 운동",
    "trx": "TRX 운동",
    "dumbbell": "덤벨 운동",
    "medicine-ball": "메디신볼 운동",
    "bosu-ball": "보수볼 운동",
    "stability-ball": "짐볼 운동",
    "cable": "케이블 운동",
    "kettlebell": "케틀벨 운동",
    "band": "밴드 운동",
    "stretch": "스트레치 운동",
    "barbell": "바벨 운동",
    "foam-roller": "폼롤러 운동",
    "tool-etc": "소도구 외",
    "functional": "기능적 운동",
    "straight-neck": "일자목 운동",
    neck: "목 운동",
};


export const CATEGORY_SETS = [
    {
        key: "tool",
        label: "소도구 운동",
        items: [
            { key: "trx", label: "TRX", image: "/workout-icons/trx.png" },
            { key: "dumbbell", label: "덤벨", image: "/workout-icons/dumbbell.png" },
            { key: "medicine-ball", label: "메디신볼", image: "/workout-icons/medicine-ball.png" },
            { key: "bosu-ball", label: "보수볼", image: "/workout-icons/bosu-ball.png" },
            { key: "stability-ball", label: "짐볼", image: "/workout-icons/stability-ball.png" },
            { key: "cable", label: "케이블", image: "/workout-icons/cable.png" },
            { key: "kettlebell", label: "케틀벨", image: "/workout-icons/kettlebell.png" },
            { key: "band", label: "밴드", image: "/workout-icons/band.png" },
            { key: "stretch", label: "스트레치", image: "/workout-icons/stretch.png" },
            { key: "barbell", label: "바벨", image: "/workout-icons/barbell.png" },
            { key: "foam-roller", label: "폼롤러", image: "/workout-icons/foam-roller.png" },
            { key: "tool-etc", label: "소도구 외", image: "/workout-icons/tool-etc.png" },
        ],
    },
    {
        key: "body",
        label: "부위별 운동",
        items: [
            { key: "straight-neck", label: "목", image: "/workout-icons/straight-neck.png" },
            { key: "functional", label: "기능적", image: "/workout-icons/functional.png" },
        ],
    },
];
